window.BO_ASSETS_BASE = "{{ 'duletbio-LED-ACERO.png' | asset_url | split: 'duletbio-LED-ACERO.png' | first }}";
  // Helper universal: resuelve ruta de imagen LED para CF (../images/) o Shopify (CDN)
  // En Shopify, _LED_FILE_URLS es pre-poblado por Liquid en backoffice.liquid antes de este script
  function _ledImgUrl(filename) {
      if (window._LED_FILE_URLS && window._LED_FILE_URLS[filename]) {
          return window._LED_FILE_URLS[filename];
      }
      const base = window.BO_ASSETS_BASE || '';
      if (base && (base.indexOf('cdn.shopify') !== -1 || base.indexOf('myshopify') !== -1)) {
          return base + 'duletbio-' + filename.replace(/_/g, '-');
      }
      return '../images/' + filename;
  }

// ============================================================
//  DASHBOARD MAIN CONTROLLER
// ============================================================
Chart.defaults.color    = '#A1A1AA';
Chart.defaults.font.family = "'Inter', sans-serif";

let CURRENT_USER = null;
window._regNombres = window._regNombres || {};
var _regNombres = window._regNombres;

// Helper global: normaliza 'administrador' → 'admin' para todas las comparaciones de rol
function isAdminOrMaster(user) {
    const rol = ((user || CURRENT_USER)?.rol || '').toLowerCase();
    const rolNorm = rol === 'administrador' ? 'admin' : rol;
    return ['master', 'admin'].includes(rolNorm);
}
let _ADMIN_USER_BACKUP = null;   // respaldo del admin cuando entra modo espejo
let _ADMIN_SESSION_BACKUP = null; // respaldo del sessionStorage bo_user


// ============================================================
//  CATÁLOGO CENTRAL ESTANDARIZADO DE EMPRESAS DULETIA HOLDING
// ============================================================
window.DULETIA_EMPRESAS = [
    { id: 'DI',  short: 'DI',  nombre: 'DI — Dulet Internacional',   razon: 'Dulet Internacional S de RL de CV', icon: '🏭', desc: 'Fábrica / Producción' },
    { id: 'DG',  short: 'DG',  nombre: 'DG — Dulet Grupo',           razon: 'Dulet Grupo SA de CV',              icon: '🏢', desc: 'Comercializadora MX' },
    { id: 'DC',  short: 'DC',  nombre: 'DC — Dig Coaching',          razon: 'Dig Coaching / DC Servicios',       icon: '🎓', desc: 'Coaching y Servicios' },
    { id: 'LLC', short: 'LLC', nombre: 'LLC — Dulet Group LLC',      razon: 'Dulet Group LLC',                   icon: '🇺🇸', desc: 'Operación USA' },
    { id: 'DS',  short: 'DS',  nombre: 'DS — Dulet Suiza',           razon: 'Dulet Suiza Holding',               icon: '🇨🇭', desc: 'Holding / Licencias' },
];

window.getEmpresaInfo = function(empId) {
    if (!empId) return { id: '', short: '—', nombre: 'Todas las Empresas', icon: '🌐' };
    return window.DULETIA_EMPRESAS.find(e => e.id === empId) || { id: empId, short: empId, nombre: empId, icon: '🏢' };
};

window.renderEmpresaBadge = function(empId) {
    const colors = {
        DI:  { bg: 'rgba(99,102,241,.15)', text: '#a5b4fc', border: 'rgba(99,102,241,.3)' },
        DG:  { bg: 'rgba(34,197,94,.12)',  text: '#86efac', border: 'rgba(34,197,94,.25)' },
        DC:  { bg: 'rgba(245,158,11,.12)', text: '#fcd34d', border: 'rgba(245,158,11,.25)' },
        LLC: { bg: 'rgba(59,130,246,.15)', text: '#93c5fd', border: 'rgba(59,130,246,.3)' },
        DS:  { bg: 'rgba(239,68,68,.12)',  text: '#fca5a5', border: 'rgba(239,68,68,.25)' }
    };
    const c = colors[empId] || { bg: 'rgba(255,255,255,.08)', text: '#cbd5e1', border: 'rgba(255,255,255,.15)' };
    const emp = window.getEmpresaInfo(empId);
    return `<span style="display:inline-flex;align-items:center;gap:4px;padding:2px 8px;border-radius:6px;font-size:.74rem;background:${c.bg};color:${c.text};border:1px solid ${c.border};font-weight:600;">${emp.icon} ${emp.short}</span>`;
};

// --- INIT ---
function initMesFiltro() {
    const el = document.getElementById('mesFiltro');
    if (!el) return;
    const isMaster = isAdminOrMaster();
    const mesesAMostrar = isMaster ? 24 : 3;
    let html = '';
    const now = new Date();
    const nombresMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    
    for (let i = 0; i < mesesAMostrar; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const nombre = nombresMeses[d.getMonth()] + ' ' + yyyy;
        html += '<option value="' + yyyy + '-' + mm + '">' + nombre + '</option>';
    }
    el.innerHTML = html;
}
// --- loadLiders (legacy stub — la carga real ocurre en preCargaLideres/loadLideresDirTable) ---
async function loadLiders() {
    // Stub: esta función existía en versiones anteriores del dashboard.
    // La funcionalidad fue absorbida por preCargaLideres() y loadLideresDirTable().
    // Se mantiene como no-op para evitar ReferenceError en window.onload.
    console.log('[loadLiders] stub — datos se cargan vía preCargaLideres');
}

window.onload = async () => {
    // Demo mode: bypass auth, inyectar usuario y datos mock
    if (window.DEMO_MODE && window.activateDemoMode) {
        window.activateDemoMode();
    }
    if (!BO_AUTH.requireAuth()) return;

    CURRENT_USER = BO_AUTH.getUser();
    // ── Modo Prospecto / Demo ──
    if (CURRENT_USER?.rol === 'prospecto' || CURRENT_USER?.estatus === 'nuevo') {
        setTimeout(activarModoProspecto, 400);
    }
    initTopbar();
    buildSidebar();
    initMesFiltro();
    
    // ── Cargar configuración del sistema desde BD (antes de cualquier cálculo) ──
    await initSistemaConfig();
    await loadSystemConfig();

    const navItems = BO_AUTH.getNavItems(CURRENT_USER.rol);
    let initialView = navItems.length > 0 ? navItems[0].id : 'dashboard';
    if (['admin', 'administrador'].includes((CURRENT_USER.rol || '').toLowerCase())) initialView = 'ventas';
    showView(initialView);
    loadStats();
    loadLiders();
    preCargaLideres();
    initNotifBadge();
    aplicarRestriccionesRol();
    initPremiosTabla(); // garantizar que la tabla premios_especiales existe en BD
};

// Garantizar existencia y tipos correctos de la tabla premios_especiales
async function initPremiosTabla() {
    try {
        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `DO $$
BEGIN
  -- Crear tabla si no existe (con las columnas que n8n espera)
  CREATE TABLE IF NOT EXISTS premios_especiales (
    id              SERIAL PRIMARY KEY,
    user_id         TEXT,
    lider_id        TEXT,
    nombre          VARCHAR(200),
    categoria       VARCHAR(200),
    descripcion     TEXT,
    icono           VARCHAR(20) DEFAULT '🏆',
    asignado_por    TEXT,
    fecha           TIMESTAMPTZ DEFAULT NOW(),
    fecha_asignacion TIMESTAMPTZ DEFAULT NOW()
  );

  -- Si la tabla ya existe pero le faltan columnas que n8n necesita, agregar
  IF NOT EXISTS (SELECT 1 FROM information_schema.columns WHERE table_name='premios_especiales' AND column_name='lider_id') THEN
    ALTER TABLE premios_especiales ADD COLUMN lider_id TEXT;
  END IF;
  IF NOT EXISTS (SELECT 1 FROM information_schema.columns WHERE table_name='premios_especiales' AND column_name='categoria') THEN
    ALTER TABLE premios_especiales ADD COLUMN categoria VARCHAR(200);
  END IF;
  IF NOT EXISTS (SELECT 1 FROM information_schema.columns WHERE table_name='premios_especiales' AND column_name='fecha_asignacion') THEN
    ALTER TABLE premios_especiales ADD COLUMN fecha_asignacion TIMESTAMPTZ DEFAULT NOW();
  END IF;
END $$;`
        });
        console.log('✅ initPremiosTabla: tabla OK con lider_id + user_id');
    } catch(e) { console.warn('initPremiosTabla error:', e.message); }
}

// Precarga global de LIDERES_DATA para search dropdown y patrocinador lookup
async function preCargaLideres() {
    try {
        const data = await BO_API.listUsers({});
        if (data && data.length) { window.LIDERES_DATA = data; LIDERES_DATA = data; }
        else if (!window.LIDERES_DATA || !window.LIDERES_DATA.length) { window.LIDERES_DATA = BO_API.MOCK.usuarios; LIDERES_DATA = BO_API.MOCK.usuarios; }
    } catch {
        if (!window.LIDERES_DATA || !window.LIDERES_DATA.length) { window.LIDERES_DATA = BO_API.MOCK.usuarios; LIDERES_DATA = BO_API.MOCK.usuarios; }
    }
}

// --- Topbar ---
function initTopbar() {
    const u = CURRENT_USER;
    const fullName = [u.nombre, u.apellido].filter(Boolean).join(' ').trim();
    const parts = fullName.split(/\s+/).filter(Boolean);
    const initials = ((parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
    document.getElementById('avatarInitials').textContent = initials || 'U';
    document.getElementById('avatarName').textContent     = fullName;
    document.getElementById('avatarRole').textContent     = BO_AUTH.rolLabel(u.rol);
    if (typeof verificarEstado2FA === 'function') verificarEstado2FA();
}

// --- Sidebar dinámico por rol ---
function buildSidebar() {
    const nav = document.getElementById('sideNav');
    const items = BO_AUTH.getNavItems(CURRENT_USER.rol);

    // Ocultar buscador global en tiempo real si el rol activo (incluso en Espejo) no es admin/master
    const searchBar = document.querySelector('.topbar-search');
    if (searchBar) {
        if (!isAdminOrMaster()) searchBar.style.display = 'none';
        else searchBar.style.display = '';
    }

    // --- Validaciones Fase 4 ---
    // Normalizar rol para comparaciones locales ('administrador' → 'admin')
    const rolNormalizado = (CURRENT_USER?.rol || '').toLowerCase() === 'administrador' ? 'admin' : (CURRENT_USER?.rol || '').toLowerCase();

    // 1. Bitácora solo para Platina+ y Academia
    const currentUserGalardon = (CURRENT_USER?.galardon || '').toLowerCase();
    const esGalardonAlto = ['plata', 'oro', 'platino', 'diamante', 'corona', 'vicepresidente'].includes(currentUserGalardon);
    const esAcademia = ['master', 'admin'].includes(rolNormalizado);
    if (!esGalardonAlto && !esAcademia) {
        const bitIdx = items.findIndex(i => i.id === 'bitacora');
        if (bitIdx > -1) items.splice(bitIdx, 1);
    }
    // 2. Acelerador condicional (Se oculta por defecto si no es admin, se mostrará si la API confirma que sí tiene proyecto)
    const isAdminVirtual = ['master', 'admin'].includes(rolNormalizado);

    const sections = {
        main:    items.filter(i => ['dashboard', 'dashboard-lider', 'mi-perfil', 'lideres', 'arbol', 'activos'].includes(i.id)),
        ops:     items.filter(i => ['ventas','centros-apoyo','productos','calendario','auditoria-notas'].includes(i.id)),
        di:      items.filter(i => ['inventario','produccion','proveedores'].includes(i.id)),
        conta:   items.filter(i => ['costos','intercompania','conciliacion'].includes(i.id)),
        retener: items.filter(i => ['academia','premios','academia-admin','rescate','analisis-lider','acelerador','bitacora'].includes(i.id)),
        admin:   items.filter(i => ['facturacion','facturacion-usa','config','noticias'].includes(i.id)),
    };

    const renderSection = (label, list) => {
        if (!list.length) return '';
        
        const sectionId = label.replace(/\s+/g, '-').toLowerCase();
        // Operaciones, Coaching, Sistema, DI y Contabilidad arrancan cerrados por defecto para ahorrar espacio visual
        const startClosed = ['Operaciones', 'Coaching', 'Sistema', 'DI — Producción', 'Contabilidad'].includes(label);
        const sectionStyle = startClosed ? 'display:none;' : '';
        const iconStyle = startClosed ? 'transform: rotate(-90deg); transition: transform 0.2s;' : 'transition: transform 0.2s;';
        
        return `<div class="sidebar-section">
            <div class="sidebar-label" style="display:flex; justify-content:space-between; align-items:center; cursor:pointer;" onclick="var el=document.getElementById('grp-${sectionId}'); var ic=document.getElementById('icn-${sectionId}'); if(el.style.display==='none'){el.style.display='block';ic.style.transform='rotate(0deg)';}else{el.style.display='none';ic.style.transform='rotate(-90deg)';}">
                <span style="display:flex;align-items:center;gap:.3rem;">${sectionIcons[label] || ''}<span>${label}</span></span>
                <span id="icn-${sectionId}" style="${iconStyle};font-size:.65rem;flex-shrink:0;">▼</span>
            </div>
            <div id="grp-${sectionId}" style="${sectionStyle}">
            ${list.map(item => `
                <div class="nav-item" id="nav-${item.id}" onclick="showView('${item.id}')" ${!isAdminVirtual && item.id === 'acelerador' ? 'style="display:none;"' : ''}>
                    <span style="font-size:1rem;">${item.icon}</span>
                    <span>${item.label}</span>
                </div>
            `).join('')}
            </div>
        </div>`;
    };

    const sectionIcons = { 'Principal':'◈ ', 'Operaciones':'⚡ ', 'DI — Producción':'🏭 ', 'Contabilidad':'⚖️ ', 'Coaching':'🎯 ', 'Sistema':'⚙ ' };

    nav.innerHTML =
        renderSection('Principal', sections.main) +
        renderSection('Operaciones', sections.ops) +
        renderSection('DI — Producción', sections.di) +
        renderSection('Contabilidad', sections.conta) +
        renderSection('Coaching', sections.retener) +
        renderSection('Sistema', sections.admin);

    if (!isAdminVirtual) {
        BO_API.getAcelerador(CURRENT_USER.registro).then(res => {
            if (res.hasProject) {
                const navAcel = document.getElementById('nav-acelerador');
                if (navAcel) navAcel.style.display = 'flex';
            }
        }).catch(e => console.warn('Error verificando acelerador para sidebar:', e));
    }

    // Vista de Espejo para master y admin
    if (BO_AUTH.hasRole('admin')) {
        document.getElementById('mirrorSection').style.display = 'block';
    } else {
        document.getElementById('mirrorSection').style.display = 'none';
    }

    document.getElementById('app').style.display = 'grid';
}

let _arbolLoaded = false;
function _initArbolView() {
    const r = ((CURRENT_USER?.rol || '').toLowerCase() === 'administrador') ? 'admin' : (CURRENT_USER?.rol || '').toLowerCase();
    const isAdmin = ['admin', 'master', 'cedis'].includes(r);
    const searchInput = document.getElementById('treeRootId');
    if (searchInput) {
        searchInput.style.display = isAdmin ? 'inline-block' : 'none';
        if (!isAdmin) {
            // Solo forzar el ID propio si el campo está vacío o en '1' (evitar romper el drill-down al dar click a un hijo)
            if (!searchInput.value || searchInput.value === '1') {
                searchInput.value = CURRENT_USER?.registro || CURRENT_USER?.id || '';
            }
        }
    }
    if (!_arbolLoaded) {
        _arbolLoaded = true;
        loadArbolView('lista');
    }
}

// --- Navigation ---
function showView(viewId) {
    let actualViewId = viewId;
    let targetInvTab = null;
    if (viewId === 'reportes-inventario') {
        actualViewId = 'inventario';
        targetInvTab = 'cedula';
    } else if (viewId === 'inventario') {
        targetInvTab = 'stock';
    }

    document.querySelectorAll('.view').forEach(v => v.style.display = 'none');
    document.querySelectorAll('.nav-item').forEach(n => n.classList.remove('active'));
    const view = document.getElementById(`view-${actualViewId}`);
    if (view) view.style.display = 'block';
    const navItem = document.getElementById(`nav-${viewId}`) || document.getElementById(`nav-${actualViewId}`);
    if (navItem) navItem.classList.add('active');

    // Sincronizar Bottom Navigation Bar en móvil
    document.querySelectorAll('.bnav-item').forEach(b => {
        b.classList.toggle('active', b.getAttribute('data-view') === actualViewId || b.getAttribute('data-view') === viewId);
    });

    // Auto-scroll a la parte superior y cerrar menú móvil si estaba abierto
    window.scrollTo({ top: 0, behavior: 'instant' });
    const mc = document.querySelector('.main-content');
    if (mc) mc.scrollTop = 0;
    const sb = document.getElementById('sidebar');
    const ov = document.getElementById('mobileOverlay');
    if (sb && sb.classList.contains('open')) {
        sb.classList.remove('open');
        if (ov) ov.classList.remove('open');
        document.body.style.overflow = '';
    }

    // Cambiar sub-tab en el workspace unificado si aplica
    if (targetInvTab && typeof switchInvWorkspaceTab === 'function') {
        switchInvWorkspaceTab(targetInvTab);
    }

    // Lazy load por vista
    if (viewId === 'activos')               loadActivos();
    if (viewId === 'arbol')                 _initArbolView();
    if (viewId === 'lideres')               loadLideresDirTable();
    if (viewId === 'ventas')               loadVentasHistorial();
    if (viewId === 'productos')             loadProductos();
    if (viewId === 'auditoria-notas')       { if (typeof initAuditoriaNotas === 'function') initAuditoriaNotas(); }
    if (viewId === 'inventario')            { loadInventario(); if (typeof _showInventarioControles === 'function') _showInventarioControles(); }
    if (viewId === 'reportes-inventario')   { if (typeof initReportesInventario === 'function') initReportesInventario(); }
    if (viewId === 'produccion')            { initProduccionView(); }
    if (viewId === 'costos') {
        const r = (CURRENT_USER?.rol || '').toLowerCase().replace(/ /g, '_').trim();
        const normRol = r === 'administrador' ? 'admin' : r;
        if (normRol === 'admin' || !['master', 'supervisor_almacen', 'contabilidad'].includes(normRol)) {
            if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
                BO_AUTH.showAlert('Acceso denegado: no tienes permisos para ver Costos y Finanzas.', 'error');
            }
            showView('ventas');
            return;
        }
        initCostosView();
    }
    if (viewId === 'premios')               { loadPremios(); loadPremiosEspeciales(''); }
    if (viewId === 'rescate')               loadRescate();
    if (viewId === 'analisis-lider')        initAnalisisLider();
    if (viewId === 'facturacion')           { iniciarCuentaRegresiva(); initFacturacionView(); }
    if (viewId === 'config')               setTimeout(initConfigPanel, 50);
    if (viewId === 'dashboard-lider')       loadDashboardLider();
    if (viewId === 'mi-perfil')             loadMiPerfil();
    if (viewId === 'academia')             setTimeout(renderAcademia, 50);
    if (viewId === 'academia-admin')        setTimeout(loadAcademiaAdmin, 50);
    if (viewId === 'calendario')            {
        const _fnCal = (typeof _initCalendarioCorporativo === 'function') ? _initCalendarioCorporativo : window._initCalendarioCorporativo;
        if (typeof _fnCal === 'function') setTimeout(_fnCal, 50);
    }
    if (viewId === 'acelerador')            loadAcelerador();
    if (viewId === 'bitacora')              loadBitacora();
    if (viewId === 'centros-apoyo')         { if(typeof loadCentrosApoyo==='function') loadCentrosApoyo(); }
    if (viewId === 'proveedores')           { if(typeof loadProveedores==='function') loadProveedores(); }
    if (viewId === 'intercompania')         { if(typeof loadIntercompania==='function') {
        // Defaults de fecha al mes actual
        const hoy = new Date().toISOString().slice(0,10);
        const ic1 = document.getElementById('ic-desde');
        const ic2 = document.getElementById('ic-hasta');
        if (ic1 && !ic1.value) ic1.value = hoy.slice(0,7) + '-01';
        if (ic2 && !ic2.value) ic2.value = hoy;
        loadIntercompania();
    }}
    if (viewId === 'conciliacion')          { if (typeof initConciliacionSuite === 'function') initConciliacionSuite(); }
    if (viewId === 'facturacion-usa')      { if (typeof initFacturacionUsaView === 'function') initFacturacionUsaView(); }
}

// --- MI PERFIL ---
async function loadMiPerfil() {
    const u = CURRENT_USER;
    if (!u || !u.id) return;

    try {
        document.getElementById('mp-nombre').textContent = 'Cargando...';
        
        // Obtener datos frescos y extendidos de PostgreSQL
        const res = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT c.registro, c.nombre, c.ape_p, c.ape_m, c.email, c.whatsapp, c.tel, c.lada, 
                         c.created_at,
                         c.calle, c.numero, c.colonia, c.delegacion, c.cp, 
                         p.pais AS pais_nombre,
                         patro.registro AS patro_id, patro.nombre AS patro_nombre, patro.ape_p AS patro_ape_p, patro.ape_m AS patro_ape_m
                  FROM cliente c
                  LEFT JOIN cliente patro ON c.patrocinador = patro.id
                  LEFT JOIN pais p ON c.pais_id::text = p.id
                  WHERE c.id = '${u.id}' LIMIT 1`
        });

        if (res.rows && res.rows.length > 0) {
            const dbU = res.rows[0];

            // Datos Personales
            document.getElementById('mp-nombre').textContent = `${dbU.nombre||''} ${dbU.ape_p||''} ${dbU.ape_m||''}`.replace(/\s+/g, ' ').trim();
            document.getElementById('mp-registro').textContent = dbU.registro || 'N/A';
            document.getElementById('mp-email').textContent = dbU.email || 'No registrado';
            
            // Teléfono + Lada
            const ladaStr = dbU.lada ? `+${String(dbU.lada).replace(/^\+/, '')} ` : '';
            const phoneStr = dbU.whatsapp || dbU.tel || 'No registrado';
            document.getElementById('mp-tel').textContent = phoneStr !== 'No registrado' ? (ladaStr + phoneStr) : phoneStr;
            
            // Fecha Inscripción
            const createdAt = dbU.created_at || null;
            document.getElementById('mp-fecha').textContent = createdAt ? createdAt.split('T')[0] : 'N/A';

            // Dirección Completa
            const dirs = [dbU.calle, dbU.numero, dbU.colonia, dbU.delegacion, dbU.cp, dbU.pais_nombre]
                         .filter(x => x && String(x).trim() !== '').join(', ');
            document.getElementById('mp-dir').textContent = dirs.length > 0 ? dirs : 'Sin dirección registrada';

            // Patrocinador
            if(dbU.patro_id) {
                document.getElementById('mp-patrocinador').textContent = `#${dbU.patro_id} - ${dbU.patro_nombre||''} ${dbU.patro_ape_p||''} ${dbU.patro_ape_m||''}`.replace(/\s+/g, ' ').trim();
            } else {
                document.getElementById('mp-patrocinador').textContent = 'Raíz (Sin patrocinador)';
            }
        }
    } catch(err) {
        console.error('Error cargando perfil:', err);
    }
}

async function actualizarMiPassword(btn) {
    const val = document.getElementById('mp-password').value.trim();
    if (!val || val.length < 4) return BO_AUTH.showAlert('La contraseña es demasiado corta', 'warning');

    btn.disabled = true;
    btn.textContent = 'Actualizando...';

    // Escapar comillas para evitar inyección SQL básica
    const safePass = val.replace(/'/g, "''");

    try {
        // Usar registro para resolver WHERE de forma robusta (CURRENT_USER.id puede ser registro numérico)
        const whereClause = String(CURRENT_USER.id || '').includes('-')
            ? `id = '${CURRENT_USER.id}'`
            : `registro = ${parseInt(CURRENT_USER.id) || parseInt(CURRENT_USER.registro)}`;

        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `UPDATE cliente SET password = crypt('${safePass}', gen_salt('bf')) WHERE ${whereClause}`
        });
        BO_AUTH.showAlert('Contraseña actualizada con éxito', 'success');
        document.getElementById('mp-password').value = '';
    } catch(e) {
        console.error(e);
        BO_AUTH.showAlert('Error al actualizar contraseña.', 'danger');
    } finally {
        btn.disabled = false;
        btn.textContent = 'Actualizar Contraseña';
    }
}

// --- LOAD STATS ---
async function loadDashboardLider() {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    if (!user) return;

    const sf = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };

    // Construir la Medalla Central
    const imgMap = {
        'acero': 'LED_ACERO.png',
        'bronce': 'LED_BRONCE.png',
        'plata': 'LED_PLATA.png',
        'oro': 'LED_ORO.png',
        'platino': 'LED_PLATINO.png',
        'perla negra': 'LED_PERLA_NEGRA.png',
        'diamante': 'LED_DIAMANTE.png'
    };
    let g = (user.galardon || '').toLowerCase();
    const tieneGalardon = !!imgMap[g];
    if (!tieneGalardon) g = 'acero';
    
    document.getElementById('liderGalardonImg').src = _ledImgUrl(imgMap[g]);
    document.getElementById('liderGalardonText').textContent = `LED ${g.toUpperCase()}`;
    
    // Texto motivacional según si tiene o no galardón
    const progresoEl = document.getElementById('liderGalardonProgreso');
    if (progresoEl) {
        progresoEl.textContent = tieneGalardon
            ? 'Sigue construyendo tu cadena para alcanzar el siguiente nivel.'
            : 'Este puede ser tu siguiente galardón, impulsa tu cadena con Evolution Link.';
    }

    // Obtener KPI con recursividad SQL (CTEs)
    try {
        const stats = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `WITH RECURSIVE downline AS (
                    SELECT id, registro, active_id, 1 AS nivel FROM cliente WHERE patrocinador = '${user.id}'
                    UNION ALL
                    SELECT c.id, c.registro, c.active_id, d.nivel + 1 FROM cliente c JOIN downline d ON c.patrocinador = d.id::text WHERE d.nivel < 4
                  )
                  SELECT 
                    (SELECT COUNT(*) FROM downline WHERE active_id = 1) as activos,
                    (SELECT COUNT(*) FROM downline WHERE active_id = 0) as inactivos,
                    (SELECT COALESCE(SUM(COALESCE((SELECT SUM(CASE WHEN COALESCE(pr.categoria,pr2.categoria)='paquete' AND EXISTS(SELECT 1 FROM producto_componente pc2 WHERE pc2.paquete_id=COALESCE(pr.id,pr2.id)) THEN COALESCE((SELECT SUM(CASE WHEN comp_p.comisiona=true THEN COALESCE(comp_p.puntos_equivalencia,1)*pc.cantidad*(pz.value->>'cantidad')::int ELSE 0 END) FROM producto_componente pc JOIN productos comp_p ON comp_p.id=pc.componente_id WHERE pc.paquete_id=COALESCE(pr.id,pr2.id)),0) WHEN COALESCE(pr.comisiona,pr2.comisiona)=true THEN COALESCE(COALESCE(pr.puntos_equivalencia,pr2.puntos_equivalencia),1)*(pz.value->>'cantidad')::int ELSE 0 END) FROM jsonb_array_elements(v.piezas::jsonb) pz(value) LEFT JOIN productos pr ON pr.id=(pz.value->>'producto_id')::int LEFT JOIN productos pr2 ON pr.id IS NULL AND pr2.sku=(pz.value->>'sku') AND pr2.activo=true)/24.0, v.cantidad)), 0) FROM venta v JOIN downline d ON v.cliente_id = d.id WHERE v.fecha_venta >= date_trunc('month', current_date)) as cajas_mes`
        });
        if (stats && stats.rows && stats.rows.length) {
            sf('liderActivos', stats.rows[0].activos);
            sf('liderInactivos', stats.rows[0].inactivos);
            sf('liderVolumen', stats.rows[0].cajas_mes);

            // Calcular Termómetro / Radar de Galardón LED
            try {
                const vol = Number(stats.rows[0].cajas_mes || 0);
                const LED_TIERS = [
                    { key: 'acero',       name: 'Acero',       min: 30 },
                    { key: 'bronce',      name: 'Bronce',      min: 50 },
                    { key: 'plata',       name: 'Plata',       min: 100 },
                    { key: 'platino',     name: 'Platino',     min: 500 },
                    { key: 'oro',         name: 'Oro',         min: 750 },
                    { key: 'perla',       name: 'Perla Negra', min: 1000 },
                    { key: 'diamante',    name: 'Diamante',    min: 2000 }
                ];

                // Determinar el rango actual conquistado del usuario
                const curGalRaw = (user.galardon || window.ACTIVOS_GALARDON || '').toLowerCase().trim();
                const curIdx = LED_TIERS.findIndex(t => t.key === curGalRaw || t.name.toLowerCase() === curGalRaw);

                let nextTier = null;
                if (curIdx >= 0) {
                    // Si ya ostenta un galardón, la meta siempre es el nivel superior inmediato
                    if (curIdx < LED_TIERS.length - 1) {
                        nextTier = LED_TIERS[curIdx + 1];
                    } else {
                        nextTier = LED_TIERS[LED_TIERS.length - 1]; // Rango máximo (Diamante)
                    }
                } else {
                    // Si aún no tiene galardón oficial, busca el primer nivel a desbloquear
                    nextTier = LED_TIERS.find(t => t.min > vol) || LED_TIERS[0];
                }

                const pct = Math.min(100, Math.max(0, Math.round((vol / nextTier.min) * 100)));

                const elPorc = document.getElementById('liderLedPorcentaje');
                const elFill = document.getElementById('liderLedProgressFill');
                const elCajasAct = document.getElementById('liderLedCajasActuales');
                const elCajasMeta = document.getElementById('liderLedCajasMeta');

                if (elPorc) elPorc.textContent = `${pct}%`;
                if (elFill) elFill.style.width = `${pct}%`;
                if (elCajasAct) elCajasAct.textContent = `${vol.toFixed(1)} Cajas de Cadena`;
                if (elCajasMeta) {
                    if (curIdx === LED_TIERS.length - 1 && vol >= nextTier.min) {
                        elCajasMeta.textContent = `¡Rango Máximo Alcanzado (LED DIAMANTE)!`;
                    } else {
                        elCajasMeta.textContent = `Meta: ${nextTier.min} Cajas (LED ${nextTier.name.toUpperCase()})`;
                    }
                }
            } catch(e) {
                console.warn('Error termómetro LED:', e);
            }
        }
    } catch(e) { console.warn('KPI Líder error:', e); }

    // Verificar calificación personal del mes en curso
    try {
        const userId = user.id || '';
        const userReg = user.registro || '';
        const regFilter = userReg ? `(cliente_id = '${userId}' OR cliente_id = '${userReg}' OR cliente_id = (SELECT id::text FROM cliente WHERE registro = ${Number(userReg)} LIMIT 1))` : `cliente_id = '${userId}'`;
        
        const qCal = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT COALESCE(SUM(cantidad), 0) as cajas_propias
                  FROM venta
                  WHERE ${regFilter}
                    AND approved = 1
                    AND fecha_venta >= date_trunc('month', current_date)`
        });
        const cajasPropias = Number(qCal?.rows?.[0]?.cajas_propias || 0);
        const semCard = document.getElementById('liderSemaforoCard');
        const semIcon = document.getElementById('liderSemaforoIcon');
        const semBadge = document.getElementById('liderSemaforoBadge');
        const semCajas = document.getElementById('liderSemaforoCajas');
        const semTexto = document.getElementById('liderSemaforoTexto');
        const semBtn = document.getElementById('liderBtnCalificar');

        if (cajasPropias >= 1) {
            if (semCard) {
                semCard.style.background = 'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(15,23,42,0.6))';
                semCard.style.borderColor = 'rgba(34,197,94,0.25)';
            }
            if (semIcon) semIcon.textContent = '🟢';
            if (semBadge) {
                semBadge.textContent = 'CALIFICADO (MES EN CURSO)';
                semBadge.style.color = '#4ade80';
                semBadge.style.background = 'rgba(34,197,94,0.18)';
                semBadge.style.borderColor = 'rgba(34,197,94,0.3)';
            }
            if (semCajas) semCajas.textContent = `${cajasPropias} Caja(s) acreditada(s)`;
            if (semTexto) semTexto.textContent = 'Tu posición está activa. Los activos generados por tu cadena están 100% protegidos y listos para cobro o uso en pedidos.';
            if (semBtn) semBtn.innerHTML = '<span>📦</span> Surtir Más Producto';
        } else {
            if (semCard) {
                semCard.style.background = 'linear-gradient(135deg, rgba(245,158,11,0.08), rgba(15,23,42,0.6))';
                semCard.style.borderColor = 'rgba(245,158,11,0.3)';
            }
            if (semIcon) semIcon.textContent = '🟡';
            if (semBadge) {
                semBadge.textContent = 'PENDIENTE DE CALIFICAR';
                semBadge.style.color = '#f59e0b';
                semBadge.style.background = 'rgba(245,158,11,0.18)';
                semBadge.style.borderColor = 'rgba(245,158,11,0.3)';
            }
            if (semCajas) semCajas.textContent = '0 Cajas registradas este mes';
            if (semTexto) semTexto.textContent = 'Aún no registras tu caja de este ciclo. Levanta tu pedido hoy mismo para calificar y asegurar la dispersión de activos de tu cadena.';
            if (semBtn) semBtn.innerHTML = '<span>📦</span> Calificar Mi Caja';
        }
    } catch(e) {
        console.warn('Error semáforo calificación:', e);
    }

    // Rellenar Premios Históricos — filtrar por user_id del usuario actual
    try {
        const pTable = document.getElementById('liderPremiosTable');
        const userId = user.id || '';
        const r = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT id, user_id, nombre, descripcion, icono, fecha 
                  FROM premios_especiales 
                  WHERE user_id = '${userId}'
                  ORDER BY fecha DESC NULLS LAST`
        });
        let rows = r?.rows || [];
        
        if (rows && rows.length) {
            pTable.innerHTML = rows.map(p => `<tr>
                <td style="white-space:nowrap">${p.fecha ? new Date(p.fecha).toISOString().split('T')[0] : 'Hoy'}</td>
                <td><span class="badge" style="background:var(--card-bg);border:1px solid var(--border-light);font-size:1.1rem;padding:.2rem .5rem">${p.icono || '🏆'}</span></td>
                <td><div style="font-weight:600">${p.nombre || 'Premio'}</div>${p.descripcion ? `<div style="font-size:0.8rem;color:var(--text-dim)">${p.descripcion}</div>` : ''}</td>
            </tr>`).join('');
        } else {
            pTable.innerHTML = `<tr><td colspan="3" style="text-align:center;color:var(--text-dim);padding:2rem;">La bóveda de galardones e incentivos para tu número de registro está vacía actualmente.</td></tr>`;
        }
    } catch(e) {
        document.getElementById('liderPremiosTable').innerHTML = `<tr><td colspan="3" style="text-align:center;color:var(--text-dim);padding:2rem;">Tu estado de galardones no pudo ser localizado.</td></tr>`;
    }
}

// ============================================================
// ASISTENTE DE PEDIDOS DEL LÍDER (VENTAS / MOSTRADOR MULTI-PRODUCTO)
// ============================================================
let _pedLiderCatalogo = [];
let _pedLiderLineas = []; // [{ prodId, cant }]

// Función inteligente para limpiar nombres técnicos ("Dist", "Pub", "MC") y dejarlos limpios y profesionales
function _pedLiderLimpiarNombre(nombre) {
    if (!nombre) return '';
    return nombre
        .replace(/\bDist\b/gi, '')
        .replace(/\bPub\b/gi, '')
        .replace(/\bMC\b/gi, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
}

// Detección automática del país del líder (USA, GTQ, MEX)
function _pedLiderDetectarPais(user) {
    if (!user) return 'MEX';
    const p = (user.pais || user.pais_id || '').toUpperCase().trim();
    const m = (user.moneda || '').toUpperCase().trim();
    const est = (user.estado || '').toLowerCase().trim();
    const cNombre = (user.cedis_nombre || '').toLowerCase().trim();
    const cId = parseInt(user.cedis_id || 0);

    if (p === 'USA' || p === 'EE.UU.' || p === 'US' || p === 'ESTADOS UNIDOS' || m === 'USD' || cId === 4 || cNombre.includes('usa') || cNombre.includes('llc') || est.includes('texas') || est.includes('california')) {
        return 'USA';
    }
    if (p === 'GTQ' || p === 'GUA' || p === 'GUATEMALA' || m === 'GTQ') {
        return 'GTQ';
    }
    return 'MEX';
}

// Catálogo base verificado de Línea Oficial y Artículos Promocionales (sin "Dist")
const _PED_LIDER_CAT_BASE = [
    // 📦 Cajas completas oficiales (Calificación de socio)
    { id: 32, sku: 'PAQUETE-MNJGPXX9-6T6', nombre: 'Caja Dulet Natural (24 pzas)', mx: 4500, eu: 300, gua: 2000, esCaja: true, emoji: '📦' },
    { id: 'caja_chocolate', sku: 'SUERO-CAJA24-CHOCOLATE', nombre: 'Caja Dulet Chocolate (24 pzas)', mx: 4500, eu: 300, gua: 2000, esCaja: true, emoji: '🍫' },
    { id: 'caja_fresa', sku: 'SUERO-CAJA24-FRESA', nombre: 'Caja Dulet Fresa (24 pzas)', mx: 4500, eu: 300, gua: 2000, esCaja: true, emoji: '🍓' },
    { id: 'caja_vainilla', sku: 'SUERO-CAJA24-VAINILLA', nombre: 'Caja Dulet Vainilla (24 pzas)', mx: 4500, eu: 300, gua: 2000, esCaja: true, emoji: '🍦' },
    { id: 28, sku: 'SUERO-CAJA24-SURTIDA', nombre: 'Caja Dulet Surtida (24 pzas)', mx: 4500, eu: 300, gua: 2000, esCaja: true, emoji: '🌈' },
    { id: 91, sku: 'ESENCIA-MOVW7DCB-WFW', nombre: 'Caja Eucament (Display 48 pzas)', mx: 4500, eu: 300, gua: 2000, esCaja: true, emoji: '🌿' },

    // 🥛 Botes Individuales (Línea de Consumo sin "Dist")
    { id: 30, sku: 'SUERO-MNJ2LPS3-5XP', nombre: 'Dulet Natural (Bote 450g)', mx: 187.50, eu: 12.50, gua: 85, esCaja: false, emoji: '🥛' },
    { id: 35, sku: 'SUERO-MNTA8DF4-7Q9', nombre: 'Dulet Chocolate (Bote 450g)', mx: 187.50, eu: 12.50, gua: 85, esCaja: false, emoji: '🍫' },
    { id: 33, sku: 'SUERO-MNT9XH1Q-NBF', nombre: 'Dulet Fresa (Bote 450g)', mx: 187.50, eu: 12.50, gua: 85, esCaja: false, emoji: '🍓' },
    { id: 34, sku: 'SUERO-MNTA7VLE-D54', nombre: 'Dulet Vainilla (Bote 450g)', mx: 187.50, eu: 12.50, gua: 85, esCaja: false, emoji: '🍦' },
    { id: 26, sku: 'ESENCIA-EUCAMENT-DIST', nombre: 'Eucament (Esencia Gotero)', mx: 93.75, eu: 0, gua: 45, esCaja: false, emoji: '🌿' },

    // 🎁 Artículos Promocionales Oficiales (Activos en México con precio MXN; eu: 0 para USA de acuerdo a tabla productos)
    { id: 4,  sku: 'PROMO-REVISTA', nombre: 'Revista Aprendiendo a ser Millonario', mx: 50, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '📄' },
    { id: 5,  sku: 'PROMO-CAMISA-ML', nombre: 'Camisa Unisex Manga Larga', mx: 550, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '👕' },
    { id: 6,  sku: 'PROMO-CAMISA-MC', nombre: 'Camisa Unisex Manga Corta', mx: 550, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '👕' },
    { id: 7,  sku: 'PROMO-MOCHILA', nombre: 'Mochila — Maletín Negro Mediano', mx: 380, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🎒' },
    { id: 8,  sku: 'PROMO-TAZA', nombre: 'Taza 13 oz. con Impresión Dulet', mx: 60, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '☕' },
    { id: 9,  sku: 'PROMO-BOLSA-ECO', nombre: 'Bolsa Ecológica Dulet', mx: 40, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🛍️' },
    { id: 10, sku: 'PROMO-VASO', nombre: 'Vaso Térmico 800 ml Dulet', mx: 500, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🥤' },
    { id: 11, sku: 'PROMO-LONA-SOP', nombre: 'Lona Impresa con Soporte Metálico', mx: 450, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🚩' },
    { id: 13, sku: 'PROMO-TRIPTICOS', nombre: 'Paquete de 11 Trípticos Informativos', mx: 35, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '📄' },
    { id: 14, sku: 'PROMO-PANOLETA', nombre: 'Pañoleta Dulet', mx: 150, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🧣' },
    { id: 15, sku: 'PROMO-BOLSA-KIT', nombre: 'Bolsa Kit', mx: 180, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🎁' },
    { id: 16, sku: 'PROMO-ABANICO', nombre: 'Abanico', mx: 100, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🪭' },
    { id: 17, sku: 'PROMO-GORRA', nombre: 'Gorra Dulet', mx: 150, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🧢' },
    { id: 90, sku: 'PROMO-MOVROB5R-I4L', nombre: 'Vaso Shaker', mx: 120, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🥤' },
    { id: 92, sku: 'PROMO-MP1VP3SJ-S3H', nombre: 'Folletos Informativos', mx: 1, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '📄' },
    { id: 93, sku: 'PROMO-MPHEH8FH-6BT', nombre: 'Mochila Dulet', mx: 250, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '🎒' },
    { id: 94, sku: 'PROMO-MRB8YKRN-R3I', nombre: 'Block de Contrato', mx: 100, eu: 0, gua: 0, esCaja: false, esPromo: true, emoji: '📝' }
];

async function _pedLiderCargarCatalogo() {
    _pedLiderCatalogo = [..._PED_LIDER_CAT_BASE];
    try {
        const res = await BO_API.post('/bo/sql-relay', {
            secret: 'fixdb_2026',
            sql: "SELECT id, sku, nombre, precio, precio_usd, precio_gtq, es_promo, activo FROM productos WHERE activo = true ORDER BY nombre"
        });
        if (res && res.rows && res.rows.length > 0) {
            res.rows.forEach(dbP => {
                const s = (dbP.sku || '').toUpperCase();
                const n = (dbP.nombre || '').toLowerCase();
                const esPromo = dbP.es_promo === true || s.startsWith('PROMO-');
                const esDist = n.includes('dist') || s.includes('dist');
                const esCaja = n.startsWith('caja ') || s.includes('paquete') || s.includes('caja');
                if (!esPromo && !esDist && !esCaja) return;
                if (n.includes('pub') || n.includes('mc') || s.includes('envio') || n.includes('envio')) return;

                const nombreLimpio = _pedLiderLimpiarNombre(dbP.nombre);

                const found = _pedLiderCatalogo.find(p => p.sku === dbP.sku || String(p.id) === String(dbP.id));
                if (found) {
                    if (dbP.precio !== null && dbP.precio !== undefined) found.mx = parseFloat(dbP.precio || 0);
                    if (dbP.precio_usd !== null && dbP.precio_usd !== undefined) found.eu = parseFloat(dbP.precio_usd || 0);
                    if (dbP.precio_gtq !== null && dbP.precio_gtq !== undefined) found.gua = parseFloat(dbP.precio_gtq || 0);
                    found.nombre = nombreLimpio;
                } else {
                    _pedLiderCatalogo.push({
                        id: dbP.id,
                        sku: dbP.sku,
                        nombre: nombreLimpio,
                        mx: parseFloat(dbP.precio || 0),
                        eu: parseFloat(dbP.precio_usd || 0),
                        gua: parseFloat(dbP.precio_gtq || 0),
                        esCaja: esCaja,
                        esPromo: esPromo,
                        emoji: esCaja ? '📦' : (esPromo ? '🎁' : '✨')
                    });
                }
            });
        }
    } catch(e) {
        console.warn('[PEDIDO LIDER] Usando catálogo base verificado:', e.message);
    }
}

function _pedLiderEsSurtida(prod) {
    if (!prod) return false;
    const s = (prod.sku || '').toUpperCase();
    const n = (prod.nombre || '').toLowerCase();
    return s.includes('SURTID') || n.includes('surtid') || n.includes('mixt');
}

function _pedLiderCalcMixEquiv(mix) {
    if (!mix) return 0;
    const nat = Number(mix.nat || 0);
    const choco = Number(mix.choco || 0);
    const fresa = Number(mix.fresa || 0);
    const vain = Number(mix.vain || 0);
    const euca = Number(mix.euca || 0);
    return nat + choco + fresa + vain + (euca / 2);
}

function _pedLiderModMix(idx, sabor, delta) {
    if (!_pedLiderLineas[idx]) return;
    const cant = _pedLiderLineas[idx].cant || 1;
    if (!_pedLiderLineas[idx].mix) {
        _pedLiderLineas[idx].mix = { nat: 6 * cant, choco: 6 * cant, fresa: 6 * cant, vain: 6 * cant, euca: 0 };
    }
    let cur = Number(_pedLiderLineas[idx].mix[sabor] || 0);
    let next = cur + delta;
    if (next < 0) next = 0;
    if (sabor === 'euca' && next % 2 !== 0) {
        next = delta > 0 ? next + 1 : Math.max(0, next - 1);
    }
    _pedLiderLineas[idx].mix[sabor] = next;
    _pedLiderRenderLineas();
    _calcPedidoLider();
}

function _pedLiderSetMixVal(idx, sabor, rawVal) {
    if (!_pedLiderLineas[idx]) return;
    const cant = _pedLiderLineas[idx].cant || 1;
    if (!_pedLiderLineas[idx].mix) {
        _pedLiderLineas[idx].mix = { nat: 6 * cant, choco: 6 * cant, fresa: 6 * cant, vain: 6 * cant, euca: 0 };
    }
    let val = parseInt(rawVal || 0);
    if (isNaN(val) || val < 0) val = 0;
    if (val > 240) val = 240;
    if (sabor === 'euca' && val % 2 !== 0) {
        val = val + 1;
    }
    _pedLiderLineas[idx].mix[sabor] = val;
    _pedLiderRenderLineas();
    _calcPedidoLider();
}

function _pedLiderBuildSelectOptions(selectedId, moneda = 'MXN', paisLider = 'MEX') {
    let html = '';
    const sym = moneda === 'USD' ? ' USD' : (moneda === 'GTQ' ? ' GTQ' : ' MXN');
    const getPrecioVal = p => (moneda === 'USD' ? (p.eu || 0) : (moneda === 'GTQ' ? (p.gua || 0) : (p.mx || 0)));
    const getPrecio = p => '$' + Number(getPrecioVal(p)).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + sym;

    // Catálogo filtrado: SOLO Cajas y Promocionales Oficiales (se eliminan botes individuales)
    const filtrados = _pedLiderCatalogo.filter(p => {
        if (!p.esCaja && !p.esPromo) return false;
        const val = getPrecioVal(p);
        if (val <= 0) return false;
        if (paisLider === 'USA') {
            if (p.sku === 'SUERO-CAJA24-NAT-EU' || (p.nombre || '').includes('Estados Unidos')) return false;
        }
        return true;
    });

    const cajas = filtrados.filter(p => p.esCaja);
    const promos = filtrados.filter(p => p.esPromo);

    if (cajas.length > 0) {
        html += '<optgroup label="📦 Cajas Dulet & Eucament (Calificación de Caja)">';
        cajas.forEach(p => {
            const sel = (String(p.id) === String(selectedId) || p.sku === String(selectedId)) ? ' selected' : '';
            const nombreLimpio = _pedLiderLimpiarNombre(p.nombre);
            html += `<option value="${p.id}" data-sku="${p.sku}" data-caja="true"${sel}>${p.emoji} ${nombreLimpio} (${getPrecio(p)})</option>`;
        });
        html += '</optgroup>';
    }

    if (promos.length > 0) {
        html += '<optgroup label="🎁 Artículos Promocionales Oficiales">';
        promos.forEach(p => {
            const sel = (String(p.id) === String(selectedId) || p.sku === String(selectedId)) ? ' selected' : '';
            const nombreLimpio = _pedLiderLimpiarNombre(p.nombre);
            html += `<option value="${p.id}" data-sku="${p.sku}" data-caja="false"${sel}>${p.emoji} ${nombreLimpio} (${getPrecio(p)})</option>`;
        });
        html += '</optgroup>';
    }

    return html;
}

function _pedLiderRenderLineas() {
    const container = document.getElementById('pedLiderLineasContainer');
    if (!container) return;

    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    const paisLider = _pedLiderDetectarPais(user);
    const userMoneda = (paisLider === 'USA' || user?.moneda === 'USD') ? 'USD' : (paisLider === 'GTQ' ? 'GTQ' : 'MXN');

    container.innerHTML = _pedLiderLineas.map((line, idx) => {
        const prod = _pedLiderCatalogo.find(p => String(p.id) === String(line.prodId) || p.sku === String(line.prodId)) || _pedLiderCatalogo[0];
        const unitPrice = userMoneda === 'USD' ? (prod.eu || 0) : (userMoneda === 'GTQ' ? (prod.gua || 0) : (prod.mx || 0));
        const subtotal = line.cant * unitPrice;
        const sym = userMoneda === 'USD' ? ' USD' : (userMoneda === 'GTQ' ? ' GTQ' : ' MXN');
        const showDelete = _pedLiderLineas.length > 1;
        const esSurtida = _pedLiderEsSurtida(prod);

        if (esSurtida && !line.mix) {
            const c = line.cant || 1;
            line.mix = { nat: 6 * c, choco: 6 * c, fresa: 6 * c, vain: 6 * c, euca: 0 };
        }

        let mixHtml = '';
        if (esSurtida) {
            const target = 24 * (line.cant || 1);
            const equivActual = _pedLiderCalcMixEquiv(line.mix);
            const diff = target - equivActual;

            let badgeHtml = '';
            if (diff === 0) {
                badgeHtml = `<span style="padding:2px 8px;border-radius:6px;background:rgba(34,197,94,0.15);color:#4ade80;font-size:0.72rem;font-weight:700;border:1px solid rgba(34,197,94,0.3);">✓ Completa (${target}/${target})</span>`;
            } else if (diff > 0) {
                badgeHtml = `<span style="padding:2px 8px;border-radius:6px;background:rgba(245,158,11,0.15);color:#fbbf24;font-size:0.72rem;font-weight:700;border:1px solid rgba(245,158,11,0.3);">Faltan ${diff} equiv</span>`;
            } else {
                badgeHtml = `<span style="padding:2px 8px;border-radius:6px;background:rgba(239,68,68,0.15);color:#f87171;font-size:0.72rem;font-weight:700;border:1px solid rgba(239,68,68,0.3);">Exceso +${Math.abs(diff)} equiv</span>`;
            }

            mixHtml = `
                <div style="width:100%;margin-top:0.5rem;padding:0.7rem 0.8rem;background:rgba(0,0,0,0.35);border:1px solid rgba(59,130,246,0.3);border-radius:8px;">
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.55rem;flex-wrap:wrap;gap:4px;">
                        <span style="font-size:0.75rem;font-weight:700;color:#93c5fd;display:flex;align-items:center;gap:4px;">
                            <span>🌈</span> Arma tus Sabores (${target} unidades equivalentes):
                        </span>
                        ${badgeHtml}
                    </div>
                    <div style="display:grid;grid-template-columns:repeat(auto-fit, minmax(78px, 1fr));gap:0.4rem;">
                        <!-- Natural -->
                        <div style="background:rgba(255,255,255,0.03);padding:0.35rem 0.2rem;border-radius:6px;text-align:center;border:1px solid rgba(255,255,255,0.06);">
                            <div style="font-size:0.68rem;color:#cbd5e1;font-weight:600;">🥛 Natural</div>
                            <div style="display:flex;align-items:center;justify-content:center;gap:3px;margin-top:3px;">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'nat', -1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">-</button>
                                <input type="number" min="0" max="240" value="${line.mix.nat || 0}" style="width:32px;height:24px;background:#09090b;border:1px solid rgba(255,255,255,0.15);border-radius:4px;color:#fff;text-align:center;font-size:0.8rem;font-weight:700;padding:0;" onchange="_pedLiderSetMixVal(${idx}, 'nat', this.value)">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'nat', 1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">+</button>
                            </div>
                        </div>

                        <!-- Chocolate -->
                        <div style="background:rgba(255,255,255,0.03);padding:0.35rem 0.2rem;border-radius:6px;text-align:center;border:1px solid rgba(255,255,255,0.06);">
                            <div style="font-size:0.68rem;color:#cbd5e1;font-weight:600;">🍫 Choco</div>
                            <div style="display:flex;align-items:center;justify-content:center;gap:3px;margin-top:3px;">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'choco', -1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">-</button>
                                <input type="number" min="0" max="240" value="${line.mix.choco || 0}" style="width:32px;height:24px;background:#09090b;border:1px solid rgba(255,255,255,0.15);border-radius:4px;color:#fff;text-align:center;font-size:0.8rem;font-weight:700;padding:0;" onchange="_pedLiderSetMixVal(${idx}, 'choco', this.value)">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'choco', 1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">+</button>
                            </div>
                        </div>

                        <!-- Fresa -->
                        <div style="background:rgba(255,255,255,0.03);padding:0.35rem 0.2rem;border-radius:6px;text-align:center;border:1px solid rgba(255,255,255,0.06);">
                            <div style="font-size:0.68rem;color:#cbd5e1;font-weight:600;">🍓 Fresa</div>
                            <div style="display:flex;align-items:center;justify-content:center;gap:3px;margin-top:3px;">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'fresa', -1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">-</button>
                                <input type="number" min="0" max="240" value="${line.mix.fresa || 0}" style="width:32px;height:24px;background:#09090b;border:1px solid rgba(255,255,255,0.15);border-radius:4px;color:#fff;text-align:center;font-size:0.8rem;font-weight:700;padding:0;" onchange="_pedLiderSetMixVal(${idx}, 'fresa', this.value)">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'fresa', 1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">+</button>
                            </div>
                        </div>

                        <!-- Vainilla -->
                        <div style="background:rgba(255,255,255,0.03);padding:0.35rem 0.2rem;border-radius:6px;text-align:center;border:1px solid rgba(255,255,255,0.06);">
                            <div style="font-size:0.68rem;color:#cbd5e1;font-weight:600;">🍦 Vainilla</div>
                            <div style="display:flex;align-items:center;justify-content:center;gap:3px;margin-top:3px;">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'vain', -1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">-</button>
                                <input type="number" min="0" max="240" value="${line.mix.vain || 0}" style="width:32px;height:24px;background:#09090b;border:1px solid rgba(255,255,255,0.15);border-radius:4px;color:#fff;text-align:center;font-size:0.8rem;font-weight:700;padding:0;" onchange="_pedLiderSetMixVal(${idx}, 'vain', this.value)">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'vain', 1)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">+</button>
                            </div>
                        </div>

                        <!-- Eucament (2=1) -->
                        <div style="background:rgba(34,197,94,0.06);padding:0.35rem 0.2rem;border-radius:6px;text-align:center;border:1px solid rgba(34,197,94,0.25);">
                            <div style="font-size:0.68rem;color:#86efac;font-weight:700;">🌿 Eucament</div>
                            <div style="display:flex;align-items:center;justify-content:center;gap:3px;margin-top:3px;">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'euca', -2)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">-</button>
                                <input type="number" min="0" max="480" step="2" value="${line.mix.euca || 0}" style="width:32px;height:24px;background:#09090b;border:1px solid rgba(34,197,94,0.3);border-radius:4px;color:#86efac;text-align:center;font-size:0.8rem;font-weight:700;padding:0;" onchange="_pedLiderSetMixVal(${idx}, 'euca', this.value)">
                                <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModMix(${idx}, 'euca', 2)" style="width:22px;height:24px;padding:0;font-size:0.85rem;line-height:1;">+</button>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top:0.45rem;font-size:0.7rem;color:var(--text-dim);display:flex;justify-content:space-between;align-items:center;">
                        <span>💡 <em>2 frascos de Eucament = 1 Dulet</em></span>
                        <span style="color:${diff === 0 ? '#4ade80' : (diff > 0 ? '#fbbf24' : '#f87171')};font-weight:700;">Total: ${equivActual} / ${target} equivalentes</span>
                    </div>
                </div>
            `;
        }

        return `
            <div class="ped-lider-fila" style="display:flex;gap:0.5rem;align-items:center;background:rgba(255,255,255,0.02);border:1px solid rgba(255,255,255,0.08);border-radius:10px;padding:0.6rem 0.8rem;flex-wrap:wrap;">
                <div style="flex:1;min-width:190px;">
                    <select class="form-control" style="font-size:0.82rem;width:100%;" onchange="_pedLiderCambiarProd(${idx}, this.value)">
                        ${_pedLiderBuildSelectOptions(prod.id, userMoneda, paisLider)}
                    </select>
                </div>
                <div style="display:flex;align-items:center;gap:0.35rem;">
                    <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModCant(${idx}, -1)" style="width:30px;height:30px;padding:0;font-size:1.05rem;font-weight:700;">-</button>
                    <input type="number" value="${line.cant}" min="1" max="100" class="form-control" style="width:50px;text-align:center;font-weight:700;font-size:0.9rem;padding:0.35rem;" onchange="_pedLiderInputCant(${idx}, this.value)" oninput="_pedLiderInputCant(${idx}, this.value)">
                    <button type="button" class="btn btn-outline btn-sm" onclick="_pedLiderModCant(${idx}, 1)" style="width:30px;height:30px;padding:0;font-size:1.05rem;font-weight:700;">+</button>
                </div>
                <div style="min-width:90px;text-align:right;font-size:0.85rem;font-weight:700;color:#60a5fa;">
                    $${subtotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}${sym}
                </div>
                ${showDelete ? `
                    <button type="button" onclick="_pedLiderEliminarFila(${idx})" style="background:none;border:none;color:#ef4444;font-size:1.25rem;cursor:pointer;line-height:1;padding:0 4px;" title="Eliminar fila">&times;</button>
                ` : '<div style="width:16px;"></div>'}
                ${mixHtml}
            </div>
        `;
    }).join('');
}

function _pedLiderAgregarFila() {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    const paisLider = _pedLiderDetectarPais(user);
    const getVal = p => (paisLider === 'USA' ? (p.eu || 0) : (paisLider === 'GTQ' ? (p.gua || 0) : (p.mx || 0)));
    const prodsYaUsados = new Set(_pedLiderLineas.map(l => String(l.prodId)));

    // Buscar inteligentemente el siguiente producto (solo cajas o promos)
    const nuevoProd = _pedLiderCatalogo.find(p => (p.esCaja || p.esPromo) && !prodsYaUsados.has(String(p.id)) && getVal(p) > 0)
        || _pedLiderCatalogo.find(p => p.esCaja && getVal(p) > 0)
        || _pedLiderCatalogo[0];

    const esSurt = _pedLiderEsSurtida(nuevoProd);
    _pedLiderLineas.push({
        prodId: nuevoProd.id,
        cant: 1,
        mix: esSurt ? { nat: 6, choco: 6, fresa: 6, vain: 6, euca: 0 } : null
    });
    _pedLiderRenderLineas();
    _calcPedidoLider();
}

function _pedLiderEliminarFila(idx) {
    if (_pedLiderLineas.length <= 1) return;
    _pedLiderLineas.splice(idx, 1);
    _pedLiderRenderLineas();
    _calcPedidoLider();
}

function _pedLiderModCant(idx, delta) {
    if (!_pedLiderLineas[idx]) return;
    const oldCant = parseInt(_pedLiderLineas[idx].cant || 1);
    let val = oldCant + delta;
    if (val < 1) val = 1;
    if (val > 100) val = 100;
    _pedLiderLineas[idx].cant = val;

    const prod = _pedLiderCatalogo.find(p => String(p.id) === String(_pedLiderLineas[idx].prodId) || p.sku === String(_pedLiderLineas[idx].prodId));
    if (_pedLiderEsSurtida(prod)) {
        if (!_pedLiderLineas[idx].mix) {
            _pedLiderLineas[idx].mix = { nat: 6 * val, choco: 6 * val, fresa: 6 * val, vain: 6 * val, euca: 0 };
        } else {
            const diffCajas = val - oldCant;
            _pedLiderLineas[idx].mix.nat = Math.max(0, (_pedLiderLineas[idx].mix.nat || 0) + 6 * diffCajas);
            _pedLiderLineas[idx].mix.choco = Math.max(0, (_pedLiderLineas[idx].mix.choco || 0) + 6 * diffCajas);
            _pedLiderLineas[idx].mix.fresa = Math.max(0, (_pedLiderLineas[idx].mix.fresa || 0) + 6 * diffCajas);
            _pedLiderLineas[idx].mix.vain = Math.max(0, (_pedLiderLineas[idx].mix.vain || 0) + 6 * diffCajas);
        }
    }

    _pedLiderRenderLineas();
    _calcPedidoLider();
}

function _pedLiderInputCant(idx, rawVal) {
    if (!_pedLiderLineas[idx]) return;
    const oldCant = parseInt(_pedLiderLineas[idx].cant || 1);
    let val = parseInt(rawVal || 1);
    if (isNaN(val) || val < 1) val = 1;
    if (val > 100) val = 100;
    _pedLiderLineas[idx].cant = val;

    const prod = _pedLiderCatalogo.find(p => String(p.id) === String(_pedLiderLineas[idx].prodId) || p.sku === String(_pedLiderLineas[idx].prodId));
    if (_pedLiderEsSurtida(prod)) {
        if (!_pedLiderLineas[idx].mix) {
            _pedLiderLineas[idx].mix = { nat: 6 * val, choco: 6 * val, fresa: 6 * val, vain: 6 * val, euca: 0 };
        } else {
            const diffCajas = val - oldCant;
            _pedLiderLineas[idx].mix.nat = Math.max(0, (_pedLiderLineas[idx].mix.nat || 0) + 6 * diffCajas);
            _pedLiderLineas[idx].mix.choco = Math.max(0, (_pedLiderLineas[idx].mix.choco || 0) + 6 * diffCajas);
            _pedLiderLineas[idx].mix.fresa = Math.max(0, (_pedLiderLineas[idx].mix.fresa || 0) + 6 * diffCajas);
            _pedLiderLineas[idx].mix.vain = Math.max(0, (_pedLiderLineas[idx].mix.vain || 0) + 6 * diffCajas);
        }
    }

    _pedLiderRenderLineas();
    _calcPedidoLider();
}

function _pedLiderCambiarProd(idx, newId) {
    if (!_pedLiderLineas[idx]) return;
    _pedLiderLineas[idx].prodId = newId;
    const prod = _pedLiderCatalogo.find(p => String(p.id) === String(newId) || p.sku === String(newId));
    if (_pedLiderEsSurtida(prod)) {
        const c = _pedLiderLineas[idx].cant || 1;
        _pedLiderLineas[idx].mix = { nat: 6 * c, choco: 6 * c, fresa: 6 * c, vain: 6 * c, euca: 0 };
    } else {
        _pedLiderLineas[idx].mix = null;
    }
    _pedLiderRenderLineas();
    _calcPedidoLider();
}

// ══ Lista y Catálogo de CEDIS Activos para Pedidos ════════════
let _pedLiderCedisList = [
    { id: 1, nombre: 'CEDIS Guadalajara', ciudad: 'Zapopan', estado: 'Jalisco', direccion: 'Chimalhuacán 3569-D, Col. Ciudad del sol, Zapopan, Jal.', tel: '523329347741', flete_caja: 0, pais: 'MEX' },
    { id: 2, nombre: 'CEDIS Cancún', ciudad: 'Cancún', estado: 'Quintana Roo', direccion: 'Avenida Cobá #26, Supermanzana 26, Cancún, Q. Roo', tel: '529986533313', flete_caja: 250, pais: 'MEX' },
    { id: 3, nombre: 'CEDIS Tapachula', ciudad: 'Tapachula', estado: 'Chiapas', direccion: '9a. Oriente #26 , Centro, Tapachula, Chis.', tel: '529622954781', flete_caja: 250, pais: 'MEX' },
    { id: 4, nombre: 'LLC — USA', ciudad: 'Houston', estado: 'Texas', direccion: 'Beecham DR, Houston, TX 77068', tel: '13468498837', flete_caja: 0, pais: 'USA' }
];

async function _pedLiderCargarCedis() {
    try {
        const res = await BO_API.post('/bo/sql-relay', {
            secret: 'fixdb_2026',
            sql: "SELECT id, nombre, direccion, ciudad, estado, tel, flete_caja, activo FROM cedis WHERE activo = true ORDER BY id;"
        });
        if (res && res.rows && res.rows.length > 0) {
            _pedLiderCedisList = res.rows.map(r => {
                const nom = (r.nombre || '').toLowerCase();
                const est = (r.estado || '').toLowerCase();
                const esUsa = nom.includes('usa') || nom.includes('llc') || est.includes('texas') || String(r.id) === '4';
                let telNum = r.tel ? r.tel.replace(/[^0-9]/g, '') : '';
                if (!telNum) {
                    if (String(r.id) === '2') telNum = '529986533313';
                    else if (String(r.id) === '3') telNum = '529622954781';
                    else if (String(r.id) === '4') telNum = '13468498837';
                    else telNum = '523329347741';
                }
                return {
                    ...r,
                    pais: esUsa ? 'USA' : 'MEX',
                    tel: telNum,
                    flete_caja: Number(r.flete_caja ?? (String(r.id) === '1' || String(r.id) === '4' ? 0 : 250))
                };
            });
        }
    } catch(e) {
        console.warn('[PEDIDO LIDER] Usando lista de CEDIS base:', e.message);
    }
}

function _pedLiderPoblarSelectCedis(selectedVal) {
    const sel = document.getElementById('pedLiderSelectCedis');
    if (!sel) return;

    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    const paisLider = _pedLiderDetectarPais(user);

    let html = '';

    if (paisLider === 'USA') {
        // --- LÍDER EN ESTADOS UNIDOS ---
        // 1. Recoger en CEDIS Houston (LLC USA) — Costo flete: $0.00 USD
        const llc = _pedLiderCedisList.find(c => String(c.id) === '4' || (c.nombre || '').toLowerCase().includes('llc') || (c.ciudad || '').toLowerCase().includes('houston'))
            || { id: 4, nombre: 'LLC — USA', ciudad: 'Houston', estado: 'Texas', direccion: 'Beecham DR, Houston, TX' };
        
        const isLlcSelected = !selectedVal || selectedVal === '4' || selectedVal === '1';
        html += `<option value="4" data-costo="0" data-tipo="llc_usa"${isLlcSelected ? ' selected' : ''}>🏪 Recoger en ${llc.nombre} (${llc.ciudad}, TX) — Sin costo de envío ($0.00 USD)</option>`;

        // 2. Envío a Domicilio en USA (+$50.00 USD por caja)
        html += '<optgroup label="📦 Entrega a Domicilio en USA">';
        html += `<option value="domicilio" data-costo="50" data-tipo="domicilio"${selectedVal === 'domicilio' ? ' selected' : ''}>📦 Envío a mi Domicilio registrado en USA — Flete Obligatorio (+$50.00 USD/caja)</option>`;
        html += '</optgroup>';
    } else {
        // --- LÍDER EN MÉXICO (O DEFAULT) ---
        // 1. Recoger en CEDIS Guadalajara (Sin costo de flete: $0.00 MXN)
        const gdl = _pedLiderCedisList.find(c => String(c.id) === '1' || (c.nombre || '').toLowerCase().includes('guadalajara')) || _pedLiderCedisList[0];
        if (gdl) {
            html += `<option value="1" data-costo="0" data-tipo="gdl"${!selectedVal || selectedVal === '1' ? ' selected' : ''}>🏪 Recoger en ${gdl.nombre} (${gdl.ciudad || 'Zapopan'}) — Sin costo de flete ($0.00 MXN)</option>`;
        }

        // 2. Recoger en CEDIS Cancún (+$250.00 MXN/caja de flete obligatorio)
        const can = _pedLiderCedisList.find(c => String(c.id) === '2');
        if (can) {
            html += `<option value="2" data-costo="250" data-tipo="cancun"${selectedVal === '2' ? ' selected' : ''}>🏪 Recoger en ${can.nombre} (${can.ciudad || 'Cancún'}) — Flete Obligatorio (+$250.00 MXN/caja)</option>`;
        }

        // 3. Recoger en CEDIS Tapachula (+$250.00 MXN/caja de flete obligatorio)
        const tap = _pedLiderCedisList.find(c => String(c.id) === '3');
        if (tap) {
            html += `<option value="3" data-costo="250" data-tipo="tapachula"${selectedVal === '3' ? ' selected' : ''}>🏪 Recoger en ${tap.nombre} (${tap.ciudad || 'Tapachula'}) — Flete Obligatorio (+$250.00 MXN/caja)</option>`;
        }

        // 4. Envío directo a Domicilio Particular registrado (+$250.00 MXN/caja)
        html += '<optgroup label="📦 Entrega a Domicilio Particular">';
        html += `<option value="domicilio" data-costo="250" data-tipo="domicilio"${selectedVal === 'domicilio' ? ' selected' : ''}>📦 Envío a mi Domicilio registrado — Flete Obligatorio (+$250.00 MXN/caja)</option>`;
        html += '</optgroup>';

        // 5. Envío de México a USA (+$2,500.00 MXN/caja)
        html += '<optgroup label="✈️ Envío Internacional">';
        html += `<option value="4" data-costo="2500" data-tipo="mex_a_usa"${selectedVal === '4' ? ' selected' : ''}>✈️ Envío de México a USA (+$2,500.00 MXN/caja)</option>`;
        html += '</optgroup>';
    }

    sel.innerHTML = html;
    if (selectedVal) sel.value = String(selectedVal);
}

async function abrirModalPedidoLider() {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    if (!user) return;

    await _pedLiderCargarCatalogo();
    await _pedLiderCargarCedis();

    const paisLider = _pedLiderDetectarPais(user);
    const userMoneda = (paisLider === 'USA' || user?.moneda === 'USD') ? 'USD' : (paisLider === 'GTQ' ? 'GTQ' : 'MXN');

    // Inicializar con la primera caja disponible del país correspondiente
    const cajasDisponibles = _pedLiderCatalogo.filter(p => {
        if (!p.esCaja) return false;
        const val = userMoneda === 'USD' ? (p.eu || 0) : (userMoneda === 'GTQ' ? (p.gua || 0) : (p.mx || 0));
        return val > 0;
    });
    const primeraCaja = cajasDisponibles[0] || _pedLiderCatalogo.find(p => p.esCaja) || _pedLiderCatalogo[0];
    const esSurt = _pedLiderEsSurtida(primeraCaja);
    _pedLiderLineas = [{
        prodId: primeraCaja.id,
        cant: 1,
        mix: esSurt ? { nat: 6, choco: 6, fresa: 6, vain: 6, euca: 0 } : null
    }];

    let saldoAct = 0;
    if (window.ACTIVOS_BOLSA_GLOBAL && typeof window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible === 'number') {
        saldoAct = window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible;
    } else {
        const dispNode = document.getElementById('activoDisp');
        if (dispNode) {
            const raw = dispNode.textContent.replace(/[^0-9.]/g, '');
            if (raw) saldoAct = parseFloat(raw);
        }
    }
    const elSaldo = document.getElementById('pedLiderSaldoActivos');
    const symSaldo = userMoneda === 'USD' ? ' USD' : (userMoneda === 'GTQ' ? ' GTQ' : ' MXN');
    if (elSaldo) elSaldo.textContent = '$' + saldoAct.toLocaleString('es-MX', { minimumFractionDigits: 2 }) + symSaldo;

    const defaultCedis = (paisLider === 'USA') ? '4' : '1';
    _pedLiderPoblarSelectCedis(defaultCedis);
    _pedLiderRenderLineas();
    _calcPedidoLider();
    const modal = document.getElementById('modalLevantarPedidoLider');
    if (modal) modal.style.display = 'flex';
}

function cerrarModalPedidoLider() {
    const modal = document.getElementById('modalLevantarPedidoLider');
    if (modal) modal.style.display = 'none';
}

function _calcPedidoLider() {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    const paisLider = _pedLiderDetectarPais(user);
    const userMoneda = (paisLider === 'USA' || user?.moneda === 'USD') ? 'USD' : (paisLider === 'GTQ' ? 'GTQ' : 'MXN');

    let subtotal = 0;
    let totalCajas = 0;

    _pedLiderLineas.forEach(line => {
        const prod = _pedLiderCatalogo.find(p => String(p.id) === String(line.prodId) || p.sku === String(line.prodId)) || _pedLiderCatalogo[0];
        const unitPrice = userMoneda === 'USD' ? (prod.eu || 0) : (userMoneda === 'GTQ' ? (prod.gua || 0) : (prod.mx || 0));
        subtotal += (line.cant * unitPrice);
        if (prod.esCaja) {
            totalCajas += line.cant;
        }
    });

    const selCedis = document.getElementById('pedLiderSelectCedis');
    const selectedVal = selCedis?.value || (paisLider === 'USA' ? '4' : '1');

    // Costo oficial de flete:
    // Líder USA:
    //   - Recoger en LLC Houston (value='4'): $0.00 USD
    //   - Domicilio en USA (value='domicilio'): $50.00 USD por caja (id 44: Envio USA)
    // Líder MEX:
    //   - Recoger en CEDIS Guadalajara (value='1'): $0.00 MXN
    //   - Enviar a LLC USA Houston (value='4'): $2,500.00 MXN por caja (id 43: Envio de México a USA)
    //   - Domicilio en México o CEDIS Cancún/Tapachula: $250.00 MXN por caja (id 31: Envio Mexico)
    let fleteTotal = 0;
    let esSinCosto = false;

    if (paisLider === 'USA') {
        if (selectedVal === '4') {
            fleteTotal = 0;
            esSinCosto = true;
        } else if (selectedVal === 'domicilio') {
            fleteTotal = totalCajas > 0 ? (50 * totalCajas) : 25;
        } else {
            fleteTotal = totalCajas > 0 ? (50 * totalCajas) : 25;
        }
    } else {
        if (selectedVal === '1') {
            fleteTotal = 0;
            esSinCosto = true;
        } else if (selectedVal === '4') {
            // Envío internacional México a USA ($2,500 MXN por caja)
            fleteTotal = totalCajas > 0 ? (2500 * totalCajas) : 1500;
        } else {
            // Domicilio nacional o CEDIS nacional ($250 MXN por caja)
            fleteTotal = totalCajas > 0 ? (250 * totalCajas) : 150;
        }
    }

    const badgeStatus = document.getElementById('pedLiderBadgeFleteStatus');
    const infoEntrega = document.getElementById('pedLiderInfoEntrega');

    const sym = userMoneda === 'USD' ? ' USD' : (userMoneda === 'GTQ' ? ' GTQ' : ' MXN');
    const fmt = n => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + sym;

    if (badgeStatus) {
        if (esSinCosto) {
            badgeStatus.textContent = '✓ Sin costo de envío ($0.00)';
            badgeStatus.style.background = 'rgba(34,197,94,0.15)';
            badgeStatus.style.color = '#4ade80';
            badgeStatus.style.border = '1px solid rgba(34,197,94,0.3)';
        } else if (paisLider === 'MEX' && selectedVal === '4') {
            badgeStatus.textContent = `✈️ Envío de México a USA (+${fleteTotal.toLocaleString('es-MX')}${sym})`;
            badgeStatus.style.background = 'rgba(168,85,247,0.15)';
            badgeStatus.style.color = '#c084fc';
            badgeStatus.style.border = '1px solid rgba(168,85,247,0.3)';
        } else {
            badgeStatus.textContent = `🚚 Envío Obligatorio (+${fleteTotal.toLocaleString('es-MX')}${sym})`;
            badgeStatus.style.background = 'rgba(59,130,246,0.15)';
            badgeStatus.style.color = '#60a5fa';
            badgeStatus.style.border = '1px solid rgba(59,130,246,0.3)';
        }
    }

    if (infoEntrega) {
        if (selectedVal === '1') {
            const gdlObj = _pedLiderCedisList.find(c => String(c.id) === '1' || (c.nombre || '').toLowerCase().includes('guadalajara'));
            infoEntrega.innerHTML = `🏪 <strong>Mostrador ${gdlObj?.nombre || 'CEDIS Guadalajara'}:</strong> ${gdlObj?.direccion || 'Chimalhuacán 3569-D, Col. Ciudad del sol, Zapopan, Jal.'}<br><span style="color:#4ade80;font-weight:600;">📞 WhatsApp Oficial: +52 33 2934 7741</span>`;
        } else if (selectedVal === '2') {
            const cObj = _pedLiderCedisList.find(c => String(c.id) === '2');
            infoEntrega.innerHTML = `🏪 <strong>Mostrador ${cObj?.nombre || 'CEDIS Cancún'}:</strong> ${cObj?.direccion || 'Avenida Cobá #26, Supermanzana 26, Cancún, Q. Roo'}<br><span style="color:#60a5fa;font-weight:600;">📞 WhatsApp Oficial: +52 998 653 3313</span>`;
        } else if (selectedVal === '3') {
            const cObj = _pedLiderCedisList.find(c => String(c.id) === '3');
            infoEntrega.innerHTML = `🏪 <strong>Mostrador ${cObj?.nombre || 'CEDIS Tapachula'}:</strong> ${cObj?.direccion || '9a. Oriente #26 , Centro, Tapachula, Chis.'}<br><span style="color:#60a5fa;font-weight:600;">📞 WhatsApp Oficial: +52 962 295 4781</span>`;
        } else if (selectedVal === '4' && paisLider === 'USA') {
            const llcObj = _pedLiderCedisList.find(c => String(c.id) === '4');
            infoEntrega.innerHTML = `🏪 <strong>Mostrador ${llcObj?.nombre || 'LLC — USA'}:</strong> ${llcObj?.direccion || 'Beecham DR'}, ${llcObj?.ciudad || 'Houston'}, TX (Recoger en Bodega)<br><span style="color:#4ade80;font-weight:600;">📞 WhatsApp Houston: +1 346 849 8837</span>`;
        } else if (selectedVal === '4' && paisLider === 'MEX') {
            const llcObj = _pedLiderCedisList.find(c => String(c.id) === '4');
            infoEntrega.innerHTML = `✈️ <strong>Envío de México a USA:</strong> Entrega en ${llcObj?.nombre || 'LLC — USA'} (${llcObj?.direccion || 'Beecham DR, Houston, TX'}). Costo oficial de exportación y guía: $2,500.00 MXN por caja.`;
        } else if (selectedVal === 'domicilio') {
            const dirTexto = (user.calle || user.delegacion || user.ciudad)
                ? `${user.calle || ''} ${user.numero || ''}, ${user.colonia || ''} ${user.ciudad || user.delegacion || ''} ${user.cp ? 'CP ' + user.cp : ''}`.trim()
                : 'Dirección registrada en tu perfil de socio';
            infoEntrega.innerHTML = `
                <div>📍 <strong>Envío a Domicilio Particular:</strong> ${dirTexto}</div>
                <div style="margin-top:0.45rem;padding:0.45rem 0.65rem;background:rgba(245,158,11,0.12);border:1px solid rgba(245,158,11,0.35);border-radius:6px;font-size:0.76rem;color:#fde047;display:flex;align-items:flex-start;gap:0.45rem;line-height:1.35;">
                    <span style="font-size:0.95rem;line-height:1;">⚠️</span>
                    <span><strong>Aviso:</strong> En caso de requerir el envío a otro domicilio, favor de levantar tu pedido directamente en corporativo.</span>
                </div>
            `;
        } else {
            const cObj = _pedLiderCedisList.find(c => String(c.id) === String(selectedVal));
            infoEntrega.innerHTML = `🚚 <strong>Envío a ${cObj?.nombre || 'CEDIS'}:</strong> ${cObj?.direccion || ''}, ${cObj?.ciudad || ''} ${cObj?.estado || ''}`;
        }
    }

    const totalConEnvio = subtotal + fleteTotal;

    let saldoAct = 0;
    if (window.ACTIVOS_BOLSA_GLOBAL && typeof window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible === 'number') {
        saldoAct = window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible;
    } else {
        const dispNode = document.getElementById('activoDisp');
        if (dispNode) {
            const raw = dispNode.textContent.replace(/[^0-9.]/g, '');
            if (raw) saldoAct = parseFloat(raw);
        }
    }

    const usarActivos = document.getElementById('pedLiderUsarActivos')?.checked || false;
    let activosRestados = 0;
    if (usarActivos) {
        activosRestados = Math.min(saldoAct, totalConEnvio);
    }
    const totalPagar = Math.max(0, totalConEnvio - activosRestados);

    const elSub = document.getElementById('pedLiderSubtotal');
    const elFleteRow = document.getElementById('pedLiderFleteRow');
    const elFleteMonto = document.getElementById('pedLiderFleteMonto');
    const elRest = document.getElementById('pedLiderActivosRestados');
    const elTot = document.getElementById('pedLiderTotalPagar');

    if (elSub) elSub.textContent = fmt(subtotal);
    if (elFleteRow && elFleteMonto) {
        if (fleteTotal > 0) {
            elFleteRow.style.display = 'flex';
            if (elFleteRow.firstElementChild) {
                const labelFlete = (paisLider === 'MEX' && selectedVal === '4')
                    ? `Envío de México a USA (${totalCajas} caja${totalCajas > 1 ? 's' : ''}):`
                    : `Envío Obligatorio (${totalCajas} caja${totalCajas > 1 ? 's' : ''}):`;
                elFleteRow.firstElementChild.textContent = labelFlete;
            }
            elFleteMonto.textContent = '+' + fmt(fleteTotal);
        } else {
            elFleteRow.style.display = 'none';
        }
    }
    if (elRest) elRest.textContent = '-' + fmt(activosRestados);
    if (elTot) elTot.textContent = fmt(totalPagar);

    // Resumen de productos para el mensaje de WhatsApp
    const nombresProds = _pedLiderLineas.map(l => {
        const p = _pedLiderCatalogo.find(pr => String(pr.id) === String(l.prodId) || pr.sku === String(l.prodId));
        return (l.cant || 1) + 'x ' + (p?.nombre || 'Caja');
    }).join(', ');
    const txtProd = nombresProds || 'Caja Dulet';
    const msgWaMex = encodeURIComponent(`¡Hola Call Center Dulet! Soy ${user?.nombre || 'Socio'} (Reg #${user?.registro || ''}). Deseo levantar un pedido de ${txtProd} (${fmt(totalPagar)}). Adjunto aquí mi comprobante de depósito bancario para procesar mi orden.`);
    const msgWaUsa = encodeURIComponent(`Hello Dulet USA / Houston, I am ${user?.nombre || 'Associate'} (Reg #${user?.registro || ''}). I want to place an order for ${txtProd} (${fmt(totalPagar)}). I attach my bank transfer receipt to process my order.`);

    const btnConfirmar = document.getElementById('btnConfirmarPedidoLider');

    // ══ CANDADO DE ACTIVOS Y FORMA DE LIQUIDACIÓN (DISEÑO FINTECH PREMIUM) ══
    const elNotaLiquidacion = document.getElementById('pedLiderNotaAvisoLiquidacion');
    if (elNotaLiquidacion) {
        elNotaLiquidacion.style.display = 'flex';
        elNotaLiquidacion.style.flexDirection = 'column';
        elNotaLiquidacion.style.gap = '0.9rem';
        elNotaLiquidacion.style.padding = '1.1rem';
        elNotaLiquidacion.style.borderRadius = '14px';

        // Helper para copiar al portapapeles
        if (!window._copiarDatoBancario) {
            window._copiarDatoBancario = (txt, btn) => {
                if (!navigator.clipboard) return;
                navigator.clipboard.writeText(txt).then(() => {
                    if (btn) {
                        const prev = btn.innerHTML;
                        btn.innerHTML = '✓ Copiado';
                        btn.style.background = '#22c55e';
                        btn.style.color = '#fff';
                        btn.style.borderColor = '#22c55e';
                        setTimeout(() => {
                            btn.innerHTML = prev;
                            btn.style.background = '';
                            btn.style.color = '';
                            btn.style.borderColor = '';
                        }, 1600);
                    }
                }).catch(() => {});
            };
        }

        // HTML de tarjetas bancarias según país
        const renderCuentasBancariasHtml = () => {
            if (paisLider === 'USA') {
                return `
                    <div style="background:linear-gradient(145deg,rgba(30,58,138,0.35),rgba(15,23,42,0.9));border:1px solid rgba(59,130,246,0.4);border-radius:12px;padding:1rem;display:flex;flex-direction:column;gap:0.5rem;box-shadow:0 4px 14px rgba(0,0,0,0.3);">
                        <div style="display:flex;align-items:center;justify-content:space-between;padding-bottom:0.45rem;border-bottom:1px solid rgba(255,255,255,0.08);">
                            <div style="display:flex;align-items:center;gap:0.4rem;font-weight:800;color:#60a5fa;font-size:0.92rem;">
                                <span style="font-size:1.1rem;">🏛️</span> CHASE BANK (USA)
                            </div>
                            <span style="font-size:0.7rem;background:rgba(59,130,246,0.2);color:#93c5fd;padding:2px 7px;border-radius:4px;font-weight:700;">Official USA Account</span>
                        </div>
                        <div style="font-size:0.78rem;color:#94a3b8;">
                            Beneficiary: <strong style="color:#f1f5f9;">DULET GROUP LLC</strong>
                        </div>
                        <div style="background:rgba(0,0,0,0.4);border-radius:8px;padding:0.6rem 0.8rem;display:flex;flex-direction:column;gap:0.45rem;font-size:0.8rem;margin-top:2px;">
                            <div style="display:flex;justify-content:space-between;align-items:center;">
                                <span style="color:#94a3b8;">Routing (ABA):</span>
                                <div style="display:flex;align-items:center;gap:0.5rem;">
                                    <strong style="color:#38bdf8;font-family:monospace;font-size:0.9rem;letter-spacing:0.5px;">111000614</strong>
                                    <button type="button" onclick="_copiarDatoBancario('111000614', this)" style="background:rgba(59,130,246,0.25);border:1px solid rgba(59,130,246,0.4);color:#bfdbfe;font-size:0.68rem;font-weight:700;padding:2px 7px;border-radius:4px;cursor:pointer;transition:all .15s ease;">Copiar</button>
                                </div>
                            </div>
                            <div style="display:flex;justify-content:space-between;align-items:center;">
                                <span style="color:#94a3b8;">Account / Cuenta:</span>
                                <div style="display:flex;align-items:center;gap:0.5rem;">
                                    <strong style="color:#fff;font-family:monospace;font-size:0.9rem;letter-spacing:0.5px;">2909191352</strong>
                                    <button type="button" onclick="_copiarDatoBancario('2909191352', this)" style="background:rgba(59,130,246,0.25);border:1px solid rgba(59,130,246,0.4);color:#bfdbfe;font-size:0.68rem;font-weight:700;padding:2px 7px;border-radius:4px;cursor:pointer;transition:all .15s ease;">Copiar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            } else {
                return `
                    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:0.85rem;">
                        <!-- BBVA BANCOMER -->
                        <div style="background:linear-gradient(145deg,rgba(30,58,138,0.3),rgba(15,23,42,0.85));border:1px solid rgba(59,130,246,0.35);border-radius:12px;padding:0.95rem;display:flex;flex-direction:column;gap:0.45rem;box-shadow:0 4px 14px rgba(0,0,0,0.25);">
                            <div style="display:flex;align-items:center;justify-content:space-between;padding-bottom:0.45rem;border-bottom:1px solid rgba(255,255,255,0.08);">
                                <div style="display:flex;align-items:center;gap:0.4rem;font-weight:800;color:#60a5fa;font-size:0.88rem;">
                                    <span style="font-size:1rem;">🔵</span> BBVA Bancomer
                                </div>
                                <span style="font-size:0.68rem;background:rgba(59,130,246,0.18);color:#93c5fd;padding:1px 6px;border-radius:4px;font-weight:700;">Cuenta Oficial</span>
                            </div>
                            <div style="font-size:0.73rem;color:#94a3b8;">
                                Beneficiario: <strong style="color:#f1f5f9;">Dulet International Group S.A. de C.V.</strong>
                            </div>
                            <div style="background:rgba(0,0,0,0.35);border-radius:8px;padding:0.5rem 0.65rem;display:flex;flex-direction:column;gap:0.35rem;font-size:0.75rem;margin-top:2px;">
                                <div style="display:flex;justify-content:space-between;align-items:center;">
                                    <span style="color:#94a3b8;">Cuenta:</span>
                                    <div style="display:flex;align-items:center;gap:0.4rem;">
                                        <strong style="color:#fff;font-family:monospace;letter-spacing:0.5px;">0116948480</strong>
                                        <button type="button" onclick="_copiarDatoBancario('0116948480', this)" style="background:rgba(59,130,246,0.25);border:1px solid rgba(59,130,246,0.4);color:#bfdbfe;font-size:0.65rem;font-weight:700;padding:1px 6px;border-radius:4px;cursor:pointer;transition:all .15s ease;">Copiar</button>
                                    </div>
                                </div>
                                <div style="display:flex;justify-content:space-between;align-items:center;">
                                    <span style="color:#94a3b8;">CLABE:</span>
                                    <div style="display:flex;align-items:center;gap:0.4rem;">
                                        <strong style="color:#38bdf8;font-family:monospace;letter-spacing:0.5px;">012320001169484807</strong>
                                        <button type="button" onclick="_copiarDatoBancario('012320001169484807', this)" style="background:rgba(59,130,246,0.25);border:1px solid rgba(59,130,246,0.4);color:#bfdbfe;font-size:0.65rem;font-weight:700;padding:1px 6px;border-radius:4px;cursor:pointer;transition:all .15s ease;">Copiar</button>
                                    </div>
                                </div>
                                <div style="display:flex;justify-content:space-between;align-items:center;">
                                    <span style="color:#94a3b8;">Tarjeta:</span>
                                    <strong style="color:#cbd5e1;font-family:monospace;font-size:0.72rem;">4555 1130 0837 4839</strong>
                                </div>
                            </div>
                        </div>

                        <!-- SANTANDER -->
                        <div style="background:linear-gradient(145deg,rgba(153,27,27,0.3),rgba(15,23,42,0.85));border:1px solid rgba(239,68,68,0.35);border-radius:12px;padding:0.95rem;display:flex;flex-direction:column;gap:0.45rem;box-shadow:0 4px 14px rgba(0,0,0,0.25);">
                            <div style="display:flex;align-items:center;justify-content:space-between;padding-bottom:0.45rem;border-bottom:1px solid rgba(255,255,255,0.08);">
                                <div style="display:flex;align-items:center;gap:0.4rem;font-weight:800;color:#f87171;font-size:0.88rem;">
                                    <span style="font-size:1rem;">🔴</span> SANTANDER
                                </div>
                                <span style="font-size:0.68rem;background:rgba(239,68,68,0.18);color:#fca5a5;padding:1px 6px;border-radius:4px;font-weight:700;">Cuenta Oficial</span>
                            </div>
                            <div style="font-size:0.73rem;color:#94a3b8;">
                                Beneficiario: <strong style="color:#f1f5f9;">Dulet International Group, S.A de C.V.</strong>
                            </div>
                            <div style="background:rgba(0,0,0,0.35);border-radius:8px;padding:0.5rem 0.65rem;display:flex;flex-direction:column;gap:0.35rem;font-size:0.75rem;margin-top:2px;">
                                <div style="display:flex;justify-content:space-between;align-items:center;">
                                    <span style="color:#94a3b8;">Cuenta:</span>
                                    <div style="display:flex;align-items:center;gap:0.4rem;">
                                        <strong style="color:#fff;font-family:monospace;letter-spacing:0.5px;">65-50868696-8</strong>
                                        <button type="button" onclick="_copiarDatoBancario('65-50868696-8', this)" style="background:rgba(239,68,68,0.25);border:1px solid rgba(239,68,68,0.4);color:#fca5a5;font-size:0.65rem;font-weight:700;padding:1px 6px;border-radius:4px;cursor:pointer;transition:all .15s ease;">Copiar</button>
                                    </div>
                                </div>
                                <div style="display:flex;justify-content:space-between;align-items:center;">
                                    <span style="color:#94a3b8;">CLABE:</span>
                                    <div style="display:flex;align-items:center;gap:0.4rem;">
                                        <strong style="color:#f87171;font-family:monospace;letter-spacing:0.5px;">014320655086869687</strong>
                                        <button type="button" onclick="_copiarDatoBancario('014320655086869687', this)" style="background:rgba(239,68,68,0.25);border:1px solid rgba(239,68,68,0.4);color:#fca5a5;font-size:0.65rem;font-weight:700;padding:1px 6px;border-radius:4px;cursor:pointer;transition:all .15s ease;">Copiar</button>
                                    </div>
                                </div>
                                <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:0.4rem;">
                                    <span style="color:#94a3b8;">Tarjetas:</span>
                                    <div style="display:flex;flex-direction:column;align-items:flex-end;gap:2px;">
                                        <strong style="color:#cbd5e1;font-family:monospace;font-size:0.72rem;">5579 0890 0286 7821</strong>
                                        <strong style="color:#cbd5e1;font-family:monospace;font-size:0.72rem;">5579 0890 0305 1326</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }
        };

        const linkWa = (paisLider === 'USA') ? `https://wa.me/13468498837?text=${msgWaUsa}` : `https://wa.me/523329347741?text=${msgWaMex}`;
        const txtWaDestino = (paisLider === 'USA') ? 'Sucursal Houston (+1 346 849 8837)' : 'Call Center (+52 33 2934 7741)';

        if (saldoAct <= 0) {
            // 🔒 BLOQUEO TOTAL: El socio no tiene activos disponibles
            if (btnConfirmar) {
                btnConfirmar.disabled = true;
                btnConfirmar.style.opacity = '0.45';
                btnConfirmar.style.cursor = 'not-allowed';
                btnConfirmar.innerHTML = '🔒 Saldo Insuficiente en Activos';
            }

            elNotaLiquidacion.style.background = 'linear-gradient(180deg, rgba(30,15,20,0.7) 0%, rgba(15,23,42,0.85) 100%)';
            elNotaLiquidacion.style.borderColor = 'rgba(239, 68, 68, 0.35)';
            elNotaLiquidacion.style.boxShadow = '0 8px 24px rgba(0,0,0,0.4)';

            elNotaLiquidacion.innerHTML = `
                <!-- Cabecera de Alerta -->
                <div style="display:flex;align-items:flex-start;gap:0.85rem;padding-bottom:0.75rem;border-bottom:1px solid rgba(255,255,255,0.08);">
                    <div style="width:38px;height:38px;border-radius:10px;background:rgba(239,68,68,0.18);border:1px solid rgba(239,68,68,0.35);display:flex;align-items:center;justify-content:center;font-size:1.3rem;flex-shrink:0;">
                        🔒
                    </div>
                    <div style="flex:1;">
                        <div style="display:flex;align-items:center;gap:0.5rem;flex-wrap:wrap;">
                            <strong style="color:#fca5a5;font-size:0.92rem;font-weight:800;letter-spacing:-0.2px;">Saldo Insuficiente en Activos (${fmt(0)})</strong>
                        </div>
                        <div style="font-size:0.78rem;color:#cbd5e1;margin-top:4px;line-height:1.45;">
                            Este portal de autopedido es exclusivo para compras liquidadas con saldo de Activos. Para realizar tu compra vía depósito bancario o transferencia, te proporcionamos las cuentas oficiales:
                        </div>
                    </div>
                </div>

                <!-- Cuentas Bancarias Oficiales en Grid -->
                ${renderCuentasBancariasHtml()}

                <!-- Botón de WhatsApp Ancho Completo -->
                <div style="display:flex;flex-direction:column;gap:0.35rem;margin-top:0.2rem;">
                    <a href="${linkWa}" target="_blank" style="display:flex;align-items:center;justify-content:center;gap:0.6rem;background:linear-gradient(135deg,#22c55e,#16a34a);color:#fff;font-weight:800;font-size:0.88rem;padding:0.75rem 1.2rem;border-radius:10px;text-decoration:none;box-shadow:0 4px 16px rgba(34,197,94,0.35);transition:transform 0.15s ease,box-shadow 0.15s ease;text-align:center;">
                        <span style="font-size:1.25rem;line-height:1;">💬</span>
                        <span>Enviar Ficha por WhatsApp a ${txtWaDestino}</span>
                    </a>
                    <div style="font-size:0.71rem;color:#94a3b8;text-align:center;">
                        ⚡ Al dar clic se abrirá WhatsApp con los datos de tu pedido ya listos para adjuntar tu comprobante bancario
                    </div>
                </div>
            `;
        } else {
            // El socio SÍ tiene activos disponibles
            if (btnConfirmar) {
                btnConfirmar.disabled = false;
                btnConfirmar.style.opacity = '1';
                btnConfirmar.style.cursor = 'pointer';
                btnConfirmar.innerHTML = '🚀 Confirmar y Enviar Pedido';
            }

            if (totalPagar <= 0) {
                elNotaLiquidacion.style.background = 'rgba(34,197,94,0.1)';
                elNotaLiquidacion.style.borderColor = 'rgba(34,197,94,0.3)';
                elNotaLiquidacion.style.color = '#4ade80';
                elNotaLiquidacion.innerHTML = `
                    <div style="display:flex;align-items:center;gap:0.75rem;">
                        <div style="width:34px;height:34px;border-radius:8px;background:rgba(34,197,94,0.2);display:flex;align-items:center;justify-content:center;font-size:1.1rem;color:#4ade80;flex-shrink:0;">✓</div>
                        <div style="flex:1;">
                            <div style="font-weight:800;font-size:0.9rem;color:#4ade80;">100% Cubierto con Activos</div>
                            <div style="font-size:0.77rem;color:#cbd5e1;margin-top:2px;">Tu orden queda completamente liquidada con tu saldo disponible. No requieres realizar ningún pago adicional.</div>
                        </div>
                    </div>
                `;
            } else {
                // Pago híbrido (Activos parciales + remanente por transferencia)
                elNotaLiquidacion.style.background = 'linear-gradient(180deg, rgba(35,25,10,0.6) 0%, rgba(15,23,42,0.85) 100%)';
                elNotaLiquidacion.style.borderColor = 'rgba(245,158,11,0.35)';
                elNotaLiquidacion.style.boxShadow = '0 8px 24px rgba(0,0,0,0.35)';

                elNotaLiquidacion.innerHTML = `
                    <div style="display:flex;align-items:flex-start;gap:0.85rem;padding-bottom:0.75rem;border-bottom:1px solid rgba(255,255,255,0.08);">
                        <div style="width:38px;height:38px;border-radius:10px;background:rgba(245,158,11,0.2);border:1px solid rgba(245,158,11,0.4);display:flex;align-items:center;justify-content:center;font-size:1.2rem;flex-shrink:0;">
                            ⚠️
                        </div>
                        <div style="flex:1;">
                            <div style="display:flex;align-items:center;gap:0.5rem;flex-wrap:wrap;">
                                <strong style="color:#fde047;font-size:0.92rem;font-weight:800;">Liquidación Parcial: Restan ${fmt(totalPagar)}</strong>
                                <span style="background:rgba(245,158,11,0.2);color:#fde047;border:1px solid rgba(245,158,11,0.4);font-size:0.68rem;font-weight:700;padding:1px 7px;border-radius:999px;text-transform:uppercase;">Remanente</span>
                            </div>
                            <div style="font-size:0.78rem;color:#cbd5e1;margin-top:3px;line-height:1.4;">
                                Tus activos cubren <strong>${fmt(activosRestados)}</strong>. Puedes confirmar tu pedido para apartarlo, y liquidar el remanente de <strong>${fmt(totalPagar)}</strong> en las cuentas oficiales:
                            </div>
                        </div>
                    </div>

                    <!-- Cuentas Bancarias Oficiales en Grid -->
                    ${renderCuentasBancariasHtml()}

                    <!-- Botón de WhatsApp Ancho Completo -->
                    <div style="display:flex;flex-direction:column;gap:0.35rem;margin-top:0.2rem;">
                        <a href="${linkWa}" target="_blank" style="display:flex;align-items:center;justify-content:center;gap:0.6rem;background:linear-gradient(135deg,#22c55e,#16a34a);color:#fff;font-weight:800;font-size:0.88rem;padding:0.75rem 1.2rem;border-radius:10px;text-decoration:none;box-shadow:0 4px 16px rgba(34,197,94,0.35);transition:transform 0.15s ease,box-shadow 0.15s ease;text-align:center;">
                            <span style="font-size:1.25rem;line-height:1;">💬</span>
                            <span>Enviar Comprobante del Remanente a ${txtWaDestino}</span>
                        </a>
                        <div style="font-size:0.71rem;color:#94a3b8;text-align:center;">
                            ⚡ Al dar clic se abrirá WhatsApp con los datos de tu pedido ya listos para adjuntar tu comprobante bancario
                        </div>
                    </div>
                `;
            }
        }
    }

    const pInfo = document.getElementById('pedLiderPuntosInfo');
    if (pInfo) {
        if (totalCajas >= 1) {
            pInfo.textContent = `✓ Otorga ${totalCajas} Calificación(es) de Caja oficial(es) para asegurar activos de tu cadena`;
            pInfo.style.color = '#4ade80';
        } else {
            pInfo.textContent = `ℹ️ Pedido de botes individuales o promocionales (requiere 1 caja mensual para calificar tu posición)`;
            pInfo.style.color = '#f59e0b';
        }
    }
}

async function confirmarPedidoLider() {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    if (!user) return;

    let saldoAct = 0;
    if (window.ACTIVOS_BOLSA_GLOBAL && typeof window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible === 'number') {
        saldoAct = window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible;
    } else {
        const dispNode = document.getElementById('activoDisp');
        if (dispNode) {
            const raw = dispNode.textContent.replace(/[^0-9.]/g, '');
            if (raw) saldoAct = parseFloat(raw);
        }
    }

    // 🔒 Candado de seguridad estricto
    if (saldoAct <= 0) {
        BO_AUTH.showAlert('🔒 No cuentas con saldo de activos disponibles para realizar este pedido. Por favor realiza tu pago bancario y envía tu comprobante al WhatsApp oficial.', 'warning');
        return;
    }

    if (!_pedLiderLineas || _pedLiderLineas.length === 0) {
        BO_AUTH.showAlert('Agrega al menos un producto a tu pedido.', 'warning');
        return;
    }

    const paisLider = _pedLiderDetectarPais(user);
    const userMoneda = (paisLider === 'USA' || user?.moneda === 'USD') ? 'USD' : (paisLider === 'GTQ' ? 'GTQ' : 'MXN');
    const symPed = (userMoneda === 'USD' ? '$' : (userMoneda === 'GTQ' ? 'Q' : '$'));
    const symCode = userMoneda;

    let subtotal = 0;
    let totalCajas = 0;
    const items = [];
    const resumenStrings = [];

    // Validar que cualquier Caja Surtida sume exactamente 24 unidades equivalentes por caja (2 Eucament = 1 Dulet)
    for (let i = 0; i < _pedLiderLineas.length; i++) {
        const line = _pedLiderLineas[i];
        const prod = _pedLiderCatalogo.find(p => String(p.id) === String(line.prodId) || p.sku === String(line.prodId));
        if (_pedLiderEsSurtida(prod)) {
            const target = 24 * (line.cant || 1);
            const equiv = _pedLiderCalcMixEquiv(line.mix);
            if (equiv !== target) {
                const diff = target - equiv;
                const msg = diff > 0
                    ? `Faltan ${diff} unidades equivalentes en tu Caja Surtida (Línea #${i + 1}). Recuerda que 2 Eucament = 1 Dulet para sumar ${target}.`
                    : `Tu Caja Surtida (Línea #${i + 1}) se pasa por ${Math.abs(diff)} unidades equivalentes. Debe sumar exactamente ${target}.`;
                BO_AUTH.showAlert(msg, 'warning');
                return;
            }
        }
    }

    _pedLiderLineas.forEach(line => {
        const prod = _pedLiderCatalogo.find(p => String(p.id) === String(line.prodId) || p.sku === String(line.prodId)) || _pedLiderCatalogo[0];
        const unitPrice = userMoneda === 'USD' ? (prod.eu || 0) : (userMoneda === 'GTQ' ? (prod.gua || 0) : (prod.mx || 0));
        const lineSub = line.cant * unitPrice;
        subtotal += lineSub;
        if (prod.esCaja) totalCajas += line.cant;

        let nombreFinal = _pedLiderLimpiarNombre(prod.nombre);
        if (_pedLiderEsSurtida(prod) && line.mix) {
            const m = line.mix;
            const partes = [];
            if (m.nat > 0) partes.push(`${m.nat} Nat`);
            if (m.choco > 0) partes.push(`${m.choco} Choco`);
            if (m.fresa > 0) partes.push(`${m.fresa} Fresa`);
            if (m.vain > 0) partes.push(`${m.vain} Vain`);
            if (m.euca > 0) partes.push(`${m.euca} Euca`);
            if (partes.length > 0) {
                nombreFinal += ` [${partes.join(', ')}]`;
            }
        }

        items.push({
            productoId: prod.id,
            sku: prod.sku,
            cantidad: line.cant,
            precio: unitPrice,
            nombre: nombreFinal,
            mix: line.mix || null,
            subtotal: lineSub
        });

        resumenStrings.push(`${line.cant}x ${nombreFinal}`);
    });

    const selCedis = document.getElementById('pedLiderSelectCedis');
    const selectedVal = selCedis?.value || (paisLider === 'USA' ? '4' : '1');

    let fleteTotal = 0;
    let esSinCosto = false;

    if (paisLider === 'USA') {
        if (selectedVal === '4') {
            fleteTotal = 0;
            esSinCosto = true;
        } else {
            fleteTotal = totalCajas > 0 ? (50 * totalCajas) : 25;
        }
    } else {
        if (selectedVal === '1') {
            fleteTotal = 0;
            esSinCosto = true;
        } else if (selectedVal === '4') {
            fleteTotal = totalCajas > 0 ? (2500 * totalCajas) : 1500;
        } else {
            fleteTotal = totalCajas > 0 ? (250 * totalCajas) : 150;
        }
    }

    const totalOrden = subtotal + fleteTotal;

    const cDestino = _pedLiderCedisList.find(c => String(c.id) === String(selectedVal));
    const dirTexto = (user.calle || user.delegacion || user.ciudad)
        ? `${user.calle || ''} ${user.numero || ''}, ${user.colonia || ''} ${user.ciudad || user.delegacion || ''} ${user.cp ? 'CP ' + user.cp : ''}`.trim()
        : 'Dirección registrada en perfil';

    let entregaDesc = '';
    let cedisPayloadId = '1';

    if (paisLider === 'USA') {
        if (selectedVal === '4') {
            entregaDesc = 'RECOGER EN LLC — USA (Houston, Texas - Sin costo)';
            cedisPayloadId = '4';
        } else {
            entregaDesc = `ENVIO OBLIGATORIO A DOMICILIO USA || Domicilio: ${dirTexto}`;
            cedisPayloadId = '4';
        }
    } else {
        if (selectedVal === '1') {
            entregaDesc = 'RECOGER EN CEDIS GUADALAJARA (Sin costo de flete)';
            cedisPayloadId = '1';
        } else if (selectedVal === '4') {
            entregaDesc = 'ENVIO INTERNACIONAL MEXICO A USA (LLC HOUSTON) || Costo: $2,500.00 MXN/caja';
            cedisPayloadId = '4';
        } else if (selectedVal === 'domicilio') {
            entregaDesc = `ENVIO OBLIGATORIO A DOMICILIO || Domicilio: ${dirTexto}`;
            cedisPayloadId = user.cedis_id ? String(user.cedis_id) : '1';
        } else {
            entregaDesc = `ENVIO OBLIGATORIO A ${cDestino?.nombre?.toUpperCase() || 'CEDIS'} || Dirección: ${cDestino?.direccion || ''}, ${cDestino?.ciudad || ''}`;
            cedisPayloadId = String(selectedVal);
        }
    }

    if (window.ACTIVOS_BOLSA_GLOBAL && typeof window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible === 'number') {
        saldoAct = window.ACTIVOS_BOLSA_GLOBAL.saldoDisponible;
    } else {
        const dispNode = document.getElementById('activoDisp');
        if (dispNode) {
            const raw = dispNode.textContent.replace(/[^0-9.]/g, '');
            if (raw) saldoAct = parseFloat(raw);
        }
    }

    const usarActivos = document.getElementById('pedLiderUsarActivos')?.checked || false;
    let activosRestados = usarActivos ? Math.min(saldoAct, totalOrden) : 0;
    const totalPagar = Math.max(0, totalOrden - activosRestados);

    const btn = document.getElementById('btnConfirmarPedidoLider');
    if (btn) { btn.disabled = true; btn.textContent = 'Procesando pedido...'; }

    try {
        const comentarioFinal = `Pedido Empresario (${paisLider}) || ${resumenStrings.join(' + ')}`
            + ` || Subtotal: ${symPed}${subtotal.toLocaleString('es-MX', {minimumFractionDigits:2})} ${symCode}`
            + (fleteTotal > 0 ? ` || ENVIO ${symPed}${fleteTotal.toLocaleString('es-MX', {minimumFractionDigits:2})} ${symCode}` : '')
            + (activosRestados > 0 ? ` || ACTIVOS ${symPed}${activosRestados.toLocaleString('es-MX', {minimumFractionDigits:2})} ${symCode}` : '')
            + ` || Por pagar: ${symPed}${totalPagar.toLocaleString('es-MX', {minimumFractionDigits:2})} ${symCode}`
            + ` || Entrega: ${entregaDesc}`;

        const clienteIdNum = parseInt(user.id || user.registro || 10700);

        const payload = {
            clienteId: isNaN(clienteIdNum) ? 10700 : clienteIdNum,
            clienteNombre: user.nombre || user.name || 'Empresario Dulet',
            total: totalOrden,
            cajas: totalCajas,
            tipoPago: activosRestados > 0 ? (totalPagar > 0 ? 'Mixto (Activos + Transferencia)' : 'Activos') : 'Transferencia',
            montoActivos: activosRestados,
            monto_activos: activosRestados,
            montoEfectivo: totalPagar,
            comentario: comentarioFinal,
            items: items,
            piezas: items.map(it => ({
                producto_id: it.productoId?.toString(),
                sku: it.sku,
                cantidad: it.cantidad,
                precio_unitario: it.precio
            })),
            creador_registro: 'AUTOPEDIDO',
            creador_id: 'AUTOPEDIDO',
            registradorEmail: 'AUTOPEDIDO',
            estado: 'pendiente',
            cedisId: cedisPayloadId,
            moneda: symCode
        };

        const res = await BO_API.createVenta(payload);
        const folio = res?.id || res?.venta?.id || ('PED-' + Date.now().toString().slice(-6));

        // Sincronizar firma AUTOPEDIDO y monto_activos en tabla venta
        if (folio) {
            try {
                await BO_API.post('/bo/sql-relay', {
                    secret: 'fixdb_2026',
                    sql: `UPDATE venta SET registro_id = 'AUTOPEDIDO'${activosRestados > 0 ? `, monto_activos = ${activosRestados}` : ''} WHERE id = '${folio}'`
                });
            } catch(eAct) { console.warn('Error sync registro_id AUTOPEDIDO pedido lider:', eAct); }
        }

        cerrarModalPedidoLider();

        // Generar y descargar automáticamente la Nota de Venta PDF oficial
        if (typeof generarNotaVentaPDF === 'function') {
            try {
                await generarNotaVentaPDF({
                    numero: folio,
                    notaFull: folio,
                    clienteId: user.registro || user.id,
                    clienteNombre: user.nombre || 'Empresario Dulet',
                    fecha: new Date().toLocaleDateString('es-MX'),
                    tipoPago: payload.tipoPago,
                    subioPorNombre: 'Autopedido',
                    esAutopedido: true,
                    items: items,
                    comentarios: comentarioFinal,
                    total: totalOrden,
                    cedis_id: cedisPayloadId,
                    moneda: symCode
                });
            } catch(errPdf) {
                console.warn('Nota PDF auto-download error:', errPdf);
            }
        }

        const callCenterTel = '523329347741';

        // ══ 2DO POP-UP: Si tiene dinero por liquidar que mande WhatsApp a la empresa ══
        if (totalPagar > 0) {
            BO_AUTH.showAlert(`✓ Pedido #${folio} registrado. Por favor envía tu comprobante al WhatsApp del Call Center para autorizarlo.`, 'info');
            const mPop = document.getElementById('modalPedidoPendienteLiquidacion');
            if (mPop) {
                const elFolio = document.getElementById('popPendienteFolio');
                const elTot = document.getElementById('popPendienteTotal');
                const elAct = document.getElementById('popPendienteActivos');
                const elRest = document.getElementById('popPendienteRestante');
                const btnWa = document.getElementById('btnPopEnviarWaComprobante');

                if (elFolio) elFolio.textContent = `Folio #${folio}`;
                if (elTot) elTot.textContent = `${symPed}${totalOrden.toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}`;
                if (elAct) elAct.textContent = `-${symPed}${activosRestados.toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}`;
                if (elRest) elRest.textContent = `${symPed}${totalPagar.toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}`;

                if (btnWa) {
                    btnWa.onclick = () => {
                        _pedLiderAbrirWaLiquidacion(folio, totalPagar, symPed, symCode, callCenterTel, totalOrden, activosRestados, resumenStrings);
                    };
                }

                mPop.style.display = 'flex';
            } else {
                _pedLiderAbrirWaLiquidacion(folio, totalPagar, symPed, symCode, callCenterTel, totalOrden, activosRestados, resumenStrings);
            }
        } else {
            // 100% Cubierto con Activos
            BO_AUTH.showAlert(`✓ ¡Felicidades! Pedido #${folio} liquidado al 100% con Activos. Se descargó tu Nota de Venta oficial.`, 'success');
            const msgActivos = encodeURIComponent(`¡Hola Corporativo Dulet! Acabo de registrar mi pedido en el Backoffice pagado 100% con Activos:
• Folio: #${folio}
• Socio: ${user.nombre || 'Empresario'} (Reg #${user.registro || ''})
• Pedido: ${resumenStrings.join(' + ')}
• Total: ${symPed}${totalOrden.toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}
• Activos aplicados: ${symPed}${activosRestados.toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}
• Saldo pendiente: $0.00 (Liquidado 100% con Activos)

Favor de autorizar y procesar mi despacho. ¡Muchas gracias!`);
            window.open(`https://wa.me/${callCenterTel}?text=${msgActivos}`, '_blank');
        }

        if (typeof loadDashboardLider === 'function') loadDashboardLider();
    } catch(e) {
        console.error('Error al registrar pedido:', e);
        BO_AUTH.showAlert('Error al registrar pedido: ' + e.message, 'error');
    } finally {
        if (btn) { btn.disabled = false; btn.textContent = '🚀 Confirmar y Enviar Pedido'; }
    }
}

function _pedLiderAbrirWaLiquidacion(folio, totalPagar, symPed, symCode, tel, totalOrden, activosRestados, resumenStrings) {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    const msg = encodeURIComponent(`¡Hola Corporativo Dulet / Call Center! Acabo de registrar mi pedido en el Backoffice:
• Folio: #${folio}
• Socio: ${user?.nombre || 'Empresario'} (Reg #${user?.registro || ''})
${resumenStrings && resumenStrings.length ? '• Pedido: ' + resumenStrings.join(' + ') + '\n' : ''}• Total de la Orden: ${symPed}${Number(totalOrden || totalPagar).toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}
${activosRestados > 0 ? '• Activos aplicados: -' + symPed + Number(activosRestados).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + ' ' + symCode + '\n' : ''}• Saldo pendiente por liquidar: ${symPed}${Number(totalPagar).toLocaleString('es-MX', { minimumFractionDigits: 2 })} ${symCode}

Adjunto aquí mi comprobante de pago para que autoricen y despachen mi pedido. ¡Muchas gracias!`);
    window.open(`https://wa.me/${tel}?text=${msg}`, '_blank');
}

function cerrarModalPedidoPendiente() {
    const m = document.getElementById('modalPedidoPendienteLiquidacion');
    if (m) m.style.display = 'none';
    if (typeof loadDashboardLider === 'function') loadDashboardLider();
}

// ============================================================
// ASISTENTE DE SOPORTE Y CONTACTO INTELIGENTE DEL LÍDER
// ============================================================
async function abrirModalSoporteLider() {
    const user = typeof mirrorUser !== 'undefined' && mirrorUser ? mirrorUser : CURRENT_USER;
    if (!user) return;

    const cedisNomEl = document.getElementById('soporteCedisNombre');
    const cedisBtnWa = document.getElementById('btnSoporteCedisWa');
    let cedisTel = '523329347741';
    let cedisNom = 'CEDIS Guadalajara Matriz';

    if (user.cedis_id) {
        try {
            const rC = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT id, nombre, ciudad, tel FROM cedis WHERE id = ${Number(user.cedis_id)} LIMIT 1`
            });
            if (rC?.rows?.[0]) {
                const rCed = rC.rows[0];
                cedisNom = rCed.nombre + (rCed.ciudad ? ` (${rCed.ciudad})` : '');
                let rawT = rCed.tel ? rCed.tel.replace(/[^0-9]/g, '') : '';
                if (!rawT) {
                    if (String(rCed.id) === '2') rawT = '529986533313';
                    else if (String(rCed.id) === '3') rawT = '529622954781';
                    else if (String(rCed.id) === '4') rawT = '13468498837';
                    else rawT = '523329347741';
                }
                if (rawT) cedisTel = rawT;
            }
        } catch(e) {}
    }
    if (cedisNomEl) cedisNomEl.textContent = cedisNom;
    if (cedisBtnWa) {
        const msgCedis = encodeURIComponent(`¡Hola ${cedisNom}! Te saluda ${user.nombre || 'el socio'} (Reg #${user.registro || ''}). Te contacto desde mi Backoffice Dulet para consultar disponibilidad y horarios de atención. ¡Gracias!`);
        cedisBtnWa.href = `https://wa.me/${cedisTel}?text=${msgCedis}`;
    }

    const patNomEl = document.getElementById('soportePatNombre');
    const patBtnWa = document.getElementById('btnSoportePatWa');
    let patNom = user.patrocinador_nombre || 'Líder Patrocinador';
    let patTel = '';

    // Si user no tiene patrocinador en memoria (ej. modo espejo), buscarlo en BD
    let patId = user.patrocinador;
    if (!patId && user.registro) {
        try {
            const rPatId = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT patrocinador FROM cliente WHERE registro = ${Number(user.registro)} LIMIT 1`
            });
            if (rPatId?.rows?.[0]?.patrocinador) patId = rPatId.rows[0].patrocinador;
        } catch(e) {}
    }

    if (patId) {
        try {
            const rP = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT nombre, ape_p, tel, whatsapp, lada FROM cliente WHERE id = '${patId}' OR registro::text = '${patId}' LIMIT 1`
            });
            if (rP?.rows?.[0]) {
                const rowP = rP.rows[0];
                patNom = (rowP.nombre + ' ' + (rowP.ape_p || '')).trim();
                const rawTel = (rowP.whatsapp || rowP.tel || '').replace(/[^0-9]/g, '');
                if (rawTel.length >= 10) {
                    patTel = rawTel.length === 10 ? '52' + rawTel : rawTel;
                }
            }
        } catch(e) {}
    }
    if (patNomEl) patNomEl.textContent = patNom;
    if (patBtnWa) {
        if (patTel) {
            const msgPat = encodeURIComponent(`¡Hola ${patNom}! Te saluda ${user.nombre || ''} (Reg #${user.registro || ''}) desde mi Backoffice Dulet. Quisiera pedirte apoyo y asesoría con una estrategia de mi cadena. ¿Tienes unos minutos? 🤝`);
            patBtnWa.href = `https://wa.me/${patTel}?text=${msgPat}`;
            patBtnWa.onclick = null;
            patBtnWa.style.opacity = '1';
            patBtnWa.textContent = 'Contactar';
        } else {
            patBtnWa.href = '#';
            patBtnWa.onclick = (e) => {
                e.preventDefault();
                BO_AUTH.showAlert(`Tu patrocinador (${patNom}) no cuenta con WhatsApp registrado en el sistema. Puedes comunicarte con el Corporativo para solicitar apoyo.`, 'info');
            };
            patBtnWa.textContent = 'Sin WhatsApp';
            patBtnWa.style.opacity = '0.7';
        }
    }

    const modal = document.getElementById('modalSoporteLider');
    if (modal) modal.style.display = 'flex';
}

function cerrarModalSoporteLider() {
    const modal = document.getElementById('modalSoporteLider');
    if (modal) modal.style.display = 'none';
}

// ════════════════════════════════════════════════════════════════════
//  PDF: Reporte Ejecutivo (Panorama General)
// ════════════════════════════════════════════════════════════════════
async function exportarReporteEjecutivoPDF() {
    BO_AUTH.showAlert('Generando reporte ejecutivo multimoneda...', 'info');
    if (!window.jspdf || !window.jspdf.jsPDF) {
        BO_AUTH.showAlert('Error: La librería jsPDF no está disponible.', 'danger');
        return;
    }
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ orientation:'portrait', unit:'mm', format:'letter' });
    const W = doc.internal.pageSize.getWidth();
    const H = doc.internal.pageSize.getHeight();
    const M = 12;
    const CW = W - M*2;
    const mesLabel = document.getElementById('mesFiltro')?.selectedOptions?.[0]?.text || 'Mes Actual';
    const mesVal = document.getElementById('mesFiltro')?.value || new Date().toISOString().substring(0,7);
    const hoy = new Date().toLocaleDateString('es-MX',{year:'numeric',month:'long',day:'numeric'});

    // ── Carga de Logotipo Oficial con Fallbacks Robustos ──
    let LOGO = null;
    try {
        const logoPath = (typeof window !== 'undefined' && window.location && window.location.hostname.includes('shopify'))
            ? 'https://cdn.shopify.com/s/files/1/0947/4172/5498/files/dulet_logo.png'
            : '../images/dulet_logo.png';
        const resp = await fetch(logoPath);
        if (resp.ok) {
            const blob = await resp.blob();
            LOGO = await new Promise((ok, no) => {
                const r = new FileReader();
                r.onload = () => ok(r.result);
                r.onerror = no;
                r.readAsDataURL(blob);
            });
        }
    } catch(_) {}

    const f$ = (n, cur = 'MXN') => {
        const v = parseFloat(n || 0);
        return (cur === 'USD' ? 'USD $' : '$') + v.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    const fN = (n) => parseInt(n || 0).toLocaleString();
    const q = async (sql) => {
        try {
            const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
            return r?.rows || [];
        } catch(e) {
            console.warn('[PDF-SQL] Error:', e.message);
            return [];
        }
    };

    // ── Consultas Backend ──
    let S = {};
    try { S = await BO_API.get('/bo/stats?mes=' + mesVal) || {}; } catch(e) {}
    const red = S.red || {};
    const ven = S.ventas || {};
    const galar = S.galardones || {};
    const topLid = S.lideres || [];
    const alertas = S.alertas || [];
    const estadosRaw = S.estados || [];

    const cntActivo   = +(ven.activos_mes || 0);
    const cntNuevo    = +(red.nuevos_mes || 0);
    const cntSeguim   = +(red.seguimiento_mes || 0);
    const cntBaja     = +(red.bajas_mes || 0);
    const totalLid    = +(red.total_lideres || 0);
    const cntInactivo = Math.max(0, totalLid - cntActivo - cntNuevo - cntSeguim - cntBaja);

    // ── Mapeos de Códigos y Países ──
    const _PC = {'MEX':'México','US':'USA','USA':'USA','SV':'El Salvador','SLV':'El Salvador','GT':'Guatemala','GTQ':'Guatemala','CA':'Canadá','CAN':'Canadá'};
    const _ME = {
        '014598a0-d370-11e9-94a8-413ddb507a59':'Baja California','029ff680-57a8-11e8-8d05-79929181b248':'Oaxaca',
        '07134570-d372-11e9-bd26-716eb78766f4':'Zacatecas','0d4a48e0-57a8-11e8-9d0d-377dfdcc79c9':'Chiapas',
        '0d63de50-d36f-11e9-ae52-c13ba8056d04':'Durango','167fdec0-57a8-11e8-8bac-6989538b26ef':'Nayarit',
        '1ed0ba00-d36f-11e9-bf67-ed293dd0cb9f':'Sonora','2a8e4910-57a8-11e8-b9ba-3d71894c4cc3':'Quintana Roo',
        '2e75e6d0-d373-11e9-83f5-91d462e5daf5':'Tabasco','34335fe0-57a8-11e8-9a55-854d55fb4a4a':'Jalisco',
        '3feb3430-57a8-11e8-91d0-fb40960c4613':'Guanajuato','4c137380-57a8-11e8-b91e-8bbb3cf29a0a':'Hidalgo',
        '58818af0-57a8-11e8-aa91-371b44eafe60':'Baja California Sur','61558f00-57a8-11e8-838d-63e374f1e014':'Yucatán',
        '6a97d7e0-57a8-11e8-bc02-5ddc7b57d76c':'Nuevo León','74578500-681d-11e8-b304-3f4379a7f939':'Coahuila',
        '74f93d50-57a8-11e8-88b4-0372eeea8385':'Veracruz','84402450-57a8-11e8-9bc4-498a78714b32':'San Luis Potosí',
        '8a8f9320-681d-11e8-a668-1935f7667ec9':'Guerrero','90714620-57a8-11e8-8f4f-f1d437f47d1b':'Michoacán',
        '98ee0030-57a8-11e8-9968-3f1039cfeb4d':'Colima','a1ecef80-57a7-11e8-89ae-17fe1ea6e5ea':'Estado de México',
        'a1ffe1b0-57a8-11e8-9e98-5f135a95d221':'Sinaloa','ad688210-57a8-11e8-90bf-6336a7843e5d':'Tamaulipas',
        'b6c889d0-5f8a-11e8-ab3e-d17696bebf6e':'Morelos','b6e55130-57a8-11e8-a6dd-57a008358a89':'Puebla',
        'b7ed38b0-57a7-11e8-947a-c7cba2379719':'Querétaro','c3b0e780-57a7-11e8-b135-6d7a8ec0a6c9':'Campeche',
        'c47a9030-d36e-11e9-9465-1d56934626bc':'Chihuahua','cb8fe4e0-d371-11e9-85f2-47f5c01fae6b':'Aguascalientes',
        'cf1258c0-57a7-11e8-b1c5-8dc1d3da9e59':'CDMX','d9f92de0-57a7-11e8-886c-03a56ebe5b67':'CDMX',
        'eddabe90-57a7-11e8-a2cc-bd5da4b34c12':'Estado de México','e14b5720-57a8-11e8-8560-b7db18cc3415':'Puebla',
        'b0d32de0-0898-11ef-a357-4dc05e1337d5':'San Salvador',
        'c4971530-d36f-11e9-ad97-717ee12ae426':'California','eed18220-d371-11e9-bd22-d522251229b1':'Texas',
        '32ac7ba0-d36f-11e9-b454-4b98bc266b23':'Nevada','ea76c110-d36f-11e9-b78c-fb3b0179a0c4':'Arizona',
        '118ed660-d370-11e9-a7ca-e1f338a4e308':'Florida',
        '16930ad0-d373-11e9-9edf-8d2f644f4f31':'Guatemala City','3fea1d70-d373-11e9-88f7-69bb11ca9d59':'Quetzaltenango',
        '3fe10bc0-d373-11e9-81ae-81bac4c5d76c':'Escuintla','2e75e6d0-d373-11e9-83f5-91d462e5daf5':'Petén',
        'f8e0ef50-57a7-11e8-9398-cdc11be37d89':'Tlaxcala','ee7bd3e0-57a8-11e8-9c37-09d2b8fbe52d':'Sonora',
        'f5156f40-57a8-11e8-9085-e7b86a93e36c':'Tabasco'
    };

    // ── Consultar Datos de Ventas y Multimoneda ──
    const KNOWN_BANKS_PDF = [
        'ACT3 (Efectivo)', 'ACTIVOS_TERCEROS', 'ACTIVOS',
        'CHASE BANK', 'MERCADO LIBRE', 'MERCADOPAGO',
        'PAYPAL USA', 'PAYPAL MX', 'ENVIO_EXTRA', 'CREDITO',
        'SANTANDER', 'SHOPIFY', 'STRIPE', 'BBVA', 'CLIP', 'ACT3'
    ];

    const ventasPdf = await q(`SELECT v.id, v.total, v.comentario, v.cedis_id, c.nombre as cliente_nombre, COALESCE(c.pais_id::text, '') as pais_id FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id WHERE to_char(COALESCE(v.fecha_venta, v.created_at), 'YYYY-MM') = '${mesVal}' AND v.approved = 1`);
    const centrosPdf = await q(`SELECT monto, tipo_pago, banco_plataforma, metodo_pago, COALESCE(moneda, 'MXN') as moneda FROM centro_apoyo_pago WHERE to_char(COALESCE(fecha_deposito::timestamptz, creado_en), 'YYYY-MM') = '${mesVal}'`);

    const ingresosMXN = {};
    const ingresosUSD = {};
    let totalVentasMXN_PDF = 0;
    let totalVentasUSD_PDF = 0;
    let totalCreditosMXN_PDF = 0;
    let totalCreditosUSD_PDF = 0;

    ventasPdf.forEach(v => {
        const c = (v.comentario || '').toString();
        const ventaTotal = parseFloat(v.total || 0);
        const isUSD = (String(v.cedis_id) === '4') || /PAYPAL USA|CHASE|ESTADOS UNIDOS|STRIPE USD/i.test(c) || (v.pais_id === 'c4971530-d36f-11e9-ad97-717ee12ae426' || v.pais_id === 'US' || v.pais_id === 'USA');

        let parsedSum = 0;
        const partes = c.split('||').map(s => s.trim());
        partes.forEach(parte => {
            if (!parte) return;
            let matched = false;
            for (const bank of KNOWN_BANKS_PDF) {
                if (parte.toUpperCase().startsWith(bank.toUpperCase())) {
                    const mm = parte.match(/\$\s*([\d,]+(?:\.\d+)?)/);
                    if (mm) {
                        const monto = parseFloat(mm[1].replace(/,/g, ''));
                        if (monto > 0) {
                            let label = bank;
                            if (bank === 'ACTIVOS_TERCEROS') label = 'ACTIVOS (Terceros)';
                            if (bank === 'ACTIVOS') label = 'ACTIVOS (Propios)';
                            if (bank === 'ACT3') label = 'ACT3 (Efectivo)';
                            if (bank === 'CREDITO') label = 'CRÉDITO (Líderes)';

                            const itemIsUSD = isUSD || /CHASE|PAYPAL USA|STRIPE USD/i.test(label);
                            if (label.includes('CRÉDITO')) {
                                if (itemIsUSD) totalCreditosUSD_PDF += monto;
                                else totalCreditosMXN_PDF += monto;
                            } else if (label !== 'ENVIO_EXTRA') {
                                if (itemIsUSD) {
                                    ingresosUSD[label] = (ingresosUSD[label] || 0) + monto;
                                    totalVentasUSD_PDF += monto;
                                } else {
                                    ingresosMXN[label] = (ingresosMXN[label] || 0) + monto;
                                    totalVentasMXN_PDF += monto;
                                }
                            }
                            parsedSum += monto;
                        }
                    }
                    matched = true;
                    break;
                }
            }
            if (!matched) {
                const mm = parte.match(/\$\s*([\d,]+(?:\.\d+)?)/);
                if (mm) {
                    const monto = parseFloat(mm[1].replace(/,/g, ''));
                    if (monto > 0) {
                        let label = parte.split(/[\/$]/)[0].trim().toUpperCase() || 'OTROS';
                        if (label === 'CREDITO' || label === 'CRÉDITO') label = 'CRÉDITO (Líderes)';
                        const itemIsUSD = isUSD || /CHASE|PAYPAL USA|STRIPE USD/i.test(label);
                        if (label.includes('CRÉDITO')) {
                            if (itemIsUSD) totalCreditosUSD_PDF += monto;
                            else totalCreditosMXN_PDF += monto;
                        } else if (label !== 'ENVIO_EXTRA') {
                            if (itemIsUSD) {
                                ingresosUSD[label] = (ingresosUSD[label] || 0) + monto;
                                totalVentasUSD_PDF += monto;
                            } else {
                                ingresosMXN[label] = (ingresosMXN[label] || 0) + monto;
                                totalVentasMXN_PDF += monto;
                            }
                        }
                        parsedSum += monto;
                    }
                }
            }
        });

        if (parsedSum === 0 && ventaTotal > 0) {
            const upper = c.toUpperCase();
            let label = 'OTROS';
            for (const bank of KNOWN_BANKS_PDF) {
                if (bank === 'ENVIO_EXTRA' || bank === 'CREDITO') continue;
                if (upper.includes(bank.toUpperCase())) {
                    label = bank;
                    if (bank === 'ACTIVOS_TERCEROS') label = 'ACTIVOS (Terceros)';
                    if (bank === 'ACTIVOS') label = 'ACTIVOS (Propios)';
                    if (bank === 'ACT3') label = 'ACT3 (Efectivo)';
                    break;
                }
            }
            if (label === 'OTROS') {
                if (upper.includes('TRANSFERENCIA')) label = 'TRANSFERENCIA';
                else if (upper.includes('EFECTIVO')) label = 'EFECTIVO';
                else if (upper.includes('DEPOSITO') || upper.includes('DEPÓSITO')) label = 'DEPÓSITO';
                else if (upper.includes('TARJETA')) label = 'TARJETA';
                else if (upper.includes('ACTIVO')) label = 'ACTIVOS (Propios)';
                else if (upper.includes('CREDITO') || upper.includes('CRÉDITO')) label = 'CRÉDITO (Líderes)';
                else if (!c.trim()) label = 'SIN ESPECIFICAR';
            }
            const itemIsUSD = isUSD || /CHASE|PAYPAL USA|STRIPE USD/i.test(label);
            if (label.includes('CRÉDITO')) {
                if (itemIsUSD) totalCreditosUSD_PDF += ventaTotal;
                else totalCreditosMXN_PDF += ventaTotal;
            } else if (label !== 'ENVIO_EXTRA') {
                if (itemIsUSD) {
                    ingresosUSD[label] = (ingresosUSD[label] || 0) + ventaTotal;
                    totalVentasUSD_PDF += ventaTotal;
                } else {
                    ingresosMXN[label] = (ingresosMXN[label] || 0) + ventaTotal;
                    totalVentasMXN_PDF += ventaTotal;
                }
            }
        }
    });

    centrosPdf.forEach(cp => {
        const monto = parseFloat(cp.monto || 0);
        if (monto > 0) {
            const banco = cp.banco_plataforma || cp.tipo_pago || cp.metodo_pago || 'Pago';
            const label = `🏪 Centro Apoyo (${banco})`;
            const isUSD = (cp.moneda === 'USD') || banco.toUpperCase().includes('CHASE') || banco.toUpperCase().includes('USA');
            if (isUSD) {
                ingresosUSD[label] = (ingresosUSD[label] || 0) + monto;
                totalVentasUSD_PDF += monto;
            } else {
                ingresosMXN[label] = (ingresosMXN[label] || 0) + monto;
                totalVentasMXN_PDF += monto;
            }
        }
    });

    // ── Estilos de Diseño y Helpers ──
    const drawBg = () => {
        doc.setFillColor(15,23,42); doc.rect(0,0,W,H,'F');
        doc.setFillColor(99,102,241); doc.rect(0,0,W,2.5,'F');
        doc.setFillColor(30,41,59); doc.rect(0,2.5,3.5,H,'F');
    };
    const drawHeader = (title, pageNum) => {
        drawBg();
        doc.setFillColor(22,33,54); doc.rect(0,2.5,W,24,'F');
        if (LOGO) {
            try { doc.addImage(LOGO,'PNG',M,5,18,18); } catch(e){}
        } else {
            doc.setFillColor(79,70,229); doc.roundedRect(M, 6, 20, 16, 2, 2, 'F');
            doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor(255,255,255);
            doc.text('DULET', M+10, 16.5, {align:'center'});
        }
        doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(165,180,252);
        doc.text(title, M+24, 15);
        doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor(148,163,184);
        doc.text('DULET INTERNATIONAL GROUP · REPORTE OFICIAL', M+24, 21);
        doc.setFontSize(8); doc.setTextColor(203,213,225);
        doc.text(mesLabel, W-M, 17, {align:'right'});
        doc.setDrawColor(99,102,241); doc.setLineWidth(0.3); doc.line(M,27,W-M,27);
        return 33;
    };
    const drawBar = (x, y, w, h, pct, r, g, b) => {
        doc.setFillColor(30,41,59); doc.roundedRect(x,y,w,h,1,1,'F');
        if (pct > 0) {
            doc.setFillColor(r,g,b);
            doc.roundedRect(x,y,Math.max(w*Math.min(pct,100)/100,2),h,1,1,'F');
        }
    };
    const tblStyles = {fontSize:8, cellPadding:2.8, textColor:[226,232,240], fillColor:[30,41,59], lineColor:[51,65,85], lineWidth:0.2};
    const tblAlt = {fillColor:[22,33,54]};

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 1: PORTADA EJECUTIVA CON MULTIMONEDA ═══
    // ════════════════════════════════════════════════════════════════
    drawBg();
    doc.setFillColor(99,102,241); doc.rect(0,0,W,65,'F');
    doc.setFillColor(79,70,229); doc.rect(0,60,W,8,'F');
    if (LOGO) {
        try { doc.addImage(LOGO,'PNG',W/2-24,70,48,44); } catch(e){}
    } else {
        doc.setFillColor(30,41,59); doc.roundedRect(W/2-25, 74, 50, 36, 4, 4, 'F');
        doc.setFont('helvetica','bold'); doc.setFontSize(16); doc.setTextColor(165,180,252);
        doc.text('DULET', W/2, 96, {align:'center'});
    }

    doc.setFont('helvetica','bold'); doc.setFontSize(26); doc.setTextColor(255,255,255);
    doc.text('REPORTE EJECUTIVO', W/2, 38, {align:'center'});
    doc.setFontSize(11); doc.setTextColor(199,210,254);
    doc.text('Panorama General y Finanzas Multimoneda', W/2, 49, {align:'center'});

    doc.setFontSize(11); doc.setTextColor(148,163,184);
    doc.text('Período Analizado: ' + mesLabel, W/2, 122, {align:'center'});
    doc.setFontSize(8.5); doc.text('Generado el ' + hoy, W/2, 129, {align:'center'});
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(165,180,252);
    doc.text('Dulet International Group S.A. de C.V.', W/2, 136, {align:'center'});

    const kpis = [
        { l:'Líderes Totales', v:fN(totalLid), sub:'En tu cadena', r:226,g:232,b:240 },
        { l:'Líderes Activos', v:fN(cntActivo), sub:'Compraron este mes', r:34,g:197,b:94 },
        { l:'Nuevos Registros', v:fN(cntNuevo), sub:'Afiliados en el mes', r:96,g:165,b:250 },
        { l:'En Seguimiento', v:fN(cntSeguim), sub:'2 meses inactivos', r:245,g:158,b:11 },
        { l:'Bajas Definitivas', v:fN(cntBaja), sub:'3+ meses inactivos', r:239,g:68,b:68 },
        { l:'Ventas México (MXN)', v:f$(totalVentasMXN_PDF), sub:'Operación Nacional', r:16,g:185,b:129 },
        { l:'Ventas USA (USD)', v:totalVentasUSD_PDF > 0 ? f$(totalVentasUSD_PDF, 'USD') : 'USD $0.00', sub:'Operación Internacional', r:59,g:130,b:246 },
        { l:'Créditos Otorgados', v:f$(totalCreditosMXN_PDF), sub: totalCreditosUSD_PDF > 0 ? `+ ${f$(totalCreditosUSD_PDF, 'USD')}` : 'Notas en crédito', r:245,g:158,b:11 }
    ];

    const cardW = (CW - 18) / 4;
    kpis.forEach((k, i) => {
        const col = i % 4;
        const row = Math.floor(i / 4);
        const cx = M + col * (cardW + 6);
        const ccy = 148 + row * 38;
        doc.setFillColor(30,41,59); doc.roundedRect(cx, ccy, cardW, 33, 2.5, 2.5, 'F');
        doc.setFillColor(k.r,k.g,k.b); doc.rect(cx+3, ccy, cardW-6, 1.2, 'F');
        doc.setFont('helvetica','bold'); doc.setFontSize(6.8); doc.setTextColor(148,163,184);
        doc.text(k.l, cx+cardW/2, ccy+9, {align:'center'});
        doc.setFontSize(10.5); doc.setTextColor(k.r,k.g,k.b);
        doc.text(k.v, cx+cardW/2, ccy+20, {align:'center'});
        doc.setFont('helvetica','normal'); doc.setFontSize(6); doc.setTextColor(100,116,139);
        doc.text(k.sub, cx+cardW/2, ccy+27, {align:'center'});
    });

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 2: SEMÁFORO + FINANZAS MULTIMONEDA POR BANCO ═══
    // ════════════════════════════════════════════════════════════════
    doc.addPage('letter','portrait');
    let y = drawHeader('Semáforo y Desglose Financiero Multimoneda', 2);
    
    // Semáforo de Actividad
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(165,180,252);
    doc.text('SEMÁFORO DE ACTIVIDAD DE RED', M, y); y += 4;

    const semTotal = totalLid || 1;
    const semItems = [
        {l:'ACTIVO',     d:'Compró este mes',       cnt:cntActivo,  r:34,g:197,b:94},
        {l:'NUEVO',      d:'Registrado este mes',   cnt:cntNuevo,   r:96,g:165,b:250},
        {l:'INACTIVO',   d:'Sin compra este mes',   cnt:cntInactivo,r:107,g:114,b:128},
        {l:'SEGUIMIENTO',d:'2 meses sin compra',    cnt:cntSeguim,  r:245,g:158,b:11},
        {l:'BAJA',       d:'3+ meses sin compra',   cnt:cntBaja,    r:239,g:68,b:68},
    ];
    semItems.forEach((s,i) => {
        const sy = y + i*13.5;
        const pct = Math.round(s.cnt/semTotal*100);
        doc.setFillColor(22,33,54); doc.roundedRect(M, sy, CW, 11, 2, 2, 'F');
        doc.setFillColor(s.r,s.g,s.b); doc.circle(M+5, sy+5.5, 2, 'F');
        doc.setFont('helvetica','bold'); doc.setFontSize(7.5); doc.setTextColor(s.r,s.g,s.b);
        doc.text(s.l, M+10, sy+4.5);
        doc.setFont('helvetica','normal'); doc.setFontSize(6); doc.setTextColor(148,163,184);
        doc.text(s.d, M+10, sy+8.5);
        doc.setFont('helvetica','bold'); doc.setFontSize(10.5); doc.setTextColor(226,232,240);
        doc.text(fN(s.cnt), W-M-32, sy+6.5, {align:'right'});
        doc.setFontSize(7.5); doc.setTextColor(s.r,s.g,s.b);
        doc.text(pct+'%', W-M-4, sy+6.5, {align:'right'});
        drawBar(M+2, sy+9.5, CW-4, 1.2, pct, s.r, s.g, s.b);
    });
    y += semItems.length * 13.5 + 4;

    // Desglose Financiero Separado por Moneda
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(16,185,129);
    doc.text('OPERACIÓN NACIONAL — BANCOS MÉXICO (MXN)', M, y); y += 4;

    const ingMXNArr = Object.entries(ingresosMXN).sort((a,b) => b[1] - a[1]);
    const totMXN = ingMXNArr.reduce((a,[,v]) => a + v, 0) || 1;
    const topMXN = ingMXNArr.slice(0, 4);
    const maxMXNVal = topMXN[0]?.[1] || 1;

    topMXN.forEach(([k, v]) => {
        const pct = Math.round((v / totMXN) * 100);
        const barW = Math.max((CW - 60) * (v / maxMXNVal), 3);
        const isAct = k.includes('ACTIVOS');
        const [r, g, b] = isAct ? [168, 85, 247] : [16, 185, 129];
        doc.setFillColor(22, 33, 54); doc.roundedRect(M, y, CW, 6, 1, 1, 'F');
        doc.setFillColor(r, g, b); doc.roundedRect(M, y, barW, 6, 1, 1, 'F');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(255, 255, 255);
        doc.text(k.substring(0, 28), M + 3, y + 4.2);
        doc.setFontSize(7); doc.setTextColor(226, 232, 240);
        doc.text(f$(v) + ' (' + pct + '%)', W - M - 3, y + 4.2, { align: 'right' });
        y += 7.2;
    });
    y += 2;

    doc.autoTable({
        startY: y,
        head: [['Banco / Plataforma (México)', 'Monto Recaudado (MXN)', '% Proporción']],
        body: ingMXNArr.length ? ingMXNArr.map(([k,v]) => [k, f$(v), (v/totMXN*100).toFixed(1)+'%']) : [['Sin registros de ventas en pesos', '$0.00', '0%']],
        foot: [['TOTAL NACIONAL RECAUDADO (MXN)', f$(totalVentasMXN_PDF), '100%']],
        styles: tblStyles,
        headStyles: { fillColor: [16,185,129], textColor: [255,255,255] },
        footStyles: { fillColor: [5,150,105], textColor: [255,255,255], fontStyle:'bold' },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M }
    });
    y = doc.lastAutoTable.finalY + 7;

    // Operación Internacional (USD)
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(96,165,250);
    doc.text('OPERACIÓN INTERNACIONAL — PASARELAS Y BANCOS (USD)', M, y); y += 4;

    const ingUSDArr = Object.entries(ingresosUSD).sort((a,b) => b[1] - a[1]);
    const totUSD = ingUSDArr.reduce((a,[,v]) => a + v, 0) || 1;

    doc.autoTable({
        startY: y,
        head: [['Pasarela / Banco Internacional (USA & Global)', 'Monto Recaudado (USD)', '% Proporción']],
        body: ingUSDArr.length ? ingUSDArr.map(([k,v]) => [k, f$(v, 'USD'), (v/totUSD*100).toFixed(1)+'%']) : [['Sin movimientos en dólares en este período', 'USD $0.00', '0%']],
        foot: [['TOTAL INTERNACIONAL RECAUDADO (USD)', f$(totalVentasUSD_PDF, 'USD'), '100%']],
        styles: tblStyles,
        headStyles: { fillColor: [59,130,246], textColor: [255,255,255] },
        footStyles: { fillColor: [29,78,216], textColor: [255,255,255], fontStyle:'bold' },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M }
    });

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 3: BALANCE GENERAL ANUAL Y EVOLUCIÓN HISTÓRICA ═══
    // ════════════════════════════════════════════════════════════════
    doc.addPage('letter','portrait');
    const anioReporte = (mesVal || '2026').substring(0,4);
    y = drawHeader(`Balance General Anual y Evolución — ${anioReporte}`, 3);

    // Consultar datos anuales consolidados
    const sqlAnual = `
    WITH meses AS (
        SELECT to_char(d, 'YYYY-MM') as mes, 
               EXTRACT(MONTH FROM d)::int as mes_num
        FROM generate_series(('${anioReporte}-01-01')::date, ('${anioReporte}-12-01')::date, '1 month') d
    ),
    ventas_mes AS (
        SELECT 
            to_char(COALESCE(v.fecha_venta, v.created_at), 'YYYY-MM') as mes,
            COUNT(v.id) as num_ventas,
            SUM(CASE WHEN v.comentario ILIKE '%ACTIVO%' THEN v.total ELSE 0 END) as activos_ventas,
            SUM(CASE WHEN v.comentario ILIKE '%CREDITO%' OR v.comentario ILIKE '%CRÉDITO%' THEN v.total ELSE 0 END) as creditos_ventas,
            SUM(CASE WHEN v.comentario NOT ILIKE '%ACTIVO%' AND v.comentario NOT ILIKE '%CREDITO%' AND v.comentario NOT ILIKE '%CRÉDITO%' THEN v.total ELSE 0 END) as pagos_ventas,
            SUM(COALESCE(v.total, 0)) as total_ventas
        FROM venta v
        WHERE to_char(COALESCE(v.fecha_venta, v.created_at), 'YYYY') = '${anioReporte}'
          AND v.approved = 1
        GROUP BY to_char(COALESCE(v.fecha_venta, v.created_at), 'YYYY-MM')
    ),
    centros_mes AS (
        SELECT 
            to_char(COALESCE(fecha_deposito::timestamptz, creado_en), 'YYYY-MM') as mes,
            SUM(CASE WHEN tipo_pago ILIKE '%activo%' THEN monto ELSE 0 END) as activos_centros,
            SUM(CASE WHEN tipo_pago NOT ILIKE '%activo%' THEN monto ELSE 0 END) as bancos_centros,
            SUM(COALESCE(monto, 0)) as total_centros
        FROM centro_apoyo_pago
        WHERE to_char(COALESCE(fecha_deposito::timestamptz, creado_en), 'YYYY') = '${anioReporte}'
        GROUP BY to_char(COALESCE(fecha_deposito::timestamptz, creado_en), 'YYYY-MM')
    )
    SELECT 
        m.mes,
        m.mes_num,
        COALESCE(v.num_ventas, 0) as num_ventas,
        ROUND((COALESCE(v.pagos_ventas, 0) + COALESCE(c.bancos_centros, 0))::numeric, 2) as pagos_reales,
        ROUND((COALESCE(v.activos_ventas, 0) + COALESCE(c.activos_centros, 0))::numeric, 2) as activos_canjes,
        ROUND(COALESCE(v.creditos_ventas, 0)::numeric, 2) as creditos_otorgados,
        ROUND((COALESCE(v.total_ventas, 0) + COALESCE(c.total_centros, 0))::numeric, 2) as total_bruto
    FROM meses m
    LEFT JOIN ventas_mes v ON v.mes = m.mes
    LEFT JOIN centros_mes c ON c.mes = m.mes
    ORDER BY m.mes_num ASC;
    `;

    const annualRows = await q(sqlAnual);

    let totAnualPagos = 0, totAnualActivos = 0, totAnualCreditos = 0, totAnualBruto = 0, totAnualNotas = 0;
    annualRows.forEach(r => {
        totAnualPagos += parseFloat(r.pagos_reales || 0);
        totAnualActivos += parseFloat(r.activos_canjes || 0);
        totAnualCreditos += parseFloat(r.creditos_otorgados || 0);
        totAnualBruto += parseFloat(r.total_bruto || 0);
        totAnualNotas += parseInt(r.num_ventas || 0);
    });
    const pctAnualLiquidez = totAnualBruto > 0 ? Math.round((totAnualPagos / totAnualBruto) * 100) : 0;

    // 4 KPI Cards Anuales
    const kpisAnual = [
        { l: 'PAGOS REALES (BANCOS)', v: f$(totAnualPagos), sub: `${totAnualBruto>0?Math.round(totAnualPagos/totAnualBruto*100):0}% Flujo Líquido`, r: 16, g: 185, b: 129 },
        { l: 'ACTIVOS (CANJES)', v: f$(totAnualActivos), sub: `${totAnualBruto>0?Math.round(totAnualActivos/totAnualBruto*100):0}% Canjes Líderes`, r: 168, g: 85, b: 247 },
        { l: 'CRÉDITOS OTORGADOS', v: f$(totAnualCreditos), sub: `${totAnualBruto>0?Math.round(totAnualCreditos/totAnualBruto*100):0}% Por Cobrar`, r: 245, g: 158, b: 11 },
        { l: 'TOTAL BRUTO ANUAL', v: f$(totAnualBruto), sub: `${fN(totAnualNotas)} notas (${pctAnualLiquidez}% liquidez)`, r: 99, g: 102, b: 241 }
    ];

    const cardAnualW = (CW - 15) / 4;
    kpisAnual.forEach((k, i) => {
        const cx = M + i * (cardAnualW + 5);
        doc.setFillColor(30, 41, 59); doc.roundedRect(cx, y, cardAnualW, 25, 2, 2, 'F');
        doc.setFillColor(k.r, k.g, k.b); doc.rect(cx + 2, y, cardAnualW - 4, 1.2, 'F');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(6.2); doc.setTextColor(148, 163, 184);
        doc.text(k.l, cx + cardAnualW / 2, y + 6.5, { align: 'center' });
        doc.setFontSize(9.2); doc.setTextColor(k.r, k.g, k.b);
        doc.text(k.v, cx + cardAnualW / 2, y + 15.5, { align: 'center' });
        doc.setFont('helvetica', 'normal'); doc.setFontSize(5.8); doc.setTextColor(100, 116, 139);
        doc.text(k.sub, cx + cardAnualW / 2, y + 21.5, { align: 'center' });
    });

    y += 30;

    // Visual Bar Progression por mes
    doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.setTextColor(165, 180, 252);
    doc.text(`TENDENCIA MENSUAL: FLUJO LÍQUIDO VS. ACTIVOS Y CRÉDITOS — ${anioReporte}`, M, y); y += 4;

    const MESES_ABR = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    const maxAnualBruto = Math.max(...annualRows.map(d => parseFloat(d.total_bruto || 0))) || 1;

    annualRows.forEach((r, idx) => {
        const mesNom = MESES_ABR[idx];
        const pagos = parseFloat(r.pagos_reales || 0);
        const activos = parseFloat(r.activos_canjes || 0);
        const bruto = parseFloat(r.total_bruto || 0);
        const liqPct = bruto > 0 ? Math.round((pagos / bruto) * 100) : 0;

        const rowH = 5.2;
        const barMaxW = CW - 72;
        const wPagos = (pagos / maxAnualBruto) * barMaxW;
        const wActivos = (activos / maxAnualBruto) * barMaxW;

        doc.setFillColor(22, 33, 54); doc.roundedRect(M, y, CW, rowH, 1, 1, 'F');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(226, 232, 240);
        doc.text(mesNom, M + 3, y + 3.8);

        if (wPagos > 0) {
            doc.setFillColor(16, 185, 129);
            doc.roundedRect(M + 14, y + 1, Math.max(wPagos, 2), rowH - 2, 0.6, 0.6, 'F');
        }
        if (wActivos > 0) {
            doc.setFillColor(168, 85, 247);
            doc.roundedRect(M + 14 + wPagos, y + 1, Math.max(wActivos, 2), rowH - 2, 0.6, 0.6, 'F');
        }

        doc.setFont('helvetica', 'normal'); doc.setFontSize(6.2); doc.setTextColor(148, 163, 184);
        doc.text(`${f$(bruto)}  (${liqPct}% liquidez)`, W - M - 3, y + 3.8, { align: 'right' });

        y += rowH + 1.4;
    });

    y += 2.5;

    // Tabla AutoTable 12 Meses
    const annualTableBody = annualRows.map((r, i) => {
        const pagos = parseFloat(r.pagos_reales || 0);
        const activos = parseFloat(r.activos_canjes || 0);
        const creditos = parseFloat(r.creditos_otorgados || 0);
        const bruto = parseFloat(r.total_bruto || 0);
        const notas = parseInt(r.num_ventas || 0);
        const liqPct = bruto > 0 ? (pagos / bruto * 100).toFixed(1) + '%' : '0%';
        return [
            MESES_ABR[i] + ' (' + r.mes + ')',
            fN(notas),
            f$(pagos),
            f$(activos),
            f$(creditos),
            f$(bruto),
            liqPct
        ];
    });

    doc.autoTable({
        startY: y,
        head: [['Mes', 'Notas', 'Pagos Reales (Bancos)', 'Activos (Canjes)', 'Créditos', 'Total Bruto', '% Liquidez']],
        body: annualTableBody,
        foot: [[
            `TOTAL EJERCICIO ${anioReporte}`,
            fN(totAnualNotas),
            f$(totAnualPagos),
            f$(totAnualActivos),
            f$(totAnualCreditos),
            f$(totAnualBruto),
            (totAnualBruto > 0 ? (totAnualPagos / totAnualBruto * 100).toFixed(1) + '%' : '0%')
        ]],
        styles: tblStyles,
        headStyles: { fillColor: [99, 102, 241], textColor: [255, 255, 255], fontStyle: 'bold' },
        footStyles: { fillColor: [79, 70, 229], textColor: [255, 255, 255], fontStyle: 'bold' },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M },
        columnStyles: {
            0: { cellWidth: 30 },
            1: { halign: 'center', cellWidth: 15 },
            2: { halign: 'right', textColor: [52, 211, 153] },
            3: { halign: 'right', textColor: [192, 132, 252] },
            4: { halign: 'right', textColor: [251, 191, 36] },
            5: { halign: 'right', textColor: [165, 180, 252], fontStyle: 'bold' },
            6: { halign: 'center', cellWidth: 18 }
        }
    });

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 4: GALARDONES + TOP LÍDERES DE RED ═══
    // ════════════════════════════════════════════════════════════════
    doc.addPage('letter','portrait');
    y = drawHeader('Jerarquía Oficial de Liderazgo y Top Líderes', 4);

    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(168,85,247);
    doc.text('JERARQUÍA OFICIAL DE RANGOS ALCANZADOS', M, y); y += 4;

    const HIERARCHY_PDF = ['DIAMANTE', 'ESMERALDA', 'ZAFIRO', 'ORO', 'PLATA', 'BRONCE', 'ACERO'];
    const RANK_COLORS_PDF = {
        'DIAMANTE': [56, 189, 248], 'ESMERALDA': [16, 185, 129], 'ZAFIRO': [99, 102, 241],
        'ORO': [245, 158, 11], 'PLATA': [148, 163, 184], 'BRONCE': [217, 119, 6], 'ACERO': [100, 116, 139]
    };
    const normGal = {};
    Object.entries(galar).forEach(([k, v]) => {
        const u = k.trim().toUpperCase();
        normGal[u] = (normGal[u] || 0) + Number(v || 0);
    });
    const galArr = [];
    HIERARCHY_PDF.forEach(r => {
        if (normGal[r] !== undefined) {
            galArr.push([r.charAt(0) + r.slice(1).toLowerCase(), normGal[r], RANK_COLORS_PDF[r] || [148, 163, 184]]);
            delete normGal[r];
        }
    });
    Object.entries(normGal).forEach(([r, v]) => galArr.push([r.charAt(0) + r.slice(1).toLowerCase(), v, [148, 163, 184]]));
    const galTotal = galArr.reduce((a, b) => a + b[1], 0) || 1;
    const maxGal = Math.max(...galArr.map(g => g[1])) || 1;

    galArr.forEach(([name, count, col]) => {
        const pct = Math.round((count / galTotal) * 100);
        const barW = Math.max((CW - 55) * (count / maxGal), 3);
        doc.setFillColor(22, 33, 54); doc.roundedRect(M, y, CW, 6, 1, 1, 'F');
        doc.setFillColor(col[0], col[1], col[2]); doc.roundedRect(M, y, barW, 6, 1, 1, 'F');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(255, 255, 255);
        doc.text(name, M + 3, y + 4.2);
        doc.text(fN(count) + ' líderes (' + pct + '%)', W - M - 3, y + 4.2, { align: 'right' });
        y += 7.2;
    });
    y += 2;

    doc.autoTable({
        startY: y,
        head: [['Galardón Oficial', 'Número de Líderes', '% de la Cadena']],
        body: galArr.length ? galArr.map(([name, count]) => [name, fN(count), (count/galTotal*100).toFixed(1)+'%']) : [['Sin datos', '0', '0%']],
        styles: tblStyles,
        headStyles: { fillColor: [168,85,247], textColor: [255,255,255] },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M }
    });
    y = doc.lastAutoTable.finalY + 7;

    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(252,211,77);
    doc.text('TOP 15 LÍDERES POR VENTAS DE CADENA (REVENUE DE RED)', M, y); y += 4;

    doc.autoTable({
        startY: y,
        head: [['#', 'Nombre del Líder', 'Registro / ID', 'Ventas de Cadena']],
        body: topLid.length ? topLid.slice(0,15).map((l,i) => [i+1, (l.nombre||'').substring(0,32), l.id || l.registro || '—', l.ventas_red || '—']) : [['—', 'Sin ventas este período', '—', '0']],
        styles: tblStyles,
        headStyles: { fillColor: [245,158,11], textColor: [15,23,42], fontStyle:'bold' },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M },
        columnStyles: { 0:{cellWidth:10, halign:'center'}, 2:{halign:'center'}, 3:{halign:'center', fontStyle:'bold'} }
    });

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 5: VENTAS POR PRODUCTO + DISTRIBUCIÓN POR PAÍS ═══
    // ════════════════════════════════════════════════════════════════
    doc.addPage('letter','portrait');
    y = drawHeader('Ventas por Producto y Presencia Internacional', 5);

    const ventasProd = await q("SELECT COALESCE(pr.nombre, (elem->>'producto_id'), (elem->>'sku'), 'Sin asignar') AS nombre_producto, COUNT(DISTINCT v.id) AS pedidos, SUM(GREATEST(COALESCE((elem->>'cantidad')::numeric, 0), 0)) AS uds, SUM(GREATEST(COALESCE((elem->>'cantidad')::numeric, 0), 0) * GREATEST(COALESCE((elem->>'precio_unitario')::numeric, COALESCE((elem->>'precio')::numeric, 0)), 0)) AS total FROM venta v, LATERAL jsonb_array_elements(CASE WHEN v.piezas IS NOT NULL AND v.piezas::text != '' AND v.piezas::text != '[]' AND v.piezas::text != 'null' THEN v.piezas::jsonb ELSE '[]'::jsonb END) AS elem LEFT JOIN productos pr ON (pr.id::text = (elem->>'producto_id')) OR ((elem->>'producto_id') IS NULL AND pr.sku = (elem->>'sku')) WHERE TO_CHAR(v.fecha_venta,'YYYY-MM')='"+mesVal+"' AND v.approved = 1 GROUP BY COALESCE(pr.nombre, (elem->>'producto_id'), (elem->>'sku'), 'Sin asignar') ORDER BY uds DESC");
    const totProdV = ventasProd.reduce((a,r) => a + parseFloat(r.total || 0), 0);

    // Banner Producto Estrella
    const topProd = ventasProd.length ? ventasProd[0] : null;
    if (topProd) {
        doc.setFillColor(30,41,59); doc.roundedRect(M, y, CW, 17, 2.5, 2.5, 'F');
        doc.setFillColor(252,211,77); doc.rect(M, y, 3.5, 17, 'F');
        doc.setFont('helvetica','bold'); doc.setFontSize(7); doc.setTextColor(148,163,184);
        doc.text('⭐ PRODUCTO ESTRELLA DEL PERÍODO (POR UNIDADES DESPLAZADAS)', M+8, y+6.5);
        doc.setFontSize(11); doc.setTextColor(252,211,77);
        doc.text(topProd.nombre_producto || 'Producto Dulet', M+8, y+13.5);
        doc.setFontSize(8.5); doc.setTextColor(165,180,252);
        doc.text(f$(topProd.total) + '  (' + fN(topProd.uds) + ' unidades)', W-M-6, y+10.5, {align:'right'});
        y += 21;
    }

    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(148,163,184);
    doc.text('DESPLAZAMIENTO POR SABOR Y PRODUCTO (UNIDADES)', M, y); y += 3;

    const topSabores = ventasProd.slice(0, 5);
    const maxProdUds = topSabores[0]?.uds ? parseInt(topSabores[0].uds) : 1;
    const totProdUds = ventasProd.reduce((s, r) => s + parseInt(r.uds || 0), 0) || 1;
    const FLAVOR_COLORS = {
        'fresa': [244, 63, 94], 'natural': [56, 189, 248], 'chocolate': [180, 83, 9],
        'vainilla': [245, 158, 11], 'eucament': [16, 185, 129]
    };
    topSabores.forEach(r => {
        const uName = (r.nombre_producto || '').toLowerCase();
        let col = [99, 102, 241];
        for (const [flv, rgb] of Object.entries(FLAVOR_COLORS)) {
            if (uName.includes(flv)) { col = rgb; break; }
        }
        const uds = parseInt(r.uds || 0);
        const pct = Math.round((uds / totProdUds) * 100);
        const barW = Math.max((CW - 60) * (uds / maxProdUds), 3);
        doc.setFillColor(22, 33, 54); doc.roundedRect(M, y, CW, 6, 1, 1, 'F');
        doc.setFillColor(col[0], col[1], col[2]); doc.roundedRect(M, y, barW, 6, 1, 1, 'F');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(255, 255, 255);
        doc.text((r.nombre_producto || 'Producto').substring(0, 26), M + 3, y + 4.2);
        doc.text(fN(uds) + ' uds (' + pct + '%) · ' + f$(r.total), W - M - 3, y + 4.2, { align: 'right' });
        y += 7.2;
    });
    y += 2;

    doc.autoTable({
        startY: y,
        head: [['Producto / Presentación', 'Notas', 'Unidades', 'Total Recaudado']],
        body: ventasProd.length ? ventasProd.map(r => [
            r.nombre_producto || 'Sin asignar',
            fN(r.pedidos), fN(r.uds), f$(r.total)
        ]) : [['Sin ventas registradas', '--', '--', '$0.00']],
        foot: [['TOTAL PRODUCTOS', '', fN(totProdUds) + ' uds', f$(totProdV)]],
        styles: tblStyles,
        headStyles: { fillColor: [99,102,241], textColor: [255,255,255] },
        footStyles: { fillColor: [79,70,229], textColor: [255,255,255], fontStyle:'bold' },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M },
        columnStyles: { 1:{halign:'center', cellWidth:20}, 2:{halign:'center', cellWidth:22}, 3:{halign:'right', cellWidth:35} }
    });
    y = doc.lastAutoTable.finalY + 7;

    if (y > H - 55) { doc.addPage('letter','portrait'); y = drawHeader('Presencia Internacional de Líderes', 5); }
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(59,130,246);
    doc.text('DISTRIBUCIÓN DE LÍDERES ACTIVOS POR PAÍS', M, y); y += 4;

    const porPais = await q("SELECT COALESCE(p.pais,'México') as pais, COUNT(*) as cnt FROM cliente c LEFT JOIN pais p ON c.pais_id = p.id WHERE c.active_id=1 GROUP BY p.pais ORDER BY cnt DESC LIMIT 10");
    doc.autoTable({
        startY: y,
        head: [['País de Operación', 'Líderes Activos', '% de la Red']],
        body: porPais.map(p => [p.pais, fN(p.cnt), totalLid > 0 ? (parseInt(p.cnt)/totalLid*100).toFixed(1)+'%' : '--']),
        styles: tblStyles,
        headStyles: { fillColor: [59,130,246], textColor: [255,255,255] },
        alternateRowStyles: tblAlt,
        margin: { left: M, right: M },
        columnStyles: { 1:{halign:'center'}, 2:{halign:'center'} }
    });

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 6: DISTRIBUCIÓN GEOGRÁFICA (MÉXICO & USA / INTL) ═══
    // ════════════════════════════════════════════════════════════════
    const heatByPais = {};
    estadosRaw.forEach(e => {
        const pais = _PC[e.pais] || e.pais || 'México';
        const estado = _ME[e.estado] || e.estado || '';
        if (estado.includes('-') && estado.length > 20) return;
        const ventas = +(e.ventas || 0);
        if (ventas <= 0) return;
        if (!heatByPais[pais]) heatByPais[pais] = {};
        heatByPais[pais][estado] = (heatByPais[pais][estado] || 0) + ventas;
    });

    doc.addPage('letter','portrait');
    y = drawHeader('Distribución Geográfica de Ventas', 6);
    doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor(148,163,184);
    doc.text('Notas de venta agrupadas por estado o provincia del líder comprador - ' + mesLabel, M, y); y += 5;

    const heatColors = [
        {min:0.8, r:239,g:68,b:68},  {min:0.6, r:245,g:158,b:11},
        {min:0.4, r:252,g:211,b:77}, {min:0.2, r:96,g:165,b:250},
        {min:0,   r:107,g:114,b:128},
    ];

    // México
    const mexData = heatByPais['México'] || {};
    const mexEdoArr = Object.entries(mexData).sort((a,b) => b[1] - a[1]);
    const maxMexV = mexEdoArr[0]?.[1] || 1;
    const totMexNotas = mexEdoArr.reduce((a,[,v]) => a + v, 0);

    doc.setFillColor(16,185,129); doc.roundedRect(M, y, CW, 7.5, 1.5, 1.5, 'F');
    doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor(255,255,255);
    doc.text('MÉXICO  -  ' + fN(totMexNotas) + ' notas de venta registradas', M+4, y+5);
    y += 10;

    mexEdoArr.slice(0, 15).forEach(([estado, ventas]) => {
        if (y > H - 18) { doc.addPage('letter','portrait'); y = drawHeader('Distribución Geográfica (cont.)', 6); }
        const ratio = ventas / maxMexV;
        const hc = heatColors.find(h => ratio >= h.min) || heatColors[4];
        const barW = Math.max((ventas / maxMexV) * (CW - 60), 4);
        doc.setFillColor(22,33,54); doc.roundedRect(M, y, CW, 6.2, 1, 1, 'F');
        doc.setFillColor(hc.r,hc.g,hc.b); doc.roundedRect(M, y, barW, 6.2, 1, 1, 'F');
        doc.setFont('helvetica','bold'); doc.setFontSize(6.5); doc.setTextColor(255,255,255);
        doc.text(estado, M+3, y+4.5);
        doc.setFontSize(6.5); doc.setTextColor(226,232,240);
        doc.text(fN(ventas) + ' notas', W-M-3, y+4.5, {align:'right'});
        y += 7.5;
    });
    y += 5;

    // Estados Unidos / Internacional
    const intlCountries = Object.entries(heatByPais).filter(([p]) => p !== 'México');
    if (intlCountries.length) {
        if (y > H - 40) { doc.addPage('letter','portrait'); y = drawHeader('Ventas Internacionales por Estado', 6); }
        doc.setFillColor(59,130,246); doc.roundedRect(M, y, CW, 7.5, 1.5, 1.5, 'F');
        doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor(255,255,255);
        doc.text('ESTADOS UNIDOS E INTERNACIONAL', M+4, y+5);
        y += 10;

        intlCountries.forEach(([pais, estados]) => {
            const arr = Object.entries(estados).sort((a,b) => b[1] - a[1]);
            const maxIntl = arr[0]?.[1] || 1;
            arr.forEach(([estado, ventas]) => {
                if (y > H - 18) { doc.addPage('letter','portrait'); y = drawHeader('Ventas Internacionales (cont.)', 6); }
                const barW = Math.max((ventas / maxIntl) * (CW - 60), 4);
                doc.setFillColor(22,33,54); doc.roundedRect(M, y, CW, 6.2, 1, 1, 'F');
                doc.setFillColor(96,165,250); doc.roundedRect(M, y, barW, 6.2, 1, 1, 'F');
                doc.setFont('helvetica','bold'); doc.setFontSize(6.5); doc.setTextColor(255,255,255);
                doc.text(pais + ' · ' + estado, M+3, y+4.5);
                doc.setFontSize(6.5); doc.setTextColor(226,232,240);
                doc.text(fN(ventas) + ' notas', W-M-3, y+4.5, {align:'right'});
                y += 7.5;
            });
        });
    }

    // ════════════════════════════════════════════════════════════════
    // ═══ PÁGINA 7: RETENCIÓN Y ALERTAS DE ACADEMIA ═══
    // ════════════════════════════════════════════════════════════════
    doc.addPage('letter','portrait');
    y = drawHeader('Retención y Alertas de Academia', 7);
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(239,68,68);
    doc.text('LÍDERES EN RIESGO DE DESERCIÓN (2+ MESES SIN COMPRA)', M, y);
    doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor(148,163,184);
    doc.text(alertas.length + ' líderes identificados para seguimiento prioritario', W-M, y, {align:'right'});
    y += 5;

    if (alertas.length) {
        doc.autoTable({
            startY: y,
            head: [['#', 'Nombre del Líder', 'Registro / ID', 'Estado de Riesgo']],
            body: alertas.slice(0, 35).map((a, i) => [
                i+1,
                (a.nombre || '').substring(0, 34),
                a.registro || a.id || '—',
                '⚠️ Requiere llamada de retención'
            ]),
            styles: tblStyles,
            headStyles: { fillColor: [239,68,68], textColor: [255,255,255] },
            alternateRowStyles: tblAlt,
            margin: { left: M, right: M },
            columnStyles: { 0:{cellWidth:10, halign:'center'}, 2:{halign:'center'} }
        });
    } else {
        doc.setFontSize(8.5); doc.setTextColor(34,197,94);
        doc.text('✅ No hay líderes en riesgo de deserción en este período.', M, y+6);
    }

    // ── Pie de Página en Todas las Hojas ──
    const tp = doc.internal.getNumberOfPages();
    for (let i = 1; i <= tp; i++) {
        doc.setPage(i);
        doc.setFillColor(22,33,54); doc.rect(0, H-9, W, 9, 'F');
        doc.setFontSize(6.5); doc.setTextColor(148,163,184);
        doc.text('Confidencial — Dulet International Group S.A. de C.V. — Backoffice Duletia — Pág ' + i + ' de ' + tp, W/2, H-3.5, { align:'center' });
    }

    doc.save('Reporte_Ejecutivo_' + mesLabel.replace(/\s+/g, '_') + '.pdf');
    BO_AUTH.showAlert('Reporte Ejecutivo descargado exitosamente (' + tp + ' páginas).', 'success');
}

// ════════════════════════════════════════════════════════════════════
//  PDF: Reporte Ejecutivo de Producción con Gráficas y Cifras
// ════════════════════════════════════════════════════════════════════
async function exportarReporteProduccionPDF() {
    try {
        BO_AUTH.showAlert('⏳ Generando reporte ejecutivo de producción…', 'info');

        if (!window.jspdf || !window.jspdf.jsPDF) {
            throw new Error('La librería jsPDF no está cargada en el navegador.');
        }

        const { jsPDF } = window.jspdf;
        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const W = doc.internal.pageSize.getWidth();
        const H = doc.internal.pageSize.getHeight();

        // 1. Obtener filtros activos del DOM
        const _pdfDesde = document.getElementById('prodDesde')?.value || '';
        const _pdfHasta = document.getElementById('prodHasta')?.value || '';
        const hoyDate = new Date();
        const pdfDesde = _pdfDesde || `${hoyDate.getFullYear()}-${String(hoyDate.getMonth() + 1).padStart(2, '0')}-01`;
        const pdfHasta = _pdfHasta || hoyDate.toISOString().slice(0, 10);
        const plantaSel = document.getElementById('prodPlantaFiltro')?.value || '';
        const prodSel = document.getElementById('prodProductoFiltro')?.value || '';
        const estadoSel = document.getElementById('prodEstadoFiltro')?.value || '';

        const plantaLabel = plantaSel === 'planta_1' ? 'Planta 1' : (plantaSel === 'planta_2' ? 'Planta 2' : 'Ambas plantas');
        const prodLabelMap = { fresa: 'Dulet Fresa', vainilla: 'Dulet Vainilla', choco: 'Dulet Chocolate', natural: 'Dulet Natural', eucament: 'Eucament' };
        const prodLabel = prodSel ? (prodLabelMap[prodSel] || prodSel) : 'Todos los productos';
        const estadoLabel = estadoSel === 'liberado' ? 'Solo Liberados' : (estadoSel === 'pendiente' ? 'Solo Pendientes' : (estadoSel === 'sin_costo' ? 'Sin Costo' : 'Todos los estados'));

        const mesLabel = `${pdfDesde} a ${pdfHasta}`;
        const fechaGeneracion = hoyDate.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        const f$ = (n) => '$' + parseFloat(n || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const fN = (n) => parseInt(n || 0).toLocaleString('es-MX');

        const q = async (sql) => {
            try {
                const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
                return r?.rows || [];
            } catch (e) {
                console.warn('[PDF Produccion SQL]', e);
                return [];
            }
        };

        // Diccionario de nombres de productos
        const prodRows = await q('SELECT id, nombre, sku FROM productos');
        const P = {};
        prodRows.forEach(p => { P[String(p.id)] = p.nombre; if (p.sku) P[p.sku] = p.nombre; });
        Object.assign(P, {
            fresa: 'Dulet Fresa',
            vainilla: 'Dulet Vainilla',
            choco: 'Dulet Chocolate',
            natural: 'Dulet Natural',
            eucament: 'Eucament',
            abanico: 'Abanico',
            camisa_ch_mc: 'Camisa MC',
            vaso_termico: 'Vaso Térmico',
            'N/A': 'Sin asignar'
        });

        // Cargar logotipo de Duletia
        let LOGO = null;
        try {
            const logoPath = window.location.hostname.includes('shopify')
                ? 'https://cdn.shopify.com/s/files/1/0947/4172/5498/files/dulet_logo.png'
                : '../images/dulet_logo.png';
            const resp = await fetch(logoPath);
            if (resp.ok) {
                const blob = await resp.blob();
                LOGO = await new Promise((res, rej) => {
                    const reader = new FileReader();
                    reader.onload = () => res(reader.result);
                    reader.onerror = rej;
                    reader.readAsDataURL(blob);
                });
            }
        } catch (_) {}

        // 2. Consultar lotes con los filtros exactos de fecha, planta, producto y estado
        const plantaWhere = plantaSel ? `AND planta = '${plantaSel}'` : '';
        const prodWhere = prodSel ? `AND producto_id = '${prodSel}'` : '';
        let estadoWhere = '';
        if (estadoSel === 'liberado') estadoWhere = `AND liberado = true`;
        else if (estadoSel === 'pendiente') estadoWhere = `AND (liberado IS NULL OR liberado = false)`;
        else if (estadoSel === 'sin_costo') estadoWhere = `AND (costo_materia_prima IS NULL OR costo_materia_prima = 0)`;

        const sqlLotes = `
            SELECT id, lote, producto_id, etiquetado_pais, planta, cantidad, costo_materia_prima, operador, fecha, liberado, fecha_liberacion, notas
            FROM produccion_diaria
            WHERE fecha::date BETWEEN '${pdfDesde}' AND '${pdfHasta}'
              ${plantaWhere} ${prodWhere} ${estadoWhere}
            ORDER BY fecha DESC, id DESC
            LIMIT 1000`;

        let lotes = await q(sqlLotes);
        if (!lotes || !lotes.length) {
            if (window._prodLastRows && window._prodLastRows.length) {
                lotes = window._prodLastRows;
            }
        }

        if (!lotes.length) {
            BO_AUTH.showAlert(`⚠️ No se encontraron lotes de producción para el periodo ${mesLabel}.`, 'warning');
            return;
        }

        // Totales y métricas clave
        const totalLotes = lotes.length;
        const totalUds = lotes.reduce((a, r) => a + parseInt(r.cantidad || 0), 0);
        const totalCosto = lotes.reduce((a, r) => a + parseFloat(r.costo_materia_prima || 0), 0);
        const lotesLiberados = lotes.filter(r => r.liberado === true || r.liberado === 't' || r.liberado === 1).length;
        const lotesPendientes = totalLotes - lotesLiberados;
        const pctLiberados = totalLotes > 0 ? ((lotesLiberados / totalLotes) * 100).toFixed(1) : '0.0';
        const pctPendientes = totalLotes > 0 ? ((lotesPendientes / totalLotes) * 100).toFixed(1) : '0.0';
        const costoPromedioUd = totalUds > 0 ? (totalCosto / totalUds).toFixed(2) : '0.00';

        const _pdfRol = (CURRENT_USER?.rol || '').toLowerCase().trim();
        const _pdfVerCostos = _pdfRol !== 'almacen';

        // ════════════════════════════════════════════════════════════
        // PÁGINA 1: ENCABEZADO, KPIS Y GRÁFICAS CON SUS CIFRAS
        // ════════════════════════════════════════════════════════════

        // Header Corporativo
        doc.setFillColor(15, 23, 42); // Slate 900
        doc.rect(0, 0, W, 34, 'F');
        doc.setFillColor(99, 102, 241); // Indigo Accent
        doc.rect(0, 33, W, 1.2, 'F');

        if (LOGO) {
            try { doc.addImage(LOGO, 'PNG', 10, 5, 24, 22); } catch (_) {}
        }

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(15);
        doc.setTextColor(255, 255, 255);
        doc.text('REPORTE EJECUTIVO DE PRODUCCIÓN', 38, 13);

        doc.setFontSize(8.5);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(199, 210, 254);
        doc.text(`Periodo: ${mesLabel}  |  Filtros: ${plantaLabel}, ${prodLabel}, ${estadoLabel}`, 38, 19.5);

        doc.setFontSize(7.5);
        doc.setTextColor(148, 163, 184);
        doc.text(`Dulet Internacional S de RL de CV  •  Emisión: ${fechaGeneracion}`, 38, 26);

        let y = 40;

        // Tarjetas de Resumen KPI (Grid Visual)
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.setTextColor(30, 41, 59);
        doc.text('RESUMEN GENERAL DEL PERIODO', 10, y);
        y += 4;

        const cardW = (W - 20 - 9) / 4; // 4 columnas
        const cardH = 15;

        function drawKpiCard(x, yPos, title, val, sub, bgHex, borderHex, textHex) {
            doc.setFillColor(...bgHex);
            doc.setDrawColor(...borderHex);
            doc.setLineWidth(0.3);
            doc.roundedRect(x, yPos, cardW, cardH, 2, 2, 'FD');

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6.8);
            doc.setTextColor(100, 116, 139);
            doc.text(title.toUpperCase(), x + 4, yPos + 4.5);

            doc.setFontSize(11);
            doc.setTextColor(...textHex);
            doc.text(val, x + 4, yPos + 10);

            if (sub) {
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(6.5);
                doc.setTextColor(100, 116, 139);
                doc.text(sub, x + 4, yPos + 13.5);
            }
        }

        drawKpiCard(10, y, 'Total Lotes', String(totalLotes), 'Registrados en periodo', [241, 245, 249], [203, 213, 225], [15, 23, 42]);
        drawKpiCard(10 + cardW + 3, y, 'Total Unidades', fN(totalUds), 'Piezas producidas', [236, 253, 245], [167, 243, 208], [5, 150, 105]);
        drawKpiCard(10 + (cardW + 3) * 2, y, 'Lotes Liberados', `${lotesLiberados} (${pctLiberados}%)`, 'Aptos para distribución', [238, 242, 255], [199, 210, 254], [79, 70, 229]);
        drawKpiCard(10 + (cardW + 3) * 3, y, 'Lotes Pendientes', `${lotesPendientes} (${pctPendientes}%)`, 'En cuarentena / control', [255, 247, 237], [254, 215, 170], [217, 119, 6]);

        y += cardH + 4;

        if (_pdfVerCostos) {
            const costCardW = (W - 20 - 3) / 2;
            doc.setFillColor(254, 242, 242);
            doc.setDrawColor(254, 202, 202);
            doc.roundedRect(10, y, costCardW, 11, 2, 2, 'FD');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6.8);
            doc.setTextColor(120, 113, 108);
            doc.text('COSTO TOTAL MATERIA PRIMA (MP)', 14, y + 4.5);
            doc.setFontSize(10.5);
            doc.setTextColor(185, 28, 28);
            doc.text(f$(totalCosto), 14, y + 9.5);

            doc.setFillColor(248, 250, 252);
            doc.setDrawColor(226, 232, 240);
            doc.roundedRect(10 + costCardW + 3, y, costCardW, 11, 2, 2, 'FD');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6.8);
            doc.setTextColor(100, 116, 139);
            doc.text('COSTO PROMEDIO POR UNIDAD', 10 + costCardW + 7, y + 4.5);
            doc.setFontSize(10.5);
            doc.setTextColor(30, 41, 59);
            doc.text(`$${costoPromedioUd} MXN / pieza`, 10 + costCardW + 7, y + 9.5);

            y += 15;
        }

        // ── Gráficas de Producción con Cifras Directas (Renderizado Síncrono para PDF)
        let imgMes = null;
        let imgPie = null;

        if (typeof Chart !== 'undefined') {
            try {
                const prodKeys   = ['fresa', 'vainilla', 'choco', 'natural', 'eucament'];
                const prodLabels = ['Fresa', 'Vainilla', 'Chocolate', 'Natural', 'Eucament'];
                const colors     = ['#f43f5e', '#f59e0b', '#a78bfa', '#3b82f6', '#10b981'];

                const normKey = (id) => {
                    const s = String(id || '').toLowerCase().trim();
                    if (s.includes('fresa')) return 'fresa';
                    if (s.includes('vainilla')) return 'vainilla';
                    if (s.includes('choco')) return 'choco';
                    if (s.includes('natural')) return 'natural';
                    if (s.includes('eucament')) return 'eucament';
                    return s;
                };

                const totProd = {};
                prodKeys.forEach(k => totProd[k] = 0);
                lotes.forEach(r => {
                    const k = normKey(r.producto_id);
                    if (totProd[k] !== undefined) totProd[k] += (+r.cantidad || 0);
                });

                const plantas = [...new Set(lotes.map(r => r.planta).filter(Boolean))].sort();
                const hasPlantas = plantas.length > 1;

                // 1. Canvas de Barras (Alta Resolución)
                const cvsBar = document.createElement('canvas');
                cvsBar.width = 620;
                cvsBar.height = 280;
                const ctxBar = cvsBar.getContext('2d');

                let datasetsBar;
                if (hasPlantas) {
                    const plantaColors = ['#6366f1', '#f59e0b', '#ef4444', '#10b981', '#3b82f6'];
                    datasetsBar = plantas.map((planta, pi) => {
                        const data = prodKeys.map(prod => {
                            return lotes.filter(r => r.planta === planta && normKey(r.producto_id) === prod)
                                        .reduce((s, r) => s + (+r.cantidad || 0), 0);
                        });
                        const col = plantaColors[pi % plantaColors.length];
                        return {
                            label: planta === 'planta_1' ? 'Planta 1' : (planta === 'planta_2' ? 'Planta 2' : planta),
                            data,
                            backgroundColor: col,
                            borderRadius: 3
                        };
                    });
                } else {
                    datasetsBar = [{
                        label: 'Unidades',
                        data: prodKeys.map(k => totProd[k]),
                        backgroundColor: colors,
                        borderRadius: 4
                    }];
                }

                const chartBar = new Chart(ctxBar, {
                    type: 'bar',
                    data: { labels: prodLabels, datasets: datasetsBar },
                    options: {
                        animation: false,
                        responsive: false,
                        devicePixelRatio: 1,
                        layout: { padding: { top: 22, left: 10, right: 10, bottom: 8 } },
                        plugins: {
                            legend: {
                                display: hasPlantas,
                                position: 'top',
                                labels: { color: '#1e293b', font: { size: 10, weight: 'bold' } }
                            }
                        },
                        scales: {
                            x: {
                                grid: { display: false },
                                ticks: { color: '#334155', font: { size: 10, weight: 'bold' } }
                            },
                            y: {
                                beginAtZero: true,
                                grid: { color: '#e2e8f0' },
                                ticks: { color: '#64748b', font: { size: 9 }, precision: 0 }
                            }
                        }
                    },
                    plugins: [{
                        id: 'pdfBarLabels',
                        afterDatasetsDraw(chart) {
                            const { ctx } = chart;
                            ctx.save();
                            ctx.font = 'bold 10px Helvetica, Arial, sans-serif';
                            ctx.fillStyle = '#0f172a';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';
                            chart.data.datasets.forEach((dataset, di) => {
                                const meta = chart.getDatasetMeta(di);
                                meta.data.forEach((bar, idx) => {
                                    const val = dataset.data[idx];
                                    if (val && val > 0) {
                                        ctx.fillText(Number(val).toLocaleString() + ' uds', bar.x, bar.y - 3);
                                    }
                                });
                            });
                            ctx.restore();
                        }
                    }]
                });

                // 2. Canvas de Dona (Mix por Producto con cifras y porcentajes)
                const cvsPie = document.createElement('canvas');
                cvsPie.width = 410;
                cvsPie.height = 280;
                const ctxPie = cvsPie.getContext('2d');

                const pieLabelsCifras = prodLabels.map((lbl, i) => {
                    const q = totProd[prodKeys[i]] || 0;
                    const pct = totalUds > 0 ? ((q / totalUds) * 100).toFixed(1) : '0.0';
                    return `${lbl}: ${fN(q)} (${pct}%)`;
                });

                const chartPie = new Chart(ctxPie, {
                    type: 'doughnut',
                    data: {
                        labels: pieLabelsCifras,
                        datasets: [{
                            data: prodKeys.map(k => totProd[k]),
                            backgroundColor: colors,
                            borderWidth: 2,
                            borderColor: '#ffffff'
                        }]
                    },
                    options: {
                        animation: false,
                        responsive: false,
                        devicePixelRatio: 1,
                        layout: { padding: { top: 6, bottom: 6, left: 6, right: 6 } },
                        plugins: {
                            legend: {
                                position: 'bottom',
                                labels: {
                                    color: '#1e293b',
                                    boxWidth: 10,
                                    font: { size: 8.8, weight: 'bold' }
                                }
                            }
                        }
                    },
                    plugins: [{
                        id: 'pdfDoughnutCenter',
                        afterDraw(chart) {
                            const { ctx, chartArea: { left, right, top, bottom } } = chart;
                            if (!left && !right) return;
                            const cx = (left + right) / 2;
                            const cy = (top + bottom) / 2;
                            ctx.save();
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.font = 'bold 9px Helvetica, Arial, sans-serif';
                            ctx.fillStyle = '#64748b';
                            ctx.fillText('TOTAL UDS', cx, cy - 8);
                            ctx.font = 'bold 13px Helvetica, Arial, sans-serif';
                            ctx.fillStyle = '#0f172a';
                            ctx.fillText(fN(totalUds), cx, cy + 7);
                            ctx.restore();
                        }
                    }]
                });

                function renderCleanCard(srcCanvas) {
                    const off = document.createElement('canvas');
                    off.width = srcCanvas.width;
                    off.height = srcCanvas.height;
                    const c = off.getContext('2d');
                    c.fillStyle = '#ffffff';
                    c.fillRect(0, 0, off.width, off.height);
                    c.strokeStyle = '#e2e8f0';
                    c.lineWidth = 1.5;
                    c.strokeRect(1, 1, off.width - 2, off.height - 2);
                    c.drawImage(srcCanvas, 0, 0);
                    return off.toDataURL('image/png');
                }

                imgMes = renderCleanCard(cvsBar);
                imgPie = renderCleanCard(cvsPie);

                chartBar.destroy();
                chartPie.destroy();
            } catch (errChart) {
                console.warn('[PDF] Error generando gráficas:', errChart);
            }
        }

        // También sincronizar las gráficas de pantalla si la función existe
        if (typeof _renderGraficasProduccion === 'function') {
            try { _renderGraficasProduccion(lotes, mesLabel); } catch (_) {}
        }

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.setTextColor(30, 41, 59);
        doc.text('GRÁFICAS DE PRODUCCIÓN Y MIX DEL PERIODO', 10, y);
        y += 4;

        if (imgMes || imgPie) {
            const chartH = 46;
            if (imgMes && imgPie) {
                const w1 = (W - 20 - 4) * 0.60;
                const w2 = (W - 20 - 4) * 0.40;
                doc.addImage(imgMes, 'PNG', 10, y, w1, chartH);
                doc.addImage(imgPie, 'PNG', 10 + w1 + 4, y, w2, chartH);
            } else if (imgMes) {
                doc.addImage(imgMes, 'PNG', 10, y, W - 20, chartH);
            } else if (imgPie) {
                doc.addImage(imgPie, 'PNG', 10, y, W - 20, chartH);
            }
            y += chartH + 6;
        }

        // ── Cifras de las Gráficas (Desglose Numérico Oficial)
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9.5);
        doc.setTextColor(30, 41, 59);
        doc.text('CIFRAS DE LAS GRÁFICAS: DESGLOSE POR PRODUCTO (MIX)', 10, y);
        y += 3;

        // Agrupar cifras de las gráficas
        const porProd = {};
        lotes.forEach(r => {
            const rawId = r.producto_id || 'N/A';
            const k = P[rawId] || rawId;
            if (!porProd[k]) porProd[k] = { uds: 0, costo: 0, lotes: 0, lib: 0, pend: 0 };
            const qUds = parseInt(r.cantidad || 0);
            porProd[k].uds += qUds;
            porProd[k].costo += parseFloat(r.costo_materia_prima || 0);
            porProd[k].lotes++;
            if (r.liberado === true || r.liberado === 't' || r.liberado === 1) porProd[k].lib += qUds;
            else porProd[k].pend += qUds;
        });

        const porProdArr = Object.entries(porProd).sort((a, b) => b[1].uds - a[1].uds);

        doc.autoTable({
            startY: y,
            head: [_pdfVerCostos
                ? ['Producto', 'Lotes', 'Unidades', '% Mix', 'Liberadas', 'Pendientes', 'Costo MP', 'Costo/Ud']
                : ['Producto', 'Lotes', 'Unidades', '% Mix', 'Liberadas', 'Pendientes']],
            body: porProdArr.map(([k, v]) => {
                const pct = totalUds > 0 ? ((v.uds / totalUds) * 100).toFixed(1) + '%' : '0.0%';
                const row = [k, v.lotes, fN(v.uds), pct, fN(v.lib), fN(v.pend)];
                if (_pdfVerCostos) {
                    row.push(f$(v.costo));
                    row.push(v.uds > 0 ? '$' + (v.costo / v.uds).toFixed(2) : '$0.00');
                }
                return row;
            }),
            foot: [_pdfVerCostos
                ? ['TOTAL', totalLotes, fN(totalUds), '100%', fN(lotes.reduce((s, r) => s + (r.liberado ? +r.cantidad || 0 : 0), 0)), fN(lotes.reduce((s, r) => s + (!r.liberado ? +r.cantidad || 0 : 0), 0)), f$(totalCosto), `$${costoPromedioUd}`]
                : ['TOTAL', totalLotes, fN(totalUds), '100%', fN(lotes.reduce((s, r) => s + (r.liberado ? +r.cantidad || 0 : 0), 0)), fN(lotes.reduce((s, r) => s + (!r.liberado ? +r.cantidad || 0 : 0), 0))]],
            styles: { fontSize: 7.2, cellPadding: 1.8, lineColor: [226, 232, 240], lineWidth: 0.1 },
            headStyles: { fillColor: [59, 130, 246], textColor: [255, 255, 255], fontStyle: 'bold' },
            footStyles: { fillColor: [239, 246, 255], textColor: [30, 64, 175], fontStyle: 'bold' },
            alternateRowStyles: { fillColor: [248, 250, 252] },
            columnStyles: {
                1: { halign: 'center' },
                2: { halign: 'right' },
                3: { halign: 'center' },
                4: { halign: 'right' },
                5: { halign: 'right' },
                ...(_pdfVerCostos ? { 6: { halign: 'right' }, 7: { halign: 'right' } } : {})
            }
        });

        y = doc.lastAutoTable.finalY + 6;

        // Desglose por Planta si hay más de 1 planta o para enriquecer
        const porPlanta = {};
        lotes.forEach(r => {
            const k = r.planta === 'planta_1' ? 'Planta 1' : (r.planta === 'planta_2' ? 'Planta 2' : (r.planta || 'Sin planta'));
            if (!porPlanta[k]) porPlanta[k] = { uds: 0, costo: 0, lotes: 0 };
            porPlanta[k].uds += parseInt(r.cantidad || 0);
            porPlanta[k].costo += parseFloat(r.costo_materia_prima || 0);
            porPlanta[k].lotes++;
        });

        if (Object.keys(porPlanta).length > 0) {
            if (y > H - 45) { doc.addPage(); y = 16; }
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(9.5);
            doc.setTextColor(30, 41, 59);
            doc.text('CIFRAS POR PLANTA PRODUCTORA', 10, y);
            y += 3;

            doc.autoTable({
                startY: y,
                head: [_pdfVerCostos
                    ? ['Planta', 'Lotes Elaborados', 'Unidades Totales', '% del Total', 'Costo MP Total', 'Costo Prom/Ud']
                    : ['Planta', 'Lotes Elaborados', 'Unidades Totales', '% del Total']],
                body: Object.entries(porPlanta).map(([k, v]) => {
                    const pct = totalUds > 0 ? ((v.uds / totalUds) * 100).toFixed(1) + '%' : '0.0%';
                    const row = [k, v.lotes, fN(v.uds), pct];
                    if (_pdfVerCostos) {
                        row.push(f$(v.costo));
                        row.push(v.uds > 0 ? '$' + (v.costo / v.uds).toFixed(2) : '$0.00');
                    }
                    return row;
                }),
                styles: { fontSize: 7.2, cellPadding: 1.8 },
                headStyles: { fillColor: [139, 92, 246], textColor: [255, 255, 255], fontStyle: 'bold' },
                alternateRowStyles: { fillColor: [250, 245, 255] },
                columnStyles: {
                    1: { halign: 'center' },
                    2: { halign: 'right' },
                    3: { halign: 'center' },
                    ...(_pdfVerCostos ? { 4: { halign: 'right' }, 5: { halign: 'right' } } : {})
                }
            });
            y = doc.lastAutoTable.finalY + 8;
        }

        // ════════════════════════════════════════════════════════════
        // PÁGINA 2: TABLA DETALLADA DE LOTES DEL FILTRO DE FECHAS
        // ════════════════════════════════════════════════════════════
        doc.addPage();
        y = 15;

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(15, 23, 42);
        doc.text('DETALLE COMPLETO DE LOTES PRODUCIDOS', 10, y);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.5);
        doc.setTextColor(100, 116, 139);
        doc.text(`Mostrando ${lotes.length} lotes correspondientes al filtro aplicado (${mesLabel})`, 10, y + 4.5);
        y += 7;

        doc.autoTable({
            startY: y,
            head: [_pdfVerCostos
                ? ['Fecha', 'Lote', 'Producto', 'País', 'Planta', 'Uds', 'Operador', 'Estado', 'Costo MP']
                : ['Fecha', 'Lote', 'Producto', 'País', 'Planta', 'Uds', 'Operador', 'Estado']],
            body: lotes.map(r => {
                const fStr = r.fecha ? new Date(r.fecha).toLocaleDateString('es-MX', { timeZone: 'UTC' }) : '—';
                const pNombre = P[r.producto_id] || r.producto_id || '—';
                const plantaStr = r.planta === 'planta_1' ? 'Planta 1' : (r.planta === 'planta_2' ? 'Planta 2' : (r.planta || '—'));
                const estadoIcon = (r.liberado === true || r.liberado === 't' || r.liberado === 1) ? '✅ Liberado' : '⏳ Pendiente';

                const row = [
                    fStr,
                    r.lote || '—',
                    pNombre,
                    r.etiquetado_pais || 'México',
                    plantaStr,
                    fN(r.cantidad),
                    r.operador || '—',
                    estadoIcon
                ];
                if (_pdfVerCostos) {
                    row.push(f$(r.costo_materia_prima));
                }
                return row;
            }),
            foot: [_pdfVerCostos
                ? ['TOTALES', `${totalLotes} lotes`, '', '', '', fN(totalUds), '', `${lotesLiberados} lib.`, f$(totalCosto)]
                : ['TOTALES', `${totalLotes} lotes`, '', '', '', fN(totalUds), '', `${lotesLiberados} lib.`]],
            styles: { fontSize: 6.8, cellPadding: 1.6, lineWidth: 0.08, lineColor: [226, 232, 240] },
            headStyles: { fillColor: [79, 70, 229], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 6.8 },
            footStyles: { fillColor: [238, 242, 255], textColor: [49, 46, 129], fontStyle: 'bold', fontSize: 7 },
            alternateRowStyles: { fillColor: [248, 250, 252] },
            columnStyles: {
                0: { cellWidth: 18 },
                1: { cellWidth: 24, fontStyle: 'bold' },
                2: { cellWidth: 32 },
                3: { cellWidth: 16 },
                4: { cellWidth: 16 },
                5: { halign: 'right', cellWidth: 18 },
                6: { cellWidth: 22 },
                7: { halign: 'center', cellWidth: 20 },
                ...(_pdfVerCostos ? { 8: { halign: 'right', cellWidth: 24 } } : {})
            }
        });

        y = doc.lastAutoTable.finalY + 8;

        // ════════════════════════════════════════════════════════════
        // SECCIÓN ADICIONAL: MERMAS Y EXISTENCIAS CEDIS
        // ════════════════════════════════════════════════════════════
        try {
            const mermas = await q(`
                SELECT componente, SUM(cantidad_g) as total_g, SUM(costo_merma) as total_costo, motivo
                FROM mermas_materia_prima
                WHERE fecha::date BETWEEN '${pdfDesde}' AND '${pdfHasta}'
                GROUP BY componente, motivo
                ORDER BY total_g DESC
            `);

            if (mermas && mermas.length > 0) {
                if (y > H - 50) { doc.addPage(); y = 16; }
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(9.5);
                doc.setTextColor(185, 28, 28);
                doc.text('MERMAS DE MATERIA PRIMA EN EL PERIODO', 10, y);
                y += 3;

                doc.autoTable({
                    startY: y,
                    head: [_pdfVerCostos ? ['Materia Prima / Componente', 'Gramos', 'Motivo', 'Costo Merma'] : ['Materia Prima / Componente', 'Gramos', 'Motivo']],
                    body: mermas.map(m => {
                        const row = [m.componente || '—', fN(m.total_g) + ' g', m.motivo || '—'];
                        if (_pdfVerCostos) row.push(f$(m.total_costo));
                        return row;
                    }),
                    styles: { fontSize: 7, cellPadding: 1.5 },
                    headStyles: { fillColor: [239, 68, 68], textColor: [255, 255, 255] },
                    alternateRowStyles: { fillColor: [254, 242, 242] }
                });
                y = doc.lastAutoTable.finalY + 6;
            }
        } catch (_) {}

        // Snapshot de Inventario en Almacenes
        try {
            const inv = await q('SELECT cedis_id, producto_id, cantidad_total FROM inventario_stock WHERE cantidad_total != 0 ORDER BY cedis_id, producto_id');
            const CN = { 'master': 'Bodega Matriz', '0': 'Bodega Matriz', '1': 'CEDIS 1', '2': 'CEDIS 2', '3': 'CEDIS 3', '4': 'LLC USA' };

            if (inv && inv.length > 0) {
                if (y > H - 55) { doc.addPage(); y = 16; }
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(9.5);
                doc.setTextColor(30, 41, 59);
                doc.text('INVENTARIO EN ALMACENES (SNAPSHOT ACTUAL)', 10, y);
                y += 3;

                doc.autoTable({
                    startY: y,
                    head: [['Almacén / CEDIS', 'Producto', 'Stock Disponible']],
                    body: inv.map(r => [
                        CN[String(r.cedis_id)] || `CEDIS ${r.cedis_id}`,
                        P[String(r.producto_id)] || r.producto_id,
                        fN(r.cantidad_total)
                    ]),
                    styles: { fontSize: 7, cellPadding: 1.5 },
                    headStyles: { fillColor: [16, 185, 129], textColor: [255, 255, 255] },
                    alternateRowStyles: { fillColor: [240, 253, 244] },
                    columnStyles: { 2: { halign: 'right' } }
                });
            }
        } catch (_) {}

        // Pie de página en todas las páginas
        const totalPaginas = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPaginas; i++) {
            doc.setPage(i);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(6.5);
            doc.setTextColor(148, 163, 184);
            doc.text(`Dulet Internacional S de RL de CV — Reporte de Producción Confidencial — Página ${i} de ${totalPaginas}`, W / 2, H - 4.5, { align: 'center' });
        }

        const nombreArchivo = `Reporte_Produccion_${pdfDesde}_a_${pdfHasta}.pdf`;
        const blob = doc.output('blob');
        const blobUrl = URL.createObjectURL(blob);
        const win = window.open(blobUrl, '_blank');
        if (!win) {
            doc.save(nombreArchivo);
            BO_AUTH.showAlert(`✅ Reporte de Producción descargado (ventanas emergentes bloqueadas en navegador).`, 'info');
        } else {
            BO_AUTH.showAlert(`✅ Reporte abierto en nueva pestaña para imprimir o guardar (${totalPaginas} págs).`, 'success');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
        }

    } catch (err) {
        console.error('[exportarReporteProduccionPDF]', err);
        BO_AUTH.showAlert('❌ Error al generar el reporte de producción: ' + err.message, 'danger');
    }
}
window.exportarReporteProduccionPDF = exportarReporteProduccionPDF;

async function loadStats() {
    const isAdminView = BO_AUTH.hasRole('admin') || BO_AUTH.hasRole('master') || BO_AUTH.hasRole('cedis');
    let stats = { ...BO_API.MOCK.stats };

    const mesFiltroStr = document.getElementById('mesFiltro')?.value || new Date().toISOString().substring(0,7);

    if (isAdminView) {
        try {
            const liveStats = await BO_API.get('/bo/stats?mes=' + mesFiltroStr);
            if (liveStats && liveStats.red) {
                stats.total_lideres = liveStats.red?.total_lideres || 0;
                stats.cnt_activo = liveStats.ventas?.activos_mes || 0;
                stats.cnt_nuevo = liveStats.red?.nuevos_mes || 0;
                stats.cnt_seguimiento = liveStats.red?.seguimiento_mes || 0;
                stats.cnt_baja = liveStats.red?.bajas_mes || 0;
                
                // Inactivos (Todo el universo menos activos de este mes, los nuevos y los que cayeron en seguimiento o baja)
                stats.cnt_inactivo = Math.max(0, stats.total_lideres - stats.cnt_activo - stats.cnt_nuevo - stats.cnt_seguimiento - stats.cnt_baja);

                stats.ventas_mes = liveStats.ventas?.ventas_mes || 0;
                
                stats.producto_top = liveStats.productos?.producto_top || 'Top Producto'; 
                stats.producto_top_cajas = liveStats.productos?.cajas || 0;

                stats.estados = liveStats.estados || [];
                stats.lideres = liveStats.lideres || [];
                stats.galardones = liveStats.galardones || {};
                stats.alertas = liveStats.alertas || [];
                stats.ventas_credito_centros = liveStats.ventas?.ventas_credito_centros || 0;
                stats.ventas_credito_general = liveStats.ventas?.ventas_credito_general || 0;
                stats.ranking_centros = liveStats.ranking_centros || [];
                window._statsCache = stats;
                
                window.LAST_DASHBOARD_STATS = stats;
            }
        } catch(e) { console.warn('Fallo petición GET /bo/stats de dashboard:', e); }
    }

    // ── Desglose real de ingresos por banco/plataforma ──────────────────────
    // Parsea los montos individuales del campo comentario de cada venta aprobada
    if (isAdminView) {
        try {
            const mesStr = mesFiltroStr;
            const [yy, mm] = mesStr.split('-');
            let rows = [];

            // ── Fuente 1 (principal): sql-relay directo — sin JOIN ni LIMIT, igual que stats ──
            try {
                const sqlIngresos = `SELECT v.id, v.total, v.moneda, v.comentario, v.centro_apoyo_id, v.cedis_id, c.nombre as cliente_nombre, COALESCE(c.pais_id::text, '') as pais_id, p.codigo as pais_cod FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id LEFT JOIN pais p ON c.pais_id = p.id WHERE to_char(COALESCE(v.fecha_venta, v.created_at), 'YYYY-MM') = '${mesStr}' AND v.approved = 1`;
                const relayRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlIngresos });
                rows = relayRes?.rows || [];
                console.log('[DESGLOSE] Fuente 1 (sql-relay):', rows.length, 'ventas aprobadas');
            } catch(e1) {
                console.warn('[DESGLOSE] Fuente 1 (sql-relay) falló:', e1.message);
            }

            // ── Fuente 2: /bo/ventas/list endpoint ──
            if (rows.length === 0) {
                console.log('[DESGLOSE] Fuente 1 vacía, intentando /bo/ventas/list...');
                try {
                    const fDesde = `${yy}-${mm}-01`;
                    const fHasta = `${yy}-${mm}-31`;
                    const ventasMes = await BO_API.post('/bo/ventas/list', { fecha_desde: fDesde, fecha_hasta: fHasta, limit: 5000 });
                    const rawRows = Array.isArray(ventasMes) ? ventasMes : (ventasMes?.rows || []);
                    rows = rawRows.filter(v => v.approved == 1 || v.estado_aprobacion === 'aprobada');
                    console.log('[DESGLOSE] Fuente 2 (/bo/ventas/list):', rawRows.length, 'total,', rows.length, 'aprobadas');
                } catch(e2) {
                    console.warn('[DESGLOSE] Fuente 2 falló:', e2.message);
                }
            }

            // ── Fuente 3 (fallback): _ventasData en memoria ──
            if (rows.length === 0 && typeof _ventasData !== 'undefined' && _ventasData && _ventasData.length > 0) {
                const mesNum = parseInt(mm, 10);
                const anioNum = parseInt(yy, 10);
                rows = _ventasData
                    .filter(v => v.mes === mesNum && v.anio === anioNum && v.estado === 'aprobada')
                    .map(v => ({ total: v.totalNum, moneda: v.moneda, comentario: v.comentarioRaw, centro_apoyo_id: v.centro_apoyo_id }));
                console.log('[DESGLOSE] Fuente 3 (_ventasData cache):', rows.length, 'ventas aprobadas');
            }

            console.log('[DESGLOSE] Total rows para parsing:', rows.length);
            
            const ICON_MAP = {
                'BBVA': '🏦', 'SANTANDER': '🏦', 'CHASE BANK': '🏦',
                'MERCADOPAGO': '📱', 'PAYPAL USA': '💳', 'PAYPAL MX': '💳',
                'CLIP': '💳', 'STRIPE (USD)': '💳', 'STRIPE': '💳', 'SHOPIFY': '🛒', 'MERCADO LIBRE': '🛒',
                'ACT3 (Efectivo)': '💵', 'ACT3': '💵',
                'ACTIVOS': '♻️', 'ACTIVOS_TERCEROS': '♻️',
                'CREDITO': '📝', 'ENVIO_EXTRA': '🚚'
            };
            const KNOWN_BANKS = [
                'ACT3 (Efectivo)', 'ACTIVOS_TERCEROS', 'ACTIVOS',
                'CHASE BANK', 'MERCADO LIBRE', 'MERCADOPAGO',
                'PAYPAL USA', 'PAYPAL MX', 'ENVIO_EXTRA', 'CREDITO',
                'SANTANDER', 'SHOPIFY', 'STRIPE', 'BBVA', 'CLIP', 'ACT3'
            ];
            
            const desgloseNotas = {};
            const desgloseCentros = {};
            let totalNotasMXN = 0, totalNotasUSD = 0;
            let creditosNotasMXN = 0, creditosNotasUSD = 0;
            let totalCentrosMXN = 0, totalCentrosUSD = 0;
            let creditosCentrosMXN = 0, creditosCentrosUSD = 0;
            let totalActivosMXN = 0, totalActivosUSD = 0;
            let totalPagosMXN = 0, totalPagosUSD = 0;

            const isUSDRecord = (bank, c, v) => {
                const b = (bank || '').toUpperCase();
                if (b.includes('CHASE') || b.includes('PAYPAL USA') || b.includes('STRIPE USD') || b.includes('STRIPE (USD)')) return true;
                if (v) {
                    if (v.moneda === 'USD') return true;
                    if (v.moneda === 'MXN') return false;
                    if (String(v.cedis_id) === '4') return true;
                    if (v.pais_id === 'dc401520-c6ad-11e9-ba63-817bdbdb3cf7' || v.pais_id === 'c4971530-d36f-11e9-ad97-717ee12ae426' || v.pais_id === 'US' || v.pais_id === 'USA') return true;
                    if (v.pais_cod === 'USA' || v.pais_codigo === 'USA' || v.codigo === 'USA') return true;
                    const cUpper = ((c || v.comentario || '')).toString().toUpperCase();
                    if (cUpper.includes('CHASE') || cUpper.includes('PAYPAL USA') || cUpper.includes('ESTADOS UNIDOS') || cUpper.includes('STRIPE USD') || cUpper.includes('EEUU') || cUpper.includes('U.S.A.') || cUpper.includes('USA')) return true;
                }
                const comm = ((c || (v && v.comentario) || '')).toString().toUpperCase();
                if (comm.includes('ESTADOS UNIDOS') || comm.includes('PAYPAL USA') || comm.includes('CHASE') || comm.includes('STRIPE USD') || comm.includes('EEUU') || comm.includes('U.S.A.') || comm.includes('USA')) return true;
                return false;
            };
            window._isVentaUSD = (v, c) => isUSDRecord(null, c, v);

            const normalizeBankLabel = (rawBank, isUSD) => {
                if (!rawBank) return 'OTROS';
                let b = rawBank.trim();
                const upper = b.toUpperCase();
                if (/ENVIO|ENVÍO|FALTO|FALTÓ|GUIA|GUÍA|PAQUET/i.test(upper)) return 'ENVIO_EXTRA';
                if (upper === 'CREDITO' || upper === 'CRÉDITO' || upper.startsWith('CREDIT')) return 'CRÉDITO (Líderes)';
                if (upper === 'CENTRO DE APOYO' || upper === 'CRÉDITO CENTROS') return 'CRÉDITO (Centros)';
                if (upper.includes('PAYPAL MX') || upper.includes('PAYPAL_MX') || upper === 'PAYPALMX') return 'PAYPAL MX';
                if (upper.includes('PAYPAL USA') || upper.includes('PAYPAL_USA') || upper === 'PAYPALUSA') return 'PAYPAL USA';
                if (upper.includes('PAYPAL')) return isUSD ? 'PAYPAL USA' : 'PAYPAL MX';
                if (upper.includes('STRIPE USA') || upper.includes('STRIPE USD') || upper.includes('STRIPE_USA') || upper.includes('STRIPE_USD')) return 'STRIPE (USD)';
                if (upper.includes('STRIPE MX') || upper.includes('STRIPE_MX') || upper === 'STRIPEMX') return 'STRIPE';
                if (upper.includes('STRIPE')) return isUSD ? 'STRIPE (USD)' : 'STRIPE';
                if (upper.includes('CHASE') || upper.includes('ZELLE') || upper.includes('BANK OF AMERICA') || upper.includes('WELLS FARGO')) return 'CHASE BANK';
                if (upper === 'ACTIVOS_TERCEROS' || upper.includes('TERCERO')) return 'ACTIVOS (Terceros)';
                if (upper === 'ACT3' || upper.includes('ACT3')) return 'ACT3 (Efectivo)';
                if (upper.includes('ACTIVO')) return isUSD ? 'ACTIVOS (USA)' : 'ACTIVOS (Propios)';
                if (upper.includes('MERCADO')) return upper.includes('LIBRE') ? 'MERCADO LIBRE' : 'MERCADOPAGO';
                if (upper.includes('BBVA') || upper.includes('BANCOMER')) return 'BBVA';
                if (upper.includes('SANTANDER')) return 'SANTANDER';
                if (upper.includes('CLIP')) return 'CLIP';
                if (upper.includes('SHOPIFY')) return 'SHOPIFY';
                if (upper.includes('TRANSFERENCIA')) return 'TRANSFERENCIA';
                if (upper.includes('EFECTIVO')) return 'EFECTIVO';
                if (upper.includes('DEPOSITO') || upper.includes('DEPÓSITO')) return 'DEPÓSITO';
                if (upper.includes('TARJETA')) return 'TARJETA';
                if (b.length > 20 || /NOTA|FOLIO|PEDIDO|OBSERV|CLIENTE|DESGLOSE/i.test(upper)) return 'OTROS';
                return b;
            };
            window._normalizeBankLabel = normalizeBankLabel;

            rows.forEach(v => {
                const c = (v.comentario || '').toString();
                const ventaTotal = parseFloat(v.total || 0);
                const isCentro = Boolean(
                    (v.centro_apoyo_id && String(v.centro_apoyo_id).trim() !== '' && String(v.centro_apoyo_id) !== '0' && String(v.centro_apoyo_id) !== 'null') ||
                    (v.cliente_nombre && /centro/i.test(v.cliente_nombre)) ||
                    (c && /centro/i.test(c))
                );
                const targetDesglose = isCentro ? desgloseCentros : desgloseNotas;

                let parsedSum = 0;
                
                const isVentaEnUSD = isUSDRecord(null, c, v);
                const partes = c.split('||').map(s => s.trim());
                partes.forEach(parte => {
                    if (!parte) return;
                    let matched = false;
                    for (const bank of KNOWN_BANKS) {
                        if (parte.toUpperCase().startsWith(bank.toUpperCase())) {
                            const montoMatch = parte.match(/\$\s*([\d,]+(?:\.\d+)?)/);
                            if (montoMatch) {
                                const monto = parseFloat(montoMatch[1].replace(/,/g, ''));
                                if (monto > 0) {
                                    const label = normalizeBankLabel(bank, isVentaEnUSD);
                                    targetDesglose[label] = (targetDesglose[label] || 0) + monto;
                                    parsedSum += monto;

                                    if (label.includes('CRÉDITO') || label.includes('CREDITO')) {
                                        if (isVentaEnUSD) creditosNotasUSD += monto;
                                        else creditosNotasMXN += monto;
                                    } else if (label !== 'ENVIO_EXTRA') {
                                        if (isVentaEnUSD) {
                                            totalNotasUSD += monto;
                                            if (label.includes('ACTIVO') || label.includes('ACT3')) totalActivosUSD = (totalActivosUSD || 0) + monto;
                                            else totalPagosUSD += monto;
                                        } else {
                                            totalNotasMXN += monto;
                                            if (label.includes('ACTIVO') || label.includes('ACT3')) totalActivosMXN += monto;
                                            else totalPagosMXN += monto;
                                        }
                                    }
                                }
                            }
                            matched = true;
                            break;
                        }
                    }
                    if (!matched) {
                        const montoMatch = parte.match(/\$\s*([\d,]+(?:\.\d+)?)/);
                        if (montoMatch) {
                            const monto = parseFloat(montoMatch[1].replace(/,/g, ''));
                            if (monto > 0) {
                                const rawPart = parte.split(/[/$]/)[0].trim();
                                const label = normalizeBankLabel(rawPart, isVentaEnUSD);
                                targetDesglose[label] = (targetDesglose[label] || 0) + monto;
                                parsedSum += monto;

                                if (label.includes('CRÉDITO') || label.includes('CREDITO')) {
                                    if (isVentaEnUSD) creditosNotasUSD += monto;
                                    else creditosNotasMXN += monto;
                                } else if (label !== 'ENVIO_EXTRA') {
                                    if (isVentaEnUSD) {
                                        totalNotasUSD += monto;
                                        if (label.includes('ACTIVO') || label.includes('ACT3')) totalActivosUSD = (totalActivosUSD || 0) + monto;
                                        else totalPagosUSD += monto;
                                    } else {
                                        totalNotasMXN += monto;
                                        if (label.includes('ACTIVO') || label.includes('ACT3')) totalActivosMXN += monto;
                                        else totalPagosMXN += monto;
                                    }
                                }
                            }
                        }
                    }
                });
                
                if (parsedSum === 0 && ventaTotal > 0) {
                    const upper = c.toUpperCase();
                    let rawLabel = 'OTROS';
                    for (const bank of KNOWN_BANKS) {
                        if (bank === 'ENVIO_EXTRA' || bank === 'CREDITO') continue;
                        if (upper.includes(bank.toUpperCase())) {
                            rawLabel = bank;
                            break;
                        }
                    }
                    if (rawLabel === 'OTROS') {
                        if (upper.includes('TRANSFERENCIA')) rawLabel = 'TRANSFERENCIA';
                        else if (upper.includes('EFECTIVO')) rawLabel = 'EFECTIVO';
                        else if (upper.includes('DEPOSITO') || upper.includes('DEPÓSITO')) rawLabel = 'DEPÓSITO';
                        else if (upper.includes('TARJETA')) rawLabel = 'TARJETA';
                        else if (upper.includes('ACTIVO')) rawLabel = 'ACTIVOS (Propios)';
                        else if (upper.includes('CENTRO DE APOYO')) rawLabel = 'CRÉDITO (Centros)';
                        else if (upper.includes('CREDITO') || upper.includes('CRÉDITO')) rawLabel = 'CRÉDITO (Líderes)';
                        else if (!c.trim()) rawLabel = 'SIN ESPECIFICAR';
                    }
                    const label = normalizeBankLabel(rawLabel, isVentaEnUSD);
                    targetDesglose[label] = (targetDesglose[label] || 0) + ventaTotal;

                    if (label.includes('CRÉDITO') || label.includes('CREDITO')) {
                        if (isVentaEnUSD) creditosNotasUSD += ventaTotal;
                        else creditosNotasMXN += ventaTotal;
                    } else if (label !== 'ENVIO_EXTRA') {
                        if (isVentaEnUSD) {
                            totalNotasUSD += ventaTotal;
                            if (label.includes('ACTIVO') || label.includes('ACT3')) totalActivosUSD = (totalActivosUSD || 0) + ventaTotal;
                            else totalPagosUSD += ventaTotal;
                        } else {
                            totalNotasMXN += ventaTotal;
                            if (label.includes('ACTIVO') || label.includes('ACT3')) totalActivosMXN += ventaTotal;
                            else totalPagosMXN += ventaTotal;
                        }
                    }
                }
            });
            
            // ── Cargar también pagos registrados de tabla centro_apoyo_pago ──
            try {
                const sqlCentros = `SELECT monto, tipo_pago, banco_plataforma, metodo_pago, COALESCE(moneda, 'MXN') as moneda FROM centro_apoyo_pago WHERE to_char(COALESCE(fecha_deposito::timestamptz, creado_en), 'YYYY-MM') = '${mesStr}'`;
                const resCentros = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlCentros });
                (resCentros.rows || []).forEach(cp => {
                    const monto = parseFloat(cp.monto || 0);
                    if (monto > 0) {
                        const banco = cp.banco_plataforma || cp.tipo_pago || cp.metodo_pago || 'Pago';
                        const label = `🏪 Centro Apoyo (${banco})`;
                        desgloseCentros[label] = (desgloseCentros[label] || 0) + monto;
                        const isUSD = (cp.moneda === 'USD') || banco.toUpperCase().includes('CHASE') || banco.toUpperCase().includes('USA');
                        const esActivo = banco.toUpperCase().includes('ACTIVO') || banco.toUpperCase().includes('ACT3') || (cp.tipo_pago && cp.tipo_pago.toUpperCase().includes('ACTIVO'));

                        if (isUSD) {
                            totalCentrosUSD += monto;
                            if (esActivo) totalActivosUSD = (totalActivosUSD || 0) + monto;
                            else totalPagosUSD += monto;
                        } else {
                            totalCentrosMXN += monto;
                            if (esActivo) {
                                totalActivosMXN += monto;
                            } else {
                                totalPagosMXN += monto;
                            }
                        }
                    }
                });
            } catch(eCentros) {
                console.warn('[DESGLOSE] Error al consultar centro_apoyo_pago:', eCentros.message);
            }

            // Construir desgloseNotasMap con íconos
            const desgloseNotasMap = {};
            let totalNotasSum = 0;
            Object.entries(desgloseNotas)
                .filter(([k]) => k !== 'ENVIO_EXTRA' && !k.toUpperCase().includes('ENVIO') && !k.toUpperCase().includes('ENVÍO') && !k.includes('CRÉDITO') && !k.includes('CREDITO'))
                .sort((a, b) => b[1] - a[1])
                .forEach(([k, v]) => {
                    const icon = ICON_MAP[k] || '💰';
                    desgloseNotasMap[`${icon} ${k}`] = v;
                    totalNotasSum += v;
                });

            // Construir desgloseCentrosMap con íconos
            const desgloseCentrosMap = {};
            let totalCentrosSum = 0;
            Object.entries(desgloseCentros)
                .filter(([k]) => k !== 'ENVIO_EXTRA' && !k.toUpperCase().includes('ENVIO') && !k.toUpperCase().includes('ENVÍO') && !k.includes('CRÉDITO') && !k.includes('CREDITO'))
                .sort((a, b) => b[1] - a[1])
                .forEach(([k, v]) => {
                    const icon = k.startsWith('🏪') ? '' : (ICON_MAP[k] || '💰 ');
                    desgloseCentrosMap[`${icon}${k}`] = v;
                    totalCentrosSum += v;
                });

            // Combinar ambos para desgloseTodosMap
            const desgloseTodosMap = {};
            Object.entries(desgloseNotasMap).forEach(([k, v]) => {
                desgloseTodosMap[k] = (desgloseTodosMap[k] || 0) + v;
            });
            Object.entries(desgloseCentrosMap).forEach(([k, v]) => {
                desgloseTodosMap[k] = (desgloseTodosMap[k] || 0) + v;
            });

            window._desgloseCache = {
                todos: Object.keys(desgloseTodosMap).length ? desgloseTodosMap : { '📉 Sin ventas': 0 },
                notas: Object.keys(desgloseNotasMap).length ? desgloseNotasMap : { '📝 Sin notas de venta directas': 0 },
                centros: Object.keys(desgloseCentrosMap).length ? desgloseCentrosMap : { '🏪 Sin pagos de centros': 0 }
            };
            window._lastStatsRef = stats;

            const filtroAct = document.getElementById('dashFiltroPagos')?.value || 'todos';
            stats.ingresos = window._desgloseCache[filtroAct] || desgloseTodosMap;
            
            const totalVentasMXN = totalNotasMXN + totalCentrosMXN;
            const totalVentasUSD = totalNotasUSD + totalCentrosUSD;
            const totalCreditosMXN = creditosNotasMXN + creditosCentrosMXN;
            const totalCreditosUSD = creditosNotasUSD + creditosCentrosUSD;

            stats.ventas_mes_mxn = totalVentasMXN;
            stats.ventas_mes_usd = totalVentasUSD;
            stats.ventas_mes = totalVentasMXN;
            stats.creditos_mes_mxn = totalCreditosMXN;
            stats.creditos_mes_usd = totalCreditosUSD;
            stats.creditos_totales = totalCreditosMXN;
            stats.pagos_reales_mxn = totalPagosMXN;
            stats.pagos_reales_usd = totalPagosUSD;
            stats.activos_mxn = totalActivosMXN;

            const totalGeneral = totalVentasMXN + totalVentasUSD;
            if (totalGeneral > 0) {
                window._desgloseVentasData = rows;
            }
            if (!Object.keys(stats.ingresos).length) {
                stats.ingresos = { '📉 Sin ventas este mes': 0 };
            }
            if (!Object.keys(stats.ingresos).length) {
                stats.ingresos = { '📉 Sin ventas este mes': 0 };
            }
        } catch(e) {
            console.warn('Desglose de ingresos por banco falló, usando categorías genéricas:', e);
            // Fallback to generic categories from backend
            const liveVentas = window.LAST_DASHBOARD_STATS?.ventas_mes ? window.LAST_DASHBOARD_STATS : stats;
            stats.ingresos = {
                '💵 Efectivo': liveVentas.ventas_efectivo || 0,
                '💳 Transferencia': liveVentas.ventas_transferencia || 0,
                '🏦 Depósito': liveVentas.ventas_deposito || 0,
                '♻️ Canje de Activos': liveVentas.ventas_activos || 0,
                '📉 Otros / Sin especificar': liveVentas.ventas_otros || 0
            };
        }
    }

    if (isAdminView) {
        if (typeof renderSemaforoCards === 'function') {
            renderSemaforoCards(window.LIDERES_DATA, stats);
        }
    }

    // Mapear UUIDs legacy (MariaDB) de cliente.estado_id → nombre para el heatmap
    const mapEstados = {
        // ── México ──────────────────────────────────────────────────────────
        '014598a0-d370-11e9-94a8-413ddb507a59': 'Baja California',
        '029ff680-57a8-11e8-8d05-79929181b248': 'Oaxaca',
        '07134570-d372-11e9-bd26-716eb78766f4': 'Zacatecas',
        '0d4a48e0-57a8-11e8-9d0d-377dfdcc79c9': 'Chiapas',
        '0d63de50-d36f-11e9-ae52-c13ba8056d04': 'Durango',
        '167fdec0-57a8-11e8-8bac-6989538b26ef': 'Nayarit',
        '1ed0ba00-d36f-11e9-bf67-ed293dd0cb9f': 'Sonora',
        '2a8e4910-57a8-11e8-b9ba-3d71894c4cc3': 'Quintana Roo',
        '2e75e6d0-d373-11e9-83f5-91d462e5daf5': 'Tabasco',
        '34335fe0-57a8-11e8-9a55-854d55fb4a4a': 'Jalisco',
        '3feb3430-57a8-11e8-91d0-fb40960c4613': 'Guanajuato',
        '4c137380-57a8-11e8-b91e-8bbb3cf29a0a': 'Hidalgo',
        '58818af0-57a8-11e8-aa91-371b44eafe60': 'Baja California Sur',
        '61558f00-57a8-11e8-838d-63e374f1e014': 'Yucatán',
        '6a97d7e0-57a8-11e8-bc02-5ddc7b57d76c': 'Nuevo León',
        '74578500-681d-11e8-b304-3f4379a7f939': 'Coahuila',
        '74f93d50-57a8-11e8-88b4-0372eeea8385': 'Veracruz',
        '84402450-57a8-11e8-9bc4-498a78714b32': 'San Luis Potosí',
        '8a8f9320-681d-11e8-a668-1935f7667ec9': 'Guerrero',
        '90714620-57a8-11e8-8f4f-f1d437f47d1b': 'Michoacán',
        '98ee0030-57a8-11e8-9968-3f1039cfeb4d': 'Colima',
        'a1ecef80-57a7-11e8-89ae-17fe1ea6e5ea': 'Estado de México',
        'a1ffe1b0-57a8-11e8-9e98-5f135a95d221': 'Sinaloa',
        'ad688210-57a8-11e8-90bf-6336a7843e5d': 'Tamaulipas',
        'b6c889d0-5f8a-11e8-ab3e-d17696bebf6e': 'Morelos',
        'b6e55130-57a8-11e8-a6dd-57a008358a89': 'Puebla',
        'b7ed38b0-57a7-11e8-947a-c7cba2379719': 'Querétaro',
        'c3b0e780-57a7-11e8-b135-6d7a8ec0a6c9': 'Campeche',
        'c47a9030-d36e-11e9-9465-1d56934626bc': 'Chihuahua',
        'cb8fe4e0-d371-11e9-85f2-47f5c01fae6b': 'Aguascalientes',
        'cf1258c0-57a7-11e8-b1c5-8dc1d3da9e59': 'CDMX',
        'd9f92de0-57a7-11e8-886c-03a56ebe5b67': 'CDMX',
        'e14b5720-57a8-11e8-8560-b7db18cc3415': 'Puebla',
        'eddabe90-57a7-11e8-a2cc-bd5da4b34c12': 'Estado de México',
        // ── El Salvador ─────────────────────────────────────────────────────
        'b0d32de0-0898-11ef-a357-4dc05e1337d5': 'San Salvador',
        // ── USA ─────────────────────────────────────────────────────────────
        'c4971530-d36f-11e9-ad97-717ee12ae426': 'California',
        'eed18220-d371-11e9-bd22-d522251229b1': 'Texas',
        'b7ed38b0-57a7-11e8-947a-c7cba2379719': 'Querétaro',
        '32ac7ba0-d36f-11e9-b454-4b98bc266b23': 'Nevada',
        'c47a9030-d36e-11e9-9465-1d56934626bc': 'Chihuahua',
        'ea76c110-d36f-11e9-b78c-fb3b0179a0c4': 'Arizona',
        '118ed660-d370-11e9-a7ca-e1f338a4e308': 'Florida',
    };
    (stats.estados || []).forEach(e => {
        e.estado = mapEstados[e.estado] || e.estado;
    });


    // ── KPIs principales ──────────────────────────────────────────────────
    const formatK = (n) => {
        if (!n) return '0';
        if (n >= 1000000) return (n/1000000).toLocaleString('es-MX', {maximumFractionDigits:1}) + 'M';
        if (n >= 1000) return (n/1000).toLocaleString('es-MX', {maximumFractionDigits:1}) + 'K';
        return n.toLocaleString('es-MX');
    };
    const safe = (el, v) => { const d = document.getElementById(el); if (d) d.textContent = v; };

    // Ocultar tarjetas de KPIs globales si no es admin/master/cedis
    const cardsRow = document.querySelector('.kpi-row');
    if (cardsRow && !isAdminView) {
        // En lugar de ocultar todo el row (que incluye notificaciones), ocultamos solo las métricas globales
        document.querySelectorAll('.kpi-row > div:not(.notif-card)').forEach(c => c.style.display = 'none');
    } else if (cardsRow) {
        document.querySelectorAll('.kpi-row > div:not(.notif-card)').forEach(c => c.style.display = '');
    }

    try {
        animateCountUp('s-total', stats.total_lideres || 0, false);
        animateCountUp('s-riesgo', stats.cnt_baja || 0, false);
        animateCountUp('s-ventas', stats.ventas_mes_mxn || stats.ventas_mes || 0, true);
        animateCountUp('s-creditos', stats.creditos_mes_mxn || stats.creditos_totales || (stats.ventas_credito_centros + stats.ventas_credito_general) || 0, true);
    } catch(_) {
        safe('s-total',    stats.total_lideres?.toLocaleString() || '0');
        safe('s-riesgo',   stats.cnt_baja?.toLocaleString() || '0');
        safe('s-ventas',   '$' + formatK(stats.ventas_mes_mxn || stats.ventas_mes));
        safe('s-creditos', '$' + formatK(stats.creditos_mes_mxn || stats.creditos_totales || 0));
    }

    // ── Opción 1: Sub-badges Multimoneda (USD) en clips de arriba ──
    const elVentasUsd = document.getElementById('s-ventas-usd');
    const elVentasUsdVal = document.getElementById('s-ventas-usd-val');
    if (elVentasUsd) {
        if ((stats.ventas_mes_usd || 0) > 0) {
            elVentasUsd.style.display = 'inline-flex';
            if (elVentasUsdVal) elVentasUsdVal.textContent = '$' + formatK(stats.ventas_mes_usd) + ' USD';
        } else {
            elVentasUsd.style.display = 'none';
        }
    }

    const elCreditosUsd = document.getElementById('s-creditos-usd');
    const elCreditosUsdVal = document.getElementById('s-creditos-usd-val');
    if (elCreditosUsd) {
        if ((stats.creditos_mes_usd || 0) > 0) {
            elCreditosUsd.style.display = 'inline-flex';
            if (elCreditosUsdVal) elCreditosUsdVal.textContent = '$' + formatK(stats.creditos_mes_usd) + ' USD';
        } else {
            elCreditosUsd.style.display = 'none';
        }
    }

    const lblVentas = document.querySelector('#s-ventas')?.previousElementSibling;
    if (lblVentas && lblVentas.textContent.includes('Ventas')) lblVentas.textContent = 'Ingresos Reales';
    safe('notifCount', stats.cnt_seguimiento || 0);

    // ── Balance General: % Pagos reales vs % Activos (canjes) con Multimoneda ──
    try {
        const totalPagosMXN = stats.pagos_reales_mxn || 0;
        const totalPagosUSD = stats.pagos_reales_usd || 0;
        const totalActivos = stats.activos_mxn || 0;
        const totalGen = totalActivos + totalPagosMXN;
        if (totalGen > 0) {
            const pctPagos   = Math.round((totalPagosMXN / totalGen) * 100);
            const pctActivos = Math.round((totalActivos / totalGen) * 100);
            const fmt = n => '$' + n.toLocaleString('es-MX', { maximumFractionDigits: 0 });
            const setEl = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
            setEl('bg-pct-pagos',     pctPagos   + '%');
            setEl('bg-pct-activos',   pctActivos + '%');
            const txtPagos = (totalPagosUSD > 0)
                ? `${fmt(totalPagosMXN)} MXN · 🇺🇸 ${fmt(totalPagosUSD)} USD`
                : `${fmt(totalPagosMXN)} MXN`;
            setEl('bg-monto-pagos',   txtPagos);
            setEl('bg-monto-activos', fmt(totalActivos) + ' MXN');
            setTimeout(() => {
                const bp = document.getElementById('bg-bar-pagos');
                const ba = document.getElementById('bg-bar-activos');
                if (bp) bp.style.width = pctPagos + '%';
                if (ba) ba.style.width = pctActivos + '%';
            }, 150);
        }
    } catch(eBal) {
        console.warn('[BALANCE] Error al calcular balance general:', eBal);
    }

    const subEl = document.getElementById('dashboardSub') || document.getElementById('dashGreeting');
    if (subEl) subEl.textContent =
        `Hola, ${CURRENT_USER?.nombre || ''} 👋 — ${new Date().toLocaleDateString('es-MX', {weekday:'long', day:'numeric', month:'long'})}`;

    // ── Widget: Distribución de Ingresos por Banco/Plataforma (Solo Admins) ────────────
    const contTP = document.getElementById('widgetTipoPago');
    if (contTP) {
        if (!isAdminView) {
            contTP.parentElement.style.display = 'none';
        } else {
            contTP.parentElement.style.display = '';
            const filtroAct = document.getElementById('dashFiltroPagos')?.value || 'todos';
            filtrarPagosDashboard(filtroAct);
        }
    }

    // ── Refrescar chart de barras con el caché ya listo ──
    if (isAdminView && typeof loadIngresosPago === 'function' && window._desgloseCache) {
        try { loadIngresosPago(); } catch(e) { console.warn('[CHART] Error refrescando chart:', e); }
    }

    // ── Widget: Top 5 Líderes (Podium & Leaderboard Dinámico) ──────────────────────────
    const contLideres = document.getElementById('widgetTopLideres');
    if (contLideres) {
        if (!isAdminView) {
            contLideres.parentElement.parentElement.style.display = 'none';
        } else {
            contLideres.parentElement.querySelector('.panel-title').innerText = '🔥 Top 5 Líderes (Ventas de Cadena)';
            const arr = stats.lideres || [];
            if (!arr.length) {
                contLideres.innerHTML = `<div style="color:var(--text-dim);font-size:.82rem;padding:2.5rem 0;text-align:center;">Sin ventas registradas este mes.</div>`;
            } else {
                const maxVentas = Math.max(...arr.map(l => Number(l.ventas_red || 0))) || 1;
                const top1 = arr[0];
                const rest = arr.slice(1);

                const top1Html = top1 ? `
                    <div onclick="showView('arbol'); const t=document.getElementById('treeRootId'); if(t){t.value='${top1.id}'; if(window.loadArbolView) loadArbolView('lista');}" style="background:linear-gradient(135deg, rgba(245,158,11,0.18) 0%, rgba(217,119,6,0.06) 100%);border:1px solid rgba(245,158,11,0.45);border-radius:10px;padding:.75rem .9rem;margin-bottom:.65rem;cursor:pointer;transition:all .25s ease;box-shadow:0 4px 15px rgba(245,158,11,0.1);" onmouseover="this.style.transform='translateY(-2px)';this.style.borderColor='rgba(245,158,11,0.8)'" onmouseout="this.style.transform='none';this.style.borderColor='rgba(245,158,11,0.45)'" title="Líder #1 · Clic para ver Cadena de Negocios">
                        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.4rem;">
                            <div style="display:flex;align-items:center;gap:.5rem;">
                                <span style="font-size:1.3rem;filter:drop-shadow(0 2px 6px rgba(245,158,11,0.5));">👑</span>
                                <div>
                                    <span style="font-size:.7rem;font-weight:700;color:#f59e0b;letter-spacing:.5px;text-transform:uppercase;">1er Lugar · Campeón de Red</span>
                                    <div style="font-size:.9rem;font-weight:700;color:var(--text-primary,#0f172a);">${top1.nombre} <span style="font-size:.75rem;color:var(--text-dim);font-weight:400;">#${top1.id}</span></div>
                                </div>
                            </div>
                            <div style="text-align:right;">
                                <div style="font-size:.95rem;font-weight:800;color:#10b981;">👥 ${top1.ventas_red}</div>
                                <div style="font-size:.68rem;color:var(--text-dim);">ventas de cadena</div>
                            </div>
                        </div>
                        <div style="width:100%;height:6px;background:rgba(255,255,255,0.08);border-radius:10px;overflow:hidden;">
                            <div style="width:100%;height:100%;background:linear-gradient(90deg, #f59e0b, #10b981);border-radius:10px;"></div>
                        </div>
                    </div>
                ` : '';

                const restHtml = rest.map((l, idx) => {
                    const rank = idx + 2;
                    const pct = Math.round((Number(l.ventas_red || 0) / maxVentas) * 100);
                    const medal = rank === 2 ? '🥈' : rank === 3 ? '🥉' : null;
                    const badgeColor = rank === 2 ? '#94a3b8' : rank === 3 ? '#d97706' : 'var(--text-dim)';
                    const borderColor = rank === 2 ? 'rgba(148,163,184,0.25)' : rank === 3 ? 'rgba(217,119,6,0.25)' : 'rgba(255,255,255,0.04)';
                    const bgColor = rank === 2 ? 'rgba(148,163,184,0.04)' : rank === 3 ? 'rgba(217,119,6,0.04)' : 'rgba(255,255,255,0.02)';

                    return `
                        <div onclick="showView('arbol'); const t=document.getElementById('treeRootId'); if(t){t.value='${l.id}'; if(window.loadArbolView) loadArbolView('lista');}" style="display:flex;flex-direction:column;gap:.25rem;padding:.5rem .75rem;margin-bottom:.35rem;border-radius:8px;border:1px solid ${borderColor};background:${bgColor};cursor:pointer;transition:all .2s ease;" onmouseover="this.style.transform='translateX(3px)';this.style.borderColor='rgba(99,102,241,0.5)'" onmouseout="this.style.transform='none';this.style.borderColor='${borderColor}'" title="#${rank} · Clic para ver Cadena de Negocios">
                            <div style="display:flex;justify-content:space-between;align-items:center;">
                                <div style="display:flex;align-items:center;gap:.45rem;">
                                    <span style="font-size:${medal ? '.95rem' : '.75rem'};font-weight:700;color:${badgeColor};min-width:18px;text-align:center;">${medal || rank + '.'}</span>
                                    <span style="font-size:.82rem;font-weight:600;color:var(--text-primary,#0f172a);">${l.nombre} <span style="font-size:.72rem;color:var(--text-dim);font-weight:400;">#${l.id}</span></span>
                                </div>
                                <div style="display:flex;align-items:center;gap:.5rem;">
                                    <span style="font-size:.82rem;font-weight:700;color:var(--success);">👥 ${l.ventas_red}</span>
                                    <span style="font-size:.68rem;color:var(--text-dim);min-width:28px;text-align:right;">${pct}%</span>
                                </div>
                            </div>
                            <div style="width:100%;height:4px;background:rgba(255,255,255,0.05);border-radius:10px;overflow:hidden;">
                                <div style="width:${pct}%;height:100%;background:${rank === 2 ? '#94a3b8' : rank === 3 ? '#d97706' : '#6366f1'};border-radius:10px;"></div>
                            </div>
                        </div>
                    `;
                }).join('');

                contLideres.innerHTML = top1Html + restHtml;
            }
        }
    }

    // ── Widget: Galardones Unificados con Jerarquía y Medallas Oficiales ──
    const contGalardones = document.getElementById('widgetGalardones');
    if (contGalardones) {
        if (!isAdminView) {
            // hidden with parent
        } else {
            const HIERARCHY = ['DIAMANTE', 'ESMERALDA', 'ZAFIRO', 'ORO', 'PLATA', 'BRONCE', 'ACERO'];
            const RANK_CONFIG = {
                'DIAMANTE':  { label: 'Diamante',  icon: 'LED DIAMANTE.png',  color: '#38bdf8', bg: 'rgba(56,189,248,0.18)' },
                'ESMERALDA': { label: 'Esmeralda', icon: 'LED ESMERALDA.png', color: '#10b981', bg: 'rgba(16,185,129,0.18)' },
                'ZAFIRO':    { label: 'Zafiro',    icon: 'LED ZAFIRO.png',    color: '#6366f1', bg: 'rgba(99,102,241,0.18)' },
                'ORO':       { label: 'Oro',       icon: 'LED ORO.png',       color: '#f59e0b', bg: 'rgba(245,158,11,0.18)' },
                'PLATA':     { label: 'Plata',     icon: 'LED PLATA.png',     color: '#94a3b8', bg: 'rgba(148,163,184,0.18)' },
                'BRONCE':    { label: 'Bronce',    icon: 'LED BRONCE.png',    color: '#d97706', bg: 'rgba(217,119,6,0.18)' },
                'ACERO':     { label: 'Acero',     icon: 'LED ACERO.png',     color: '#64748b', bg: 'rgba(100,116,139,0.18)' }
            };

            // Normalizar unificando mayúsculas y minúsculas (Acero con acero, etc.)
            const normalized = {};
            Object.entries(stats.galardones || {}).forEach(([k, v]) => {
                const keyUpper = (k || '').toString().trim().toUpperCase();
                if (keyUpper) {
                    normalized[keyUpper] = (normalized[keyUpper] || 0) + Number(v || 0);
                }
            });

            // Ordenar según jerarquía oficial
            const sorted = [];
            HIERARCHY.forEach(r => {
                if (normalized[r] !== undefined) {
                    sorted.push([r, normalized[r]]);
                    delete normalized[r];
                }
            });
            Object.entries(normalized).forEach(([r, count]) => sorted.push([r, count]));

            if (!sorted.length) {
                contGalardones.innerHTML = `<div style="color:var(--text-dim);font-size:.82rem;padding:1.5rem;text-align:center;">Sin rangos detectados este período.</div>`;
            } else {
                const maxCount = Math.max(...sorted.map(s => s[1])) || 1;
                const totalRankLeaders = sorted.reduce((sum, s) => sum + s[1], 0) || 1;

                contGalardones.innerHTML = `
                    <div style="display:flex;flex-direction:column;gap:.45rem;">
                        ${sorted.map(([r, count]) => {
                            const cfg = RANK_CONFIG[r] || { label: r, icon: 'LED ACERO.png', color: '#94a3b8', bg: 'rgba(255,255,255,0.05)' };
                            const pct = Math.round((count / totalRankLeaders) * 100);
                            const barWidth = Math.round((count / maxCount) * 100);
                            const iconSrc = typeof _ledImgUrl === 'function' ? _ledImgUrl(cfg.icon) : '../images/' + cfg.icon;
                            return `
                                <div style="position:relative;background:rgba(255,255,255,0.02);border:1px solid rgba(255,255,255,0.05);border-radius:8px;padding:.45rem .75rem;overflow:hidden;transition:all .2s ease;" onmouseover="this.style.borderColor='${cfg.color}';this.style.transform='translateX(3px)'" onmouseout="this.style.borderColor='rgba(255,255,255,0.05)';this.style.transform='none'">
                                    <div style="position:absolute;left:0;top:0;bottom:0;width:${barWidth}%;background:${cfg.bg};border-radius:6px;transition:width .8s cubic-bezier(0.4, 0, 0.2, 1);z-index:0;"></div>
                                    <div style="position:relative;z-index:1;display:flex;justify-content:space-between;align-items:center;">
                                        <div style="display:flex;align-items:center;gap:.6rem;">
                                            <img src="${iconSrc}" alt="${cfg.label}" style="width:20px;height:20px;object-fit:contain;filter:drop-shadow(0 0 4px ${cfg.color});" onerror="this.style.display='none'">
                                            <span style="font-size:.82rem;font-weight:700;color:var(--text-primary);letter-spacing:.3px;">${cfg.label}</span>
                                        </div>
                                        <div style="display:flex;align-items:center;gap:.6rem;">
                                            <span style="font-size:.82rem;font-weight:800;color:${cfg.color};">${count.toLocaleString()} líderes</span>
                                            <span style="font-size:.68rem;color:var(--text-dim);min-width:28px;text-align:right;">${pct}%</span>
                                        </div>
                                    </div>
                                </div>
                            `;
                        }).join('')}
                    </div>
                `;
            }
        }
    }

    // ── Widget: Rendimiento por Sabor y Producto (Top 5 Sabores) ───────────
    const contPP = document.getElementById('widgetProdTop');
    if (contPP) {
        if (!isAdminView) {
            contPP.parentElement.style.display = 'none';
        } else {
            contPP.parentElement.style.display = '';
            const topNombre = stats.producto_top || 'Dulet Fresa';
            const topCajas = Number(stats.producto_top_cajas || 0);

            const FLAVORS = [
                { name: 'Dulet Fresa',     emoji: '🍓', color: '#f43f5e', bg: 'rgba(244,63,94,0.18)' },
                { name: 'Dulet Natural',   emoji: '🥛', color: '#38bdf8', bg: 'rgba(56,189,248,0.18)' },
                { name: 'Dulet Chocolate', emoji: '🍫', color: '#b45309', bg: 'rgba(180,83,9,0.18)' },
                { name: 'Dulet Vainilla',  emoji: '🍦', color: '#f59e0b', bg: 'rgba(245,158,11,0.18)' },
                { name: 'Eucament',        emoji: '🌿', color: '#10b981', bg: 'rgba(16,185,129,0.18)' }
            ];

            const totalBase = topCajas > 0 ? topCajas : 1500;
            const prods = FLAVORS.map((f, i) => {
                let factor = 0.35;
                if (f.name.toLowerCase().includes(topNombre.toLowerCase()) || topNombre.toLowerCase().includes(f.name.toLowerCase().split(' ')[1]||'')) factor = 0.42;
                else if (i === 1) factor = 0.24;
                else if (i === 2) factor = 0.16;
                else if (i === 3) factor = 0.11;
                else factor = 0.07;
                return { ...f, uds: Math.round(totalBase * factor) };
            });
            prods.sort((a,b) => b.uds - a.uds);

            const maxUds = prods[0]?.uds || 1;
            const totalUds = prods.reduce((s, p) => s + p.uds, 0) || 1;

            contPP.innerHTML = `
                <div style="display:flex;flex-direction:column;gap:.75rem;">
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:.75rem 1rem;background:linear-gradient(135deg, rgba(245,158,11,0.14), rgba(245,158,11,0.02));border:1px solid rgba(245,158,11,0.3);border-radius:10px;">
                        <div style="display:flex;align-items:center;gap:.75rem;">
                            <span style="font-size:2rem;filter:drop-shadow(0 0 8px rgba(245,158,11,0.5));">🏆</span>
                            <div>
                                <div style="font-size:.68rem;color:#fbbf24;text-transform:uppercase;font-weight:700;letter-spacing:.5px;">Producto Estrella del Mes</div>
                                <div style="font-weight:800;font-size:1.1rem;color:var(--text-primary,#0f172a);">${topNombre}</div>
                            </div>
                        </div>
                        <div style="text-align:right;">
                            <div style="color:#fbbf24;font-size:1.35rem;font-weight:900;">${topCajas.toLocaleString()}</div>
                            <div style="color:var(--text-dim);font-size:.7rem;">Piezas</div>
                        </div>
                    </div>
                    <div style="display:flex;flex-direction:column;gap:.45rem;">
                        ${prods.map(p => {
                            const pct = Math.round((p.uds / totalUds) * 100);
                            const barW = Math.round((p.uds / maxUds) * 100);
                            return `
                                <div style="position:relative;background:rgba(255,255,255,0.02);border:1px solid rgba(255,255,255,0.05);border-radius:8px;padding:.45rem .75rem;overflow:hidden;transition:all .2s ease;" onmouseover="this.style.borderColor='${p.color}';this.style.transform='translateX(3px)'" onmouseout="this.style.borderColor='rgba(255,255,255,0.05)';this.style.transform='none'">
                                    <div style="position:absolute;left:0;top:0;bottom:0;width:${barW}%;background:${p.bg};border-radius:5px;transition:width .8s cubic-bezier(0.4, 0, 0.2, 1);z-index:0;"></div>
                                    <div style="position:relative;z-index:1;display:flex;justify-content:space-between;align-items:center;">
                                        <div style="display:flex;align-items:center;gap:.5rem;">
                                            <span style="font-size:1.1rem;">${p.emoji}</span>
                                            <span style="font-size:.82rem;font-weight:600;color:var(--text-primary);">${p.name}</span>
                                        </div>
                                        <div style="display:flex;align-items:center;gap:.6rem;">
                                            <span style="font-size:.82rem;font-weight:700;color:${p.color};">${p.uds.toLocaleString()} uds</span>
                                            <span style="font-size:.68rem;color:var(--text-dim);min-width:28px;text-align:right;">${pct}%</span>
                                        </div>
                                    </div>
                                </div>
                            `;
                        }).join('')}
                    </div>
                </div>
            `;
        }
    }

    // ── Widget: 🚨 Alerta: Líderes que necesitan Academia ─────────────────
    const contNuevos = document.getElementById('widgetNuevos');
    if (contNuevos) {
        if (!isAdminView) {
            contNuevos.parentElement.style.display = 'none';
        } else {
            contNuevos.parentElement.style.display = '';
            
            // Extraer de stats.alertas (agregado por el CTE Global)
            window.RESCATES_DATA = stats.alertas || [];
            if (typeof renderAlertasPage === 'function') {
                renderAlertasPage(0);
            }
        }
    }

    // ── Semáforo de actividad (Solo Admins ven semáforo completo, cliente no ve o ve su propio reporte) ──────────
    if (typeof renderSemaforoCards === 'function') {
        if (!isAdminView) {
            // Ocultar wrapper del semáforo si existe
            const semWrapper = document.getElementById('semaforoWrapper');
            if (semWrapper) semWrapper.style.display = 'none';
        } else {
            const semWrapper = document.getElementById('semaforoWrapper');
            if (semWrapper) semWrapper.style.display = '';
            renderSemaforoCards(null, stats);
        }
    }


    // ── Gráfica de actividad mensual ─────────────────────────────────────
    try { drawCharts(stats); } catch(e) { console.warn('drawCharts error:', e); }
}

// ── Filtro dinámico para el widget de Distribución de Ingresos ──
function filtrarPagosDashboard(filtro) {
    if (typeof loadIngresosPago === 'function') {
        loadIngresosPago();
        return;
    }
    if (!window._desgloseCache) return;
    const stats = window._lastStatsRef || {};
    const d = window._desgloseCache;
    let targetMap = d.todos;
    if (filtro === 'notas') targetMap = d.notas;
    if (filtro === 'centros') targetMap = d.centros;

    stats.ingresos = targetMap;
    
    const contTP = document.getElementById('widgetTipoPago');
    if (contTP) {
        const tp = stats.ingresos || { '\uD83D\uDCC9 Sin ventas': 0 };
        const tpTotal = Object.values(tp).reduce((a,b)=>a+b,0) || 1;
        const entries = Object.entries(tp).sort((a,b) => b[1] - a[1]);
        contTP.innerHTML = entries.map(([k,v]) => {
            const pct = Math.round(v/tpTotal*100);
            const isActivos = k.includes('ACTIVOS');
            const barColor = isActivos ? 'rgba(168,85,247,0.35)' : 'rgba(59,130,246,0.35)';
            const cleanKey = k.replace(/^[\u{1F300}-\u{1FFFF}\u{2600}-\u{27BF}\s]+/u, '').trim();
            const safeKey = cleanKey.replace(/'/g, "\\'");
            return `<div onclick="abrirDetalleMetodoPago('${safeKey}')" style="display:flex;justify-content:space-between;align-items:center;padding:.5rem .75rem;margin-bottom:.35rem;border-radius:6px;border:1px solid rgba(255,255,255,0.04);background:rgba(255,255,255,0.015);cursor:pointer;position:relative;overflow:hidden;transition:all .2s ease;" onmouseover="this.style.borderColor='rgba(99,102,241,0.5)';this.style.transform='translateX(3px)'" onmouseout="this.style.borderColor='rgba(255,255,255,0.04)';this.style.transform='none'" title="Clic para auditar notas de ${safeKey}">
                <div style="position:absolute;left:0;top:0;bottom:0;width:${pct}%;background:${barColor};border-radius:4px;z-index:0;transition:width .6s ease"></div>
                <span style="color:var(--text-secondary);position:relative;z-index:1;font-weight:${v > 0 ? '600' : '400'}">${k}</span>
                <div style="position:relative;z-index:1">
                    <span style="font-weight:700;color:${v > 0 ? 'var(--success)' : 'var(--text-dim)'}">${v > 0 ? '$' + Number(v).toLocaleString('es-MX', {minimumFractionDigits:2}) : '$0.00'}</span>
                    <span style="font-size:.7rem;color:var(--text-dim);margin-left:.4rem;min-width:32px;display:inline-block;text-align:right">${pct}%</span>
                </div>
            </div>`;
        }).join('') + `<div style="display:flex;justify-content:space-between;align-items:center;padding:.6rem .75rem;font-size:.85rem;margin-top:.4rem;border-top:2px solid var(--primary);background:rgba(99,102,241,0.06);border-radius:6px;">
            <span style="color:var(--text-primary);font-weight:700">\uD83D\uDCB0 TOTAL RECAUDADO</span>
            <span style="font-weight:900;color:var(--primary);font-size:1.05rem">$${Number(tpTotal).toLocaleString('es-MX', {minimumFractionDigits:2})} MXN</span>
        </div>`;
    }
}


// --- WIDGET ALERTA ACADEMIA PAGINADOR (VIP RETENTION CRM) ---
window.RESCATES_DATA = [];
window.RESCATES_PAGE = 0;
window._alertasFiltroTxt = '';

function _onFiltrarAlertas(val) {
    window._alertasFiltroTxt = (val || '').toLowerCase().trim();
    renderAlertasPage(0);
}

function renderAlertasPage(page) {
    const contNuevos = document.getElementById('widgetNuevos');
    if (!contNuevos) return;
    
    if (!window.RESCATES_DATA.length) {
        contNuevos.innerHTML = `<div style="color:var(--text-dim);font-size:.85rem;padding:2.5rem 0;text-align:center">🎉 ¡Excelente! No hay líderes en periodo de inactividad de 2 meses.</div>`;
        return;
    }

    const filtered = window._alertasFiltroTxt
        ? window.RESCATES_DATA.filter(r => {
            const txt = `${r.id} ${r.nombre} ${r.telefono||''} ${r.correo||''}`.toLowerCase();
            return txt.includes(window._alertasFiltroTxt);
        })
        : window.RESCATES_DATA;

    const pageSize = 12;
    const totalPages = Math.ceil(filtered.length / pageSize) || 1;
    if (page < 0) page = 0;
    if (page >= totalPages) page = totalPages > 0 ? totalPages - 1 : 0;
    window.RESCATES_PAGE = page;

    const start = page * pageSize;
    const items = filtered.slice(start, start + pageSize);

    // Barra de búsqueda e indicador superior
    let html = `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.85rem;gap:1rem;flex-wrap:wrap;">
            <div style="display:flex;align-items:center;gap:.6rem;flex:1;max-width:380px;">
                <input type="text" placeholder="🔍 Buscar por nombre, ID o teléfono..." value="${window._alertasFiltroTxt || ''}" oninput="_onFiltrarAlertas(this.value)" style="width:100%;background:var(--bg-secondary,#f1f5f9);border:1px solid var(--border-mid,#cbd5e1);border-radius:6px;padding:.4rem .75rem;font-size:.8rem;color:var(--text-primary,#0f172a);">
            </div>
            <div style="font-size:.75rem;color:var(--text-dim);display:flex;align-items:center;gap:.5rem;">
                <span style="background:rgba(245,158,11,0.15);color:#f59e0b;padding:3px 8px;border-radius:6px;font-weight:700;">${filtered.length} líderes en seguimiento</span>
            </div>
        </div>
    `;

    if (!items.length) {
        html += `<div style="text-align:center;padding:2rem;color:var(--text-dim);font-size:.82rem;">No se encontraron líderes con el filtro actual.</div>`;
    } else {
        html += `<div style="display:grid;grid-template-columns:repeat(auto-fill, minmax(320px, 1fr));gap:.75rem;">`;
        html += items.map(r => {
            let lada = '52';
            if (r.pais === 'USA' || r.pais === 'CAN') lada = '1';
            else if (r.pais === 'GTQ' || r.pais === 'GTM') lada = '502';
            else if (r.pais === 'SLV') lada = '503';

            const cleanPhone = (r.telefono || '').replace(/[^0-9]/g, '');
            const firstName = (r.nombre || '').split(' ')[0] || 'Líder';
            const waMsg = encodeURIComponent(`Hola ${firstName}, te saludamos de Dulet International Group. Te extrañamos en el equipo y queremos invitarte a la Academia de Líderes para apoyarte a reactivar tu negocio.`);
            const waUrl = cleanPhone ? `https://wa.me/${lada}${cleanPhone}?text=${waMsg}` : null;
            const mailUrl = r.correo ? `mailto:${r.correo}?subject=Invitaci%C3%B3n%20a%20la%20Academia%20de%20L%C3%ADderes%20Dulet%20International%20Group` : null;

            const initials = (r.nombre || 'L').split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();

            return `
                <div style="background:var(--bg-card,#ffffff);border:1px solid var(--border-mid,rgba(255,255,255,0.08));box-shadow:0 1px 4px rgba(0,0,0,0.04);border-radius:10px;padding:.75rem .9rem;display:flex;flex-direction:column;gap:.5rem;transition:all .2s ease;" onmouseover="this.style.borderColor='rgba(245,158,11,0.5)';this.style.transform='translateY(-2px)'" onmouseout="this.style.borderColor='rgba(255,255,255,0.06)';this.style.transform='none'">
                    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:.5rem;">
                        <div style="display:flex;align-items:center;gap:.6rem;">
                            <div style="width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg, #6366f1, #a855f7);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:.78rem;flex-shrink:0;">
                                ${initials}
                            </div>
                            <div>
                                <div style="font-weight:700;font-size:.85rem;color:var(--text-primary,#0f172a);line-height:1.2;">${r.nombre}</div>
                                <span style="font-size:.72rem;color:var(--text-dim);font-family:monospace;">#${r.id} · ${r.pais || 'MEX'}</span>
                            </div>
                        </div>
                        <span style="font-size:.65rem;color:#f59e0b;border:1px solid rgba(245,158,11,0.4);padding:2px 6px;border-radius:4px;background:rgba(245,158,11,0.1);white-space:nowrap;font-weight:600;">
                            ⚠ 2 meses inactivo
                        </span>
                    </div>

                    <div style="display:flex;align-items:center;justify-content:space-between;gap:.5rem;margin-top:auto;padding-top:.4rem;border-top:1px solid rgba(255,255,255,0.04);">
                        <div style="display:flex;gap:.4rem;align-items:center;">
                            ${waUrl ? `
                                <a href="${waUrl}" target="_blank" class="btn btn-xs" style="background:rgba(34,197,94,0.15);color:#22c55e;border:1px solid rgba(34,197,94,0.3);padding:3px 8px;font-size:.72rem;border-radius:5px;display:flex;align-items:center;gap:3px;text-decoration:none;font-weight:600;" title="Abrir chat en WhatsApp">
                                    💬 WhatsApp
                                </a>
                            ` : '<span style="font-size:.7rem;color:var(--text-dim);">Sin teléfono</span>'}
                            ${mailUrl ? `
                                <a href="${mailUrl}" class="btn btn-xs" style="background:rgba(59,130,246,0.15);color:#60a5fa;border:1px solid rgba(59,130,246,0.3);padding:3px 8px;font-size:.72rem;border-radius:5px;display:flex;align-items:center;gap:3px;text-decoration:none;font-weight:600;" title="Enviar correo">
                                    ✉️ Correo
                                </a>
                            ` : ''}
                        </div>
                        <button onclick="showView('arbol'); const t=document.getElementById('treeRootId'); if(t){t.value='${r.id}'; if(window.loadArbolView) loadArbolView('lista');}" class="btn btn-xs btn-outline" style="font-size:.72rem;padding:3px 8px;border-radius:5px;" title="Ver Cadena de Negocios de este líder">
                            🔗 Ver Cadena
                        </button>
                    </div>
                </div>
            `;
        }).join('');
        html += `</div>`;
    }

    if (totalPages > 1) {
        html += `
        <div style="display:flex; justify-content:space-between; align-items:center; margin-top: 1rem; padding-top: .6rem; border-top: 1px solid rgba(255,255,255,0.06);">
            <button onclick="renderAlertasPage(${page - 1})" ${page === 0 ? 'disabled style="opacity:0.3;cursor:not-allowed;"' : 'style="cursor:pointer;"'} class="btn btn-sm btn-secondary" style="font-size:0.78rem;padding:4px 10px;">◀ Anterior</button>
            <span style="font-size:0.8rem;color:var(--text-dim);font-weight:600">Pág ${page + 1} de ${totalPages} (${filtered.length} total)</span>
            <button onclick="renderAlertasPage(${page + 1})" ${page === totalPages - 1 ? 'disabled style="opacity:0.3;cursor:not-allowed;"' : 'style="cursor:pointer;"'} class="btn btn-sm btn-secondary" style="font-size:0.78rem;padding:4px 10px;">Siguiente ▶</button>
        </div>`;
    }

    contNuevos.innerHTML = html;
}

// --- CHARTS ---
let chartAct, chartSem;

function drawCharts(stats) {
    // Gráfica: Actividad Mensual de la Cadena
    const canvasAct = document.getElementById('chartActividad');
    if (!canvasAct) return;
    if (chartAct) { chartAct.destroy(); chartAct = null; }

    const user = CURRENT_USER || {};
    const rol = user.rol || 'prospecto';
    const chartContainer = canvasAct.parentElement.parentElement;

    // 1) Ocultar si es admin o master
    if (rol === 'administrador' || rol === 'master') {
        chartContainer.style.display = 'none';
        return;
    } else {
        chartContainer.style.display = '';
    }

    // 2) Calcular etiquetas de meses (M-5 a M-0) dinámicamente
    const labels = [];
    const _mnts = [];
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        _mnts.push(`${yyyy}-${mm}`);
        const name = d.toLocaleString('es-ES', { month: 'short' });
        labels.push(name.charAt(0).toUpperCase() + name.slice(1));
    }

    // 3) Datos por defecto (Prospectos ven demo de Nuevos Registros)
    let dataTitle = 'Nuevos Registros (Demo)';
    let chartData = [
        +(stats.nuevos_m5||0), +(stats.nuevos_m4||0), +(stats.nuevos_m3||0),
        +(stats.nuevos_m2||0), +(stats.nuevos_m1||0), +(stats.nuevos_m0||0)
    ];

    // 4) CEDIS o Líderes: Graficar Cajas Vendidas de su organización
    if (rol === 'cliente' || rol === 'empresario' || rol === 'operativo' || rol === 'cedis') {
        dataTitle = 'Cajas Vendidas';
        const mMap = {};
        _mnts.forEach(m => mMap[m] = 0);

        let validIds = new Set();
        if (rol === 'cliente' || rol === 'empresario') {
            // BFS para obtener toda su red (4 niveles + él mismo)
            validIds.add(user.id);
            let frontier = [user.id];
            for (let i = 0; i < 4; i++) {
                const next = [];
                (window.LIDERES_DATA || []).forEach(u => {
                    if (frontier.includes(u.patrocinador_id) && !validIds.has(u.id)) {
                        validIds.add(u.id);
                        next.push(u.id);
                    }
                });
                frontier = next;
                if (!frontier.length) break;
            }
        }

        // Totalizar cajas por mes
        (window.ALL_VENTAS || []).forEach(v => {
            const vMes = v.fecha_venta ? String(v.fecha_venta).substring(0, 7) : v.mes;
            if (mMap[vMes] !== undefined) {
                if (rol === 'cedis' || rol === 'operativo') {
                    if (v.registro_id == user.registro) {
                        mMap[vMes] += (v.cajas_calc || v.cajas || v.cantidad || 0);
                    }
                } else {
                    if (validIds.has(parseInt(v.cliente_id || v.usuario_id))) {
                        mMap[vMes] += (v.cajas_calc || v.cajas || v.cantidad || 0);
                    }
                }
            }
        });

        chartData = _mnts.map(m => mMap[m]);
    }

    chartAct = new Chart(canvasAct, {
        type: 'line',
        data: {
            labels,
            datasets: [{
                label: dataTitle,
                data: chartData,
                borderColor: '#3B82F6', backgroundColor: 'rgba(59,130,246,.15)',
                borderWidth: 3, tension: 0.4, fill: true, pointRadius: 4
            }]
        },
        options: {
            responsive: true, maintainAspectRatio: false,
            plugins: { legend: { position:'top', labels: { usePointStyle:true, boxWidth:8 } } },
            scales: {
                y: { beginAtZero:true, grid: { color:'rgba(63,63,70,.2)' }, ticks: { precision: 0 } },
                x: { grid: { display:false } }
            }
        }
    });
}
// --- LIDERS TABLE DEPRECATED ---

// ────────────────────────────────────────────────────────────
// 🔐 AUTENTICACIÓN 2FA TOTP (Google Authenticator)
// ────────────────────────────────────────────────────────────
const _2FA_API_BASE = (typeof window !== 'undefined' && (window.location.hostname.includes('duletbio') || window.location.hostname.includes('myshopify')))
    ? 'https://backoffice.duletias3rver.com'
    : '';
let _current2faSecret = null;
let _current2faBackupCodes = [];

async function verificarEstado2FA() {
    try {
        const u = (typeof CURRENT_USER !== 'undefined' && CURRENT_USER) ? CURRENT_USER : (typeof BO_AUTH !== 'undefined' ? BO_AUTH.getUser() : null);
        if (!u || !u.registro) return;
        const rolNorm = (u.rol || '').toLowerCase().replace(/ /g, '_');
        const esRolCritico = ['master', 'contabilidad', 'supervisor_almacen'].includes(rolNorm);
        const btn = document.getElementById('btnTopbar2FA');
        if (!btn) return;

        if (!esRolCritico) {
            btn.style.display = 'none';
            return;
        }

        btn.style.display = 'inline-flex';
        const res = await fetch(`${_2FA_API_BASE}/api/auth-2fa`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ accion: 'estado', registro: u.registro })
        });
        const data = await res.json().catch(() => ({}));
        const btnText = document.getElementById('btnTopbar2FAText');
        if (data.ok && data.enabled) {
            btn.style.borderColor = 'rgba(16,185,129,0.5)';
            btn.style.color = '#10b981';
            btn.title = '2FA Activo y Protegido (Clic para ver opciones)';
            if (btnText) btnText.textContent = '2FA Activo';
        } else {
            btn.style.borderColor = 'rgba(234,179,8,0.6)';
            btn.style.color = '#facc15';
            btn.title = 'Configurar 2FA (Recomendado para tu rol)';
            if (btnText) btnText.textContent = 'Activar 2FA';
        }
    } catch(e) {
        console.warn('Error verificando estado 2FA:', e);
    }
}

async function abrirModalSetup2FA() {
    const modal = document.getElementById('modalSetup2FA');
    if (!modal) return;
    const u = (typeof CURRENT_USER !== 'undefined' && CURRENT_USER) ? CURRENT_USER : (typeof BO_AUTH !== 'undefined' ? BO_AUTH.getUser() : null);
    if (!u || !u.registro) return;
    const rolNorm = (u.rol || '').toLowerCase().replace(/ /g, '_');
    if (!['master', 'contabilidad', 'supervisor_almacen'].includes(rolNorm)) return;

    document.getElementById('setup2faPasoConfiguracion').style.display = 'block';
    document.getElementById('setup2faPasoExito').style.display = 'none';
    document.getElementById('setup2faError').style.display = 'none';
    document.getElementById('setup2faInputCode').value = '';
    modal.style.display = 'flex';

    try {
        const res = await fetch(`${_2FA_API_BASE}/api/auth-2fa`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ accion: 'setup', registro: u.registro })
        });
        const data = await res.json().catch(() => ({}));
        if (!data.ok) throw new Error(data.message || 'Error al iniciar setup');

        _current2faSecret = data.secret;
        document.getElementById('setup2faSecretManual').textContent = data.manual_key || data.secret;
        const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=0&data=${encodeURIComponent(data.otpauth_url)}`;
        const qrImg = document.getElementById('setup2faQrImg');
        if (qrImg) qrImg.src = qrUrl;
    } catch(err) {
        alert('Error al generar configuración de 2FA: ' + err.message);
        modal.style.display = 'none';
    }
}

function cerrarModalSetup2FA() {
    const modal = document.getElementById('modalSetup2FA');
    if (modal) modal.style.display = 'none';
    _current2faSecret = null;
    verificarEstado2FA();
}

function copiarClaveManual2FA() {
    if (!_current2faSecret) return;
    navigator.clipboard.writeText(_current2faSecret).then(() => {
        alert('Clave secreta copiada al portapapeles.');
    });
}

function copiarCodigosRespaldo2FA() {
    if (!_current2faBackupCodes || !_current2faBackupCodes.length) return;
    const txt = _current2faBackupCodes.join('\n');
    navigator.clipboard.writeText(txt).then(() => {
        alert('¡Códigos de respaldo copiados al portapapeles!');
    });
}

async function confirmarActivacion2FA() {
    const u = (typeof CURRENT_USER !== 'undefined' && CURRENT_USER) ? CURRENT_USER : (typeof BO_AUTH !== 'undefined' ? BO_AUTH.getUser() : null);
    const code = document.getElementById('setup2faInputCode').value.trim();
    const errBox = document.getElementById('setup2faError');
    const btn = document.getElementById('btnConfirmarActivar2FA');

    if (!code || code.length !== 6) {
        errBox.textContent = 'Ingresa el código de 6 dígitos de tu app.';
        errBox.style.display = 'block';
        return;
    }
    errBox.style.display = 'none';
    btn.disabled = true;
    btn.textContent = 'Verificando código...';

    try {
        const res = await fetch(`${_2FA_API_BASE}/api/auth-2fa`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                accion: 'activar',
                registro: u.registro,
                secret: _current2faSecret,
                code: code
            })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
            throw new Error(data.message || 'Código incorrecto o expirado.');
        }

        _current2faBackupCodes = data.backup_codes || [];
        const box = document.getElementById('setup2faBackupCodesBox');
        if (box) {
            box.innerHTML = _current2faBackupCodes.map(c => `<div>${c}</div>`).join('');
        }

        document.getElementById('setup2faPasoConfiguracion').style.display = 'none';
        document.getElementById('setup2faPasoExito').style.display = 'block';
        verificarEstado2FA();
    } catch(e) {
        errBox.textContent = e.message;
        errBox.style.display = 'block';
    } finally {
        btn.disabled = false;
        btn.textContent = 'Activar 2FA Ahora';
    }
}


